/******/ (function(modules) { // webpackBootstrap
/******/ 	function hotDisposeChunk(chunkId) {
/******/ 		delete installedChunks[chunkId];
/******/ 	}
/******/ 	var parentHotUpdateCallback = this["webpackHotUpdate"];
/******/ 	this["webpackHotUpdate"] = 
/******/ 	function webpackHotUpdateCallback(chunkId, moreModules) { // eslint-disable-line no-unused-vars
/******/ 		hotAddUpdateChunk(chunkId, moreModules);
/******/ 		if(parentHotUpdateCallback) parentHotUpdateCallback(chunkId, moreModules);
/******/ 	} ;
/******/ 	
/******/ 	function hotDownloadUpdateChunk(chunkId) { // eslint-disable-line no-unused-vars
/******/ 		var head = document.getElementsByTagName("head")[0];
/******/ 		var script = document.createElement("script");
/******/ 		script.type = "text/javascript";
/******/ 		script.charset = "utf-8";
/******/ 		script.src = __webpack_require__.p + "" + chunkId + "." + hotCurrentHash + ".hot-update.js";
/******/ 		;
/******/ 		head.appendChild(script);
/******/ 	}
/******/ 	
/******/ 	function hotDownloadManifest(requestTimeout) { // eslint-disable-line no-unused-vars
/******/ 		requestTimeout = requestTimeout || 10000;
/******/ 		return new Promise(function(resolve, reject) {
/******/ 			if(typeof XMLHttpRequest === "undefined")
/******/ 				return reject(new Error("No browser support"));
/******/ 			try {
/******/ 				var request = new XMLHttpRequest();
/******/ 				var requestPath = __webpack_require__.p + "" + hotCurrentHash + ".hot-update.json";
/******/ 				request.open("GET", requestPath, true);
/******/ 				request.timeout = requestTimeout;
/******/ 				request.send(null);
/******/ 			} catch(err) {
/******/ 				return reject(err);
/******/ 			}
/******/ 			request.onreadystatechange = function() {
/******/ 				if(request.readyState !== 4) return;
/******/ 				if(request.status === 0) {
/******/ 					// timeout
/******/ 					reject(new Error("Manifest request to " + requestPath + " timed out."));
/******/ 				} else if(request.status === 404) {
/******/ 					// no update available
/******/ 					resolve();
/******/ 				} else if(request.status !== 200 && request.status !== 304) {
/******/ 					// other failure
/******/ 					reject(new Error("Manifest request to " + requestPath + " failed."));
/******/ 				} else {
/******/ 					// success
/******/ 					try {
/******/ 						var update = JSON.parse(request.responseText);
/******/ 					} catch(e) {
/******/ 						reject(e);
/******/ 						return;
/******/ 					}
/******/ 					resolve(update);
/******/ 				}
/******/ 			};
/******/ 		});
/******/ 	}
/******/
/******/ 	
/******/ 	
/******/ 	var hotApplyOnUpdate = true;
/******/ 	var hotCurrentHash = "0d1a4b48bbe81fce665d"; // eslint-disable-line no-unused-vars
/******/ 	var hotRequestTimeout = 10000;
/******/ 	var hotCurrentModuleData = {};
/******/ 	var hotCurrentChildModule; // eslint-disable-line no-unused-vars
/******/ 	var hotCurrentParents = []; // eslint-disable-line no-unused-vars
/******/ 	var hotCurrentParentsTemp = []; // eslint-disable-line no-unused-vars
/******/ 	
/******/ 	function hotCreateRequire(moduleId) { // eslint-disable-line no-unused-vars
/******/ 		var me = installedModules[moduleId];
/******/ 		if(!me) return __webpack_require__;
/******/ 		var fn = function(request) {
/******/ 			if(me.hot.active) {
/******/ 				if(installedModules[request]) {
/******/ 					if(installedModules[request].parents.indexOf(moduleId) < 0)
/******/ 						installedModules[request].parents.push(moduleId);
/******/ 				} else {
/******/ 					hotCurrentParents = [moduleId];
/******/ 					hotCurrentChildModule = request;
/******/ 				}
/******/ 				if(me.children.indexOf(request) < 0)
/******/ 					me.children.push(request);
/******/ 			} else {
/******/ 				console.warn("[HMR] unexpected require(" + request + ") from disposed module " + moduleId);
/******/ 				hotCurrentParents = [];
/******/ 			}
/******/ 			return __webpack_require__(request);
/******/ 		};
/******/ 		var ObjectFactory = function ObjectFactory(name) {
/******/ 			return {
/******/ 				configurable: true,
/******/ 				enumerable: true,
/******/ 				get: function() {
/******/ 					return __webpack_require__[name];
/******/ 				},
/******/ 				set: function(value) {
/******/ 					__webpack_require__[name] = value;
/******/ 				}
/******/ 			};
/******/ 		};
/******/ 		for(var name in __webpack_require__) {
/******/ 			if(Object.prototype.hasOwnProperty.call(__webpack_require__, name) && name !== "e") {
/******/ 				Object.defineProperty(fn, name, ObjectFactory(name));
/******/ 			}
/******/ 		}
/******/ 		fn.e = function(chunkId) {
/******/ 			if(hotStatus === "ready")
/******/ 				hotSetStatus("prepare");
/******/ 			hotChunksLoading++;
/******/ 			return __webpack_require__.e(chunkId).then(finishChunkLoading, function(err) {
/******/ 				finishChunkLoading();
/******/ 				throw err;
/******/ 			});
/******/ 	
/******/ 			function finishChunkLoading() {
/******/ 				hotChunksLoading--;
/******/ 				if(hotStatus === "prepare") {
/******/ 					if(!hotWaitingFilesMap[chunkId]) {
/******/ 						hotEnsureUpdateChunk(chunkId);
/******/ 					}
/******/ 					if(hotChunksLoading === 0 && hotWaitingFiles === 0) {
/******/ 						hotUpdateDownloaded();
/******/ 					}
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 		return fn;
/******/ 	}
/******/ 	
/******/ 	function hotCreateModule(moduleId) { // eslint-disable-line no-unused-vars
/******/ 		var hot = {
/******/ 			// private stuff
/******/ 			_acceptedDependencies: {},
/******/ 			_declinedDependencies: {},
/******/ 			_selfAccepted: false,
/******/ 			_selfDeclined: false,
/******/ 			_disposeHandlers: [],
/******/ 			_main: hotCurrentChildModule !== moduleId,
/******/ 	
/******/ 			// Module API
/******/ 			active: true,
/******/ 			accept: function(dep, callback) {
/******/ 				if(typeof dep === "undefined")
/******/ 					hot._selfAccepted = true;
/******/ 				else if(typeof dep === "function")
/******/ 					hot._selfAccepted = dep;
/******/ 				else if(typeof dep === "object")
/******/ 					for(var i = 0; i < dep.length; i++)
/******/ 						hot._acceptedDependencies[dep[i]] = callback || function() {};
/******/ 				else
/******/ 					hot._acceptedDependencies[dep] = callback || function() {};
/******/ 			},
/******/ 			decline: function(dep) {
/******/ 				if(typeof dep === "undefined")
/******/ 					hot._selfDeclined = true;
/******/ 				else if(typeof dep === "object")
/******/ 					for(var i = 0; i < dep.length; i++)
/******/ 						hot._declinedDependencies[dep[i]] = true;
/******/ 				else
/******/ 					hot._declinedDependencies[dep] = true;
/******/ 			},
/******/ 			dispose: function(callback) {
/******/ 				hot._disposeHandlers.push(callback);
/******/ 			},
/******/ 			addDisposeHandler: function(callback) {
/******/ 				hot._disposeHandlers.push(callback);
/******/ 			},
/******/ 			removeDisposeHandler: function(callback) {
/******/ 				var idx = hot._disposeHandlers.indexOf(callback);
/******/ 				if(idx >= 0) hot._disposeHandlers.splice(idx, 1);
/******/ 			},
/******/ 	
/******/ 			// Management API
/******/ 			check: hotCheck,
/******/ 			apply: hotApply,
/******/ 			status: function(l) {
/******/ 				if(!l) return hotStatus;
/******/ 				hotStatusHandlers.push(l);
/******/ 			},
/******/ 			addStatusHandler: function(l) {
/******/ 				hotStatusHandlers.push(l);
/******/ 			},
/******/ 			removeStatusHandler: function(l) {
/******/ 				var idx = hotStatusHandlers.indexOf(l);
/******/ 				if(idx >= 0) hotStatusHandlers.splice(idx, 1);
/******/ 			},
/******/ 	
/******/ 			//inherit from previous dispose call
/******/ 			data: hotCurrentModuleData[moduleId]
/******/ 		};
/******/ 		hotCurrentChildModule = undefined;
/******/ 		return hot;
/******/ 	}
/******/ 	
/******/ 	var hotStatusHandlers = [];
/******/ 	var hotStatus = "idle";
/******/ 	
/******/ 	function hotSetStatus(newStatus) {
/******/ 		hotStatus = newStatus;
/******/ 		for(var i = 0; i < hotStatusHandlers.length; i++)
/******/ 			hotStatusHandlers[i].call(null, newStatus);
/******/ 	}
/******/ 	
/******/ 	// while downloading
/******/ 	var hotWaitingFiles = 0;
/******/ 	var hotChunksLoading = 0;
/******/ 	var hotWaitingFilesMap = {};
/******/ 	var hotRequestedFilesMap = {};
/******/ 	var hotAvailableFilesMap = {};
/******/ 	var hotDeferred;
/******/ 	
/******/ 	// The update info
/******/ 	var hotUpdate, hotUpdateNewHash;
/******/ 	
/******/ 	function toModuleId(id) {
/******/ 		var isNumber = (+id) + "" === id;
/******/ 		return isNumber ? +id : id;
/******/ 	}
/******/ 	
/******/ 	function hotCheck(apply) {
/******/ 		if(hotStatus !== "idle") throw new Error("check() is only allowed in idle status");
/******/ 		hotApplyOnUpdate = apply;
/******/ 		hotSetStatus("check");
/******/ 		return hotDownloadManifest(hotRequestTimeout).then(function(update) {
/******/ 			if(!update) {
/******/ 				hotSetStatus("idle");
/******/ 				return null;
/******/ 			}
/******/ 			hotRequestedFilesMap = {};
/******/ 			hotWaitingFilesMap = {};
/******/ 			hotAvailableFilesMap = update.c;
/******/ 			hotUpdateNewHash = update.h;
/******/ 	
/******/ 			hotSetStatus("prepare");
/******/ 			var promise = new Promise(function(resolve, reject) {
/******/ 				hotDeferred = {
/******/ 					resolve: resolve,
/******/ 					reject: reject
/******/ 				};
/******/ 			});
/******/ 			hotUpdate = {};
/******/ 			var chunkId = 0;
/******/ 			{ // eslint-disable-line no-lone-blocks
/******/ 				/*globals chunkId */
/******/ 				hotEnsureUpdateChunk(chunkId);
/******/ 			}
/******/ 			if(hotStatus === "prepare" && hotChunksLoading === 0 && hotWaitingFiles === 0) {
/******/ 				hotUpdateDownloaded();
/******/ 			}
/******/ 			return promise;
/******/ 		});
/******/ 	}
/******/ 	
/******/ 	function hotAddUpdateChunk(chunkId, moreModules) { // eslint-disable-line no-unused-vars
/******/ 		if(!hotAvailableFilesMap[chunkId] || !hotRequestedFilesMap[chunkId])
/******/ 			return;
/******/ 		hotRequestedFilesMap[chunkId] = false;
/******/ 		for(var moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				hotUpdate[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(--hotWaitingFiles === 0 && hotChunksLoading === 0) {
/******/ 			hotUpdateDownloaded();
/******/ 		}
/******/ 	}
/******/ 	
/******/ 	function hotEnsureUpdateChunk(chunkId) {
/******/ 		if(!hotAvailableFilesMap[chunkId]) {
/******/ 			hotWaitingFilesMap[chunkId] = true;
/******/ 		} else {
/******/ 			hotRequestedFilesMap[chunkId] = true;
/******/ 			hotWaitingFiles++;
/******/ 			hotDownloadUpdateChunk(chunkId);
/******/ 		}
/******/ 	}
/******/ 	
/******/ 	function hotUpdateDownloaded() {
/******/ 		hotSetStatus("ready");
/******/ 		var deferred = hotDeferred;
/******/ 		hotDeferred = null;
/******/ 		if(!deferred) return;
/******/ 		if(hotApplyOnUpdate) {
/******/ 			// Wrap deferred object in Promise to mark it as a well-handled Promise to
/******/ 			// avoid triggering uncaught exception warning in Chrome.
/******/ 			// See https://bugs.chromium.org/p/chromium/issues/detail?id=465666
/******/ 			Promise.resolve().then(function() {
/******/ 				return hotApply(hotApplyOnUpdate);
/******/ 			}).then(
/******/ 				function(result) {
/******/ 					deferred.resolve(result);
/******/ 				},
/******/ 				function(err) {
/******/ 					deferred.reject(err);
/******/ 				}
/******/ 			);
/******/ 		} else {
/******/ 			var outdatedModules = [];
/******/ 			for(var id in hotUpdate) {
/******/ 				if(Object.prototype.hasOwnProperty.call(hotUpdate, id)) {
/******/ 					outdatedModules.push(toModuleId(id));
/******/ 				}
/******/ 			}
/******/ 			deferred.resolve(outdatedModules);
/******/ 		}
/******/ 	}
/******/ 	
/******/ 	function hotApply(options) {
/******/ 		if(hotStatus !== "ready") throw new Error("apply() is only allowed in ready status");
/******/ 		options = options || {};
/******/ 	
/******/ 		var cb;
/******/ 		var i;
/******/ 		var j;
/******/ 		var module;
/******/ 		var moduleId;
/******/ 	
/******/ 		function getAffectedStuff(updateModuleId) {
/******/ 			var outdatedModules = [updateModuleId];
/******/ 			var outdatedDependencies = {};
/******/ 	
/******/ 			var queue = outdatedModules.slice().map(function(id) {
/******/ 				return {
/******/ 					chain: [id],
/******/ 					id: id
/******/ 				};
/******/ 			});
/******/ 			while(queue.length > 0) {
/******/ 				var queueItem = queue.pop();
/******/ 				var moduleId = queueItem.id;
/******/ 				var chain = queueItem.chain;
/******/ 				module = installedModules[moduleId];
/******/ 				if(!module || module.hot._selfAccepted)
/******/ 					continue;
/******/ 				if(module.hot._selfDeclined) {
/******/ 					return {
/******/ 						type: "self-declined",
/******/ 						chain: chain,
/******/ 						moduleId: moduleId
/******/ 					};
/******/ 				}
/******/ 				if(module.hot._main) {
/******/ 					return {
/******/ 						type: "unaccepted",
/******/ 						chain: chain,
/******/ 						moduleId: moduleId
/******/ 					};
/******/ 				}
/******/ 				for(var i = 0; i < module.parents.length; i++) {
/******/ 					var parentId = module.parents[i];
/******/ 					var parent = installedModules[parentId];
/******/ 					if(!parent) continue;
/******/ 					if(parent.hot._declinedDependencies[moduleId]) {
/******/ 						return {
/******/ 							type: "declined",
/******/ 							chain: chain.concat([parentId]),
/******/ 							moduleId: moduleId,
/******/ 							parentId: parentId
/******/ 						};
/******/ 					}
/******/ 					if(outdatedModules.indexOf(parentId) >= 0) continue;
/******/ 					if(parent.hot._acceptedDependencies[moduleId]) {
/******/ 						if(!outdatedDependencies[parentId])
/******/ 							outdatedDependencies[parentId] = [];
/******/ 						addAllToSet(outdatedDependencies[parentId], [moduleId]);
/******/ 						continue;
/******/ 					}
/******/ 					delete outdatedDependencies[parentId];
/******/ 					outdatedModules.push(parentId);
/******/ 					queue.push({
/******/ 						chain: chain.concat([parentId]),
/******/ 						id: parentId
/******/ 					});
/******/ 				}
/******/ 			}
/******/ 	
/******/ 			return {
/******/ 				type: "accepted",
/******/ 				moduleId: updateModuleId,
/******/ 				outdatedModules: outdatedModules,
/******/ 				outdatedDependencies: outdatedDependencies
/******/ 			};
/******/ 		}
/******/ 	
/******/ 		function addAllToSet(a, b) {
/******/ 			for(var i = 0; i < b.length; i++) {
/******/ 				var item = b[i];
/******/ 				if(a.indexOf(item) < 0)
/******/ 					a.push(item);
/******/ 			}
/******/ 		}
/******/ 	
/******/ 		// at begin all updates modules are outdated
/******/ 		// the "outdated" status can propagate to parents if they don't accept the children
/******/ 		var outdatedDependencies = {};
/******/ 		var outdatedModules = [];
/******/ 		var appliedUpdate = {};
/******/ 	
/******/ 		var warnUnexpectedRequire = function warnUnexpectedRequire() {
/******/ 			console.warn("[HMR] unexpected require(" + result.moduleId + ") to disposed module");
/******/ 		};
/******/ 	
/******/ 		for(var id in hotUpdate) {
/******/ 			if(Object.prototype.hasOwnProperty.call(hotUpdate, id)) {
/******/ 				moduleId = toModuleId(id);
/******/ 				var result;
/******/ 				if(hotUpdate[id]) {
/******/ 					result = getAffectedStuff(moduleId);
/******/ 				} else {
/******/ 					result = {
/******/ 						type: "disposed",
/******/ 						moduleId: id
/******/ 					};
/******/ 				}
/******/ 				var abortError = false;
/******/ 				var doApply = false;
/******/ 				var doDispose = false;
/******/ 				var chainInfo = "";
/******/ 				if(result.chain) {
/******/ 					chainInfo = "\nUpdate propagation: " + result.chain.join(" -> ");
/******/ 				}
/******/ 				switch(result.type) {
/******/ 					case "self-declined":
/******/ 						if(options.onDeclined)
/******/ 							options.onDeclined(result);
/******/ 						if(!options.ignoreDeclined)
/******/ 							abortError = new Error("Aborted because of self decline: " + result.moduleId + chainInfo);
/******/ 						break;
/******/ 					case "declined":
/******/ 						if(options.onDeclined)
/******/ 							options.onDeclined(result);
/******/ 						if(!options.ignoreDeclined)
/******/ 							abortError = new Error("Aborted because of declined dependency: " + result.moduleId + " in " + result.parentId + chainInfo);
/******/ 						break;
/******/ 					case "unaccepted":
/******/ 						if(options.onUnaccepted)
/******/ 							options.onUnaccepted(result);
/******/ 						if(!options.ignoreUnaccepted)
/******/ 							abortError = new Error("Aborted because " + moduleId + " is not accepted" + chainInfo);
/******/ 						break;
/******/ 					case "accepted":
/******/ 						if(options.onAccepted)
/******/ 							options.onAccepted(result);
/******/ 						doApply = true;
/******/ 						break;
/******/ 					case "disposed":
/******/ 						if(options.onDisposed)
/******/ 							options.onDisposed(result);
/******/ 						doDispose = true;
/******/ 						break;
/******/ 					default:
/******/ 						throw new Error("Unexception type " + result.type);
/******/ 				}
/******/ 				if(abortError) {
/******/ 					hotSetStatus("abort");
/******/ 					return Promise.reject(abortError);
/******/ 				}
/******/ 				if(doApply) {
/******/ 					appliedUpdate[moduleId] = hotUpdate[moduleId];
/******/ 					addAllToSet(outdatedModules, result.outdatedModules);
/******/ 					for(moduleId in result.outdatedDependencies) {
/******/ 						if(Object.prototype.hasOwnProperty.call(result.outdatedDependencies, moduleId)) {
/******/ 							if(!outdatedDependencies[moduleId])
/******/ 								outdatedDependencies[moduleId] = [];
/******/ 							addAllToSet(outdatedDependencies[moduleId], result.outdatedDependencies[moduleId]);
/******/ 						}
/******/ 					}
/******/ 				}
/******/ 				if(doDispose) {
/******/ 					addAllToSet(outdatedModules, [result.moduleId]);
/******/ 					appliedUpdate[moduleId] = warnUnexpectedRequire;
/******/ 				}
/******/ 			}
/******/ 		}
/******/ 	
/******/ 		// Store self accepted outdated modules to require them later by the module system
/******/ 		var outdatedSelfAcceptedModules = [];
/******/ 		for(i = 0; i < outdatedModules.length; i++) {
/******/ 			moduleId = outdatedModules[i];
/******/ 			if(installedModules[moduleId] && installedModules[moduleId].hot._selfAccepted)
/******/ 				outdatedSelfAcceptedModules.push({
/******/ 					module: moduleId,
/******/ 					errorHandler: installedModules[moduleId].hot._selfAccepted
/******/ 				});
/******/ 		}
/******/ 	
/******/ 		// Now in "dispose" phase
/******/ 		hotSetStatus("dispose");
/******/ 		Object.keys(hotAvailableFilesMap).forEach(function(chunkId) {
/******/ 			if(hotAvailableFilesMap[chunkId] === false) {
/******/ 				hotDisposeChunk(chunkId);
/******/ 			}
/******/ 		});
/******/ 	
/******/ 		var idx;
/******/ 		var queue = outdatedModules.slice();
/******/ 		while(queue.length > 0) {
/******/ 			moduleId = queue.pop();
/******/ 			module = installedModules[moduleId];
/******/ 			if(!module) continue;
/******/ 	
/******/ 			var data = {};
/******/ 	
/******/ 			// Call dispose handlers
/******/ 			var disposeHandlers = module.hot._disposeHandlers;
/******/ 			for(j = 0; j < disposeHandlers.length; j++) {
/******/ 				cb = disposeHandlers[j];
/******/ 				cb(data);
/******/ 			}
/******/ 			hotCurrentModuleData[moduleId] = data;
/******/ 	
/******/ 			// disable module (this disables requires from this module)
/******/ 			module.hot.active = false;
/******/ 	
/******/ 			// remove module from cache
/******/ 			delete installedModules[moduleId];
/******/ 	
/******/ 			// when disposing there is no need to call dispose handler
/******/ 			delete outdatedDependencies[moduleId];
/******/ 	
/******/ 			// remove "parents" references from all children
/******/ 			for(j = 0; j < module.children.length; j++) {
/******/ 				var child = installedModules[module.children[j]];
/******/ 				if(!child) continue;
/******/ 				idx = child.parents.indexOf(moduleId);
/******/ 				if(idx >= 0) {
/******/ 					child.parents.splice(idx, 1);
/******/ 				}
/******/ 			}
/******/ 		}
/******/ 	
/******/ 		// remove outdated dependency from module children
/******/ 		var dependency;
/******/ 		var moduleOutdatedDependencies;
/******/ 		for(moduleId in outdatedDependencies) {
/******/ 			if(Object.prototype.hasOwnProperty.call(outdatedDependencies, moduleId)) {
/******/ 				module = installedModules[moduleId];
/******/ 				if(module) {
/******/ 					moduleOutdatedDependencies = outdatedDependencies[moduleId];
/******/ 					for(j = 0; j < moduleOutdatedDependencies.length; j++) {
/******/ 						dependency = moduleOutdatedDependencies[j];
/******/ 						idx = module.children.indexOf(dependency);
/******/ 						if(idx >= 0) module.children.splice(idx, 1);
/******/ 					}
/******/ 				}
/******/ 			}
/******/ 		}
/******/ 	
/******/ 		// Not in "apply" phase
/******/ 		hotSetStatus("apply");
/******/ 	
/******/ 		hotCurrentHash = hotUpdateNewHash;
/******/ 	
/******/ 		// insert new code
/******/ 		for(moduleId in appliedUpdate) {
/******/ 			if(Object.prototype.hasOwnProperty.call(appliedUpdate, moduleId)) {
/******/ 				modules[moduleId] = appliedUpdate[moduleId];
/******/ 			}
/******/ 		}
/******/ 	
/******/ 		// call accept handlers
/******/ 		var error = null;
/******/ 		for(moduleId in outdatedDependencies) {
/******/ 			if(Object.prototype.hasOwnProperty.call(outdatedDependencies, moduleId)) {
/******/ 				module = installedModules[moduleId];
/******/ 				if(module) {
/******/ 					moduleOutdatedDependencies = outdatedDependencies[moduleId];
/******/ 					var callbacks = [];
/******/ 					for(i = 0; i < moduleOutdatedDependencies.length; i++) {
/******/ 						dependency = moduleOutdatedDependencies[i];
/******/ 						cb = module.hot._acceptedDependencies[dependency];
/******/ 						if(cb) {
/******/ 							if(callbacks.indexOf(cb) >= 0) continue;
/******/ 							callbacks.push(cb);
/******/ 						}
/******/ 					}
/******/ 					for(i = 0; i < callbacks.length; i++) {
/******/ 						cb = callbacks[i];
/******/ 						try {
/******/ 							cb(moduleOutdatedDependencies);
/******/ 						} catch(err) {
/******/ 							if(options.onErrored) {
/******/ 								options.onErrored({
/******/ 									type: "accept-errored",
/******/ 									moduleId: moduleId,
/******/ 									dependencyId: moduleOutdatedDependencies[i],
/******/ 									error: err
/******/ 								});
/******/ 							}
/******/ 							if(!options.ignoreErrored) {
/******/ 								if(!error)
/******/ 									error = err;
/******/ 							}
/******/ 						}
/******/ 					}
/******/ 				}
/******/ 			}
/******/ 		}
/******/ 	
/******/ 		// Load self accepted modules
/******/ 		for(i = 0; i < outdatedSelfAcceptedModules.length; i++) {
/******/ 			var item = outdatedSelfAcceptedModules[i];
/******/ 			moduleId = item.module;
/******/ 			hotCurrentParents = [moduleId];
/******/ 			try {
/******/ 				__webpack_require__(moduleId);
/******/ 			} catch(err) {
/******/ 				if(typeof item.errorHandler === "function") {
/******/ 					try {
/******/ 						item.errorHandler(err);
/******/ 					} catch(err2) {
/******/ 						if(options.onErrored) {
/******/ 							options.onErrored({
/******/ 								type: "self-accept-error-handler-errored",
/******/ 								moduleId: moduleId,
/******/ 								error: err2,
/******/ 								orginalError: err, // TODO remove in webpack 4
/******/ 								originalError: err
/******/ 							});
/******/ 						}
/******/ 						if(!options.ignoreErrored) {
/******/ 							if(!error)
/******/ 								error = err2;
/******/ 						}
/******/ 						if(!error)
/******/ 							error = err;
/******/ 					}
/******/ 				} else {
/******/ 					if(options.onErrored) {
/******/ 						options.onErrored({
/******/ 							type: "self-accept-errored",
/******/ 							moduleId: moduleId,
/******/ 							error: err
/******/ 						});
/******/ 					}
/******/ 					if(!options.ignoreErrored) {
/******/ 						if(!error)
/******/ 							error = err;
/******/ 					}
/******/ 				}
/******/ 			}
/******/ 		}
/******/ 	
/******/ 		// handle errors in accept handlers and self accepted module load
/******/ 		if(error) {
/******/ 			hotSetStatus("fail");
/******/ 			return Promise.reject(error);
/******/ 		}
/******/ 	
/******/ 		hotSetStatus("idle");
/******/ 		return new Promise(function(resolve) {
/******/ 			resolve(outdatedModules);
/******/ 		});
/******/ 	}
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {},
/******/ 			hot: hotCreateModule(moduleId),
/******/ 			parents: (hotCurrentParentsTemp = hotCurrentParents, hotCurrentParents = [], hotCurrentParentsTemp),
/******/ 			children: []
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, hotCreateRequire(moduleId));
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/bamboo-ui/builds/";
/******/
/******/ 	// __webpack_hash__
/******/ 	__webpack_require__.h = function() { return hotCurrentHash; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return hotCreateRequire(40)(__webpack_require__.s = 40);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(7))(0);

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(7))(2);

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(7))(89);

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Picker = exports.FlatList = exports.PinBox = exports.Label = exports.Table = exports.AutoComplete = exports.DynamicString = exports.DynamicNumber = exports.Tooltip = exports.Progress = exports.Curtain = exports.Modal = exports.GroupItem = exports.Group = exports.Menu = exports.Select = exports.Slider = exports.Checkbox = exports.Radio = exports.Input = exports.FormField = exports.Form = exports.A = exports.Icon = exports.Button = exports.Col = exports.Row = exports.Navigation = undefined;

var _Nav = __webpack_require__(30);

var _Nav2 = _interopRequireDefault(_Nav);

var _Row2 = __webpack_require__(59);

var _Row3 = _interopRequireDefault(_Row2);

var _Col2 = __webpack_require__(31);

var _Col3 = _interopRequireDefault(_Col2);

var _Button2 = __webpack_require__(16);

var _Button3 = _interopRequireDefault(_Button2);

var _Icon2 = __webpack_require__(24);

var _Icon3 = _interopRequireDefault(_Icon2);

var _A2 = __webpack_require__(62);

var _A3 = _interopRequireDefault(_A2);

var _Form2 = __webpack_require__(63);

var _Form3 = _interopRequireDefault(_Form2);

var _Field = __webpack_require__(32);

var _Field2 = _interopRequireDefault(_Field);

var _Input2 = __webpack_require__(17);

var _Input3 = _interopRequireDefault(_Input2);

var _Radio2 = __webpack_require__(25);

var _Radio3 = _interopRequireDefault(_Radio2);

var _Checkbox2 = __webpack_require__(13);

var _Checkbox3 = _interopRequireDefault(_Checkbox2);

var _Slider2 = __webpack_require__(64);

var _Slider3 = _interopRequireDefault(_Slider2);

var _Select2 = __webpack_require__(33);

var _Select3 = _interopRequireDefault(_Select2);

var _Menu2 = __webpack_require__(68);

var _Menu3 = _interopRequireDefault(_Menu2);

var _Group2 = __webpack_require__(36);

var _Group3 = _interopRequireDefault(_Group2);

var _Item = __webpack_require__(37);

var _Item2 = _interopRequireDefault(_Item);

var _Modal2 = __webpack_require__(70);

var _Modal3 = _interopRequireDefault(_Modal2);

var _Curtain2 = __webpack_require__(77);

var _Curtain3 = _interopRequireDefault(_Curtain2);

var _Progress2 = __webpack_require__(78);

var _Progress3 = _interopRequireDefault(_Progress2);

var _Tooltip2 = __webpack_require__(79);

var _Tooltip3 = _interopRequireDefault(_Tooltip2);

var _DynamicNumber2 = __webpack_require__(81);

var _DynamicNumber3 = _interopRequireDefault(_DynamicNumber2);

var _DynamicString2 = __webpack_require__(82);

var _DynamicString3 = _interopRequireDefault(_DynamicString2);

var _AutoComplete2 = __webpack_require__(83);

var _AutoComplete3 = _interopRequireDefault(_AutoComplete2);

var _Table2 = __webpack_require__(85);

var _Table3 = _interopRequireDefault(_Table2);

var _Label2 = __webpack_require__(88);

var _Label3 = _interopRequireDefault(_Label2);

var _PinBox2 = __webpack_require__(27);

var _PinBox3 = _interopRequireDefault(_PinBox2);

var _FlatList2 = __webpack_require__(89);

var _FlatList3 = _interopRequireDefault(_FlatList2);

var _Picker2 = __webpack_require__(90);

var _Picker3 = _interopRequireDefault(_Picker2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Navigation = _Nav2.default;
exports.Row = _Row3.default;
exports.Col = _Col3.default;
exports.Button = _Button3.default;
exports.Icon = _Icon3.default;
exports.A = _A3.default;
exports.Form = _Form3.default;
exports.FormField = _Field2.default;
exports.Input = _Input3.default;
exports.Radio = _Radio3.default;
exports.Checkbox = _Checkbox3.default;
exports.Slider = _Slider3.default;
exports.Select = _Select3.default;
exports.Menu = _Menu3.default;
exports.Group = _Group3.default;
exports.GroupItem = _Item2.default;
exports.Modal = _Modal3.default;
exports.Curtain = _Curtain3.default;
exports.Progress = _Progress3.default;
exports.Tooltip = _Tooltip3.default;
exports.DynamicNumber = _DynamicNumber3.default;
exports.DynamicString = _DynamicString3.default;
exports.AutoComplete = _AutoComplete3.default;
exports.Table = _Table3.default;
exports.Label = _Label3.default;
exports.PinBox = _PinBox3.default;
exports.FlatList = _FlatList3.default;
exports.Picker = _Picker3.default;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.mapChildrenByNotType = exports.everyChildrenByType = exports.someChildrenByType = exports.mapChildrenByType = exports.mapChildrenForNode = exports.mapChildren = exports.BAMBOO_INTERNAL_REF = exports.BAMBOO_COMPONENT = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BAMBOO_COMPONENT = exports.BAMBOO_COMPONENT = 'BAMBOO_COMPONENT';

var BAMBOO_INTERNAL_REF = exports.BAMBOO_INTERNAL_REF = 'BAMBOO_INTERNAL_REF';

var mapChildren = exports.mapChildren = function mapChildren(children, func) {
	var list = _react2.default.Children.map(children, function (node, index) {
		return func(node, index);
	}) || [];
	return list.filter(function (node) {
		return node;
	});
};

var mapChildrenForNode = exports.mapChildrenForNode = function mapChildrenForNode(children, func) {
	return mapChildren(children, function (node, index) {
		if (_react2.default.isValidElement(node)) {
			return func(node, index);
		}
		return node;
	});
};

var mapChildrenByType = exports.mapChildrenByType = function mapChildrenByType(children, type, func) {
	var typeList = Array.isArray(type) ? type : [type];

	return mapChildren(children, function (node, index) {
		if (_react2.default.isValidElement(node) && node.type && typeList.includes(node.type[BAMBOO_COMPONENT])) {
			if (func) return func(node, index);
			return node;
		}
		return null;
	});
};

var someChildrenByType = exports.someChildrenByType = function someChildrenByType(children, type, func) {
	var childList = mapChildrenByType(children, type, function (node) {
		return node;
	});
	return childList.some(func);
};

var everyChildrenByType = exports.everyChildrenByType = function everyChildrenByType(children, type, func) {
	var childList = mapChildrenByType(children, type, function (node) {
		return node;
	});
	return childList.every(func);
};

var mapChildrenByNotType = exports.mapChildrenByNotType = function mapChildrenByNotType(children, type, func) {
	var typeList = Array.isArray(type) ? type : [type];

	return mapChildren(children, function (node, index) {
		if (_react2.default.isValidElement(node) && node.type && typeList.includes(node.type[BAMBOO_COMPONENT])) {
			return null;
		}

		if (func) return func(node, index);
		return node;
	});
};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
var TYPE_LIST = exports.TYPE_LIST = [{ name: 'deprecated', isDefault: false }, { name: 'primary', isDefault: true }, { name: 'info', isDefault: false }, { name: 'success', isDefault: false }, { name: 'warning', isDefault: false }, { name: 'danger', isDefault: false }, { name: 'forbid', isDefault: false }];

var SIZE_LIST = exports.SIZE_LIST = [{ name: 'xs', displayName: 'x-small', isDefault: false }, { name: 'sm', displayName: 'small', isDefault: false }, { name: 'md', displayName: 'medium', isDefault: true }, { name: 'lg', displayName: 'large', isDefault: false }, { name: 'xl', displayName: 'x-large', isDefault: false }];

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var toString = exports.toString = function toString(props) {
	var defaultProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	var str = Object.keys(props).map(function (key) {
		var value = props[key];
		if (value === undefined || defaultProps[key] === value) return null;

		if (value === null) {
			return key + '={null}';
		}

		if (Array.isArray(value)) {
			return key + '={' + JSON.stringify(value) + '}';
		}

		switch (typeof value === 'undefined' ? 'undefined' : _typeof(value)) {
			case 'string':
				return key + '="' + value + '"';
			case 'number':
				return key + '={' + value + '}';
			case 'boolean':
				return value ? '' + key : '';
		}

		console.warn('Unknown type of ', key, value);
		return null;
	}).filter(function (s) {
		return s;
	}).join(' ');

	return str ? ' ' + str : '';
};

exports.default = {};

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = vendor;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.getEnablePosition = exports.getWinHeight = exports.getWinWidth = exports.createPortal = exports.hasVerticalScroll = exports.hasHorizontalScroll = exports.requestAnimationFrame = exports.ANIMATION_INTERVAL = exports.ANIMATE_STATUS_HIDING = exports.ANIMATE_STATUS_SHOWN = exports.ANIMATE_STATUS_SHOWING = exports.ANIMATE_STATUS_INIT = exports.ANIMATE_STATUS_NONE = undefined;
exports.getHolder = getHolder;
exports.getScrollbarWidth = getScrollbarWidth;
exports.enableWinScrollBar = enableWinScrollBar;
exports.disableWinScrollBar = disableWinScrollBar;
exports.isInRect = isInRect;

var _reactDom = __webpack_require__(14);

var _envUtil = __webpack_require__(11);

var ANIMATE_STATUS_NONE = exports.ANIMATE_STATUS_NONE = 0;
var ANIMATE_STATUS_INIT = exports.ANIMATE_STATUS_INIT = 1;
var ANIMATE_STATUS_SHOWING = exports.ANIMATE_STATUS_SHOWING = 2;
var ANIMATE_STATUS_SHOWN = exports.ANIMATE_STATUS_SHOWN = 3;
var ANIMATE_STATUS_HIDING = exports.ANIMATE_STATUS_HIDING = 4;

var BAMBOO_PORTALS_HOLDER = 'bmbo_portals_holder';
var $bambooHolder = void 0;

// =====================================================================================
// =                                   Window Holder                                   =
// =====================================================================================
if (_envUtil.canUseDOM) {
	// Clean up menu holder for hot module reload
	window.document.querySelectorAll('#' + BAMBOO_PORTALS_HOLDER).forEach(function (ele) {
		ele.remove();
	});

	// Set up menu holder
	$bambooHolder = window.document.createElement('div');
	$bambooHolder.id = BAMBOO_PORTALS_HOLDER;
	$bambooHolder.className = 'bmbo-portals-holder';
	// $bambooHolder.dataset.timestamp = Date.now();
	window.document.body.appendChild($bambooHolder);
}
function getHolder() {
	return $bambooHolder;
}

// =====================================================================================
// =                                     Animation                                     =
// =====================================================================================
var ANIMATION_INTERVAL = exports.ANIMATION_INTERVAL = 1000 / 60;

var delayByFrame = function delayByFrame(func) {
	if (window.requestAnimationFrame) {
		window.requestAnimationFrame(func);
	} else {
		setTimeout(func, ANIMATION_INTERVAL);
	}
};

var requestAnimationFrame = exports.requestAnimationFrame = function requestAnimationFrame(func) {
	var delayFrame = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

	var count = delayFrame;

	function doAction() {
		if (count <= 0) {
			func();
			return;
		}

		count -= 1;
		delayByFrame(doAction);
	}

	doAction();
};

// =====================================================================================
// =                                      Scroll                                       =
// =====================================================================================
/**
 * Get Scroll bar size
 * @type {number}
 */
var scrollbarWidth = 0;
function getScrollbarWidth() {
	if (scrollbarWidth || !_envUtil.canUseDOM) return scrollbarWidth;

	var $body = window.document.body;
	var scrollDiv = document.createElement('div');
	scrollDiv.className = 'bmbo-scrollbar-measure';
	$body.appendChild(scrollDiv);
	scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	scrollDiv.remove();
	return scrollbarWidth;
}

var hasHorizontalScroll = exports.hasHorizontalScroll = function hasHorizontalScroll() {
	var winWidth = window.innerWidth;
	var bodyWidth = window.document.body.scrollWidth;
	return winWidth < bodyWidth;
};

var hasVerticalScroll = exports.hasVerticalScroll = function hasVerticalScroll() {
	var winHeight = window.innerHeight;
	var bodyHeight = window.document.body.scrollHeight;
	return winHeight < bodyHeight;
};

var winScrollLocker = [];

function enableWinScrollBar(name) {
	if (!_envUtil.canUseDOM) return;

	if (name) {
		winScrollLocker = winScrollLocker.filter(function (n) {
			return n !== name;
		});
		if (winScrollLocker.length) return;
	} else {
		winScrollLocker = [];
	}

	document.body.style.paddingRight = '';
	document.body.style.overflowY = '';
}

function disableWinScrollBar(name) {
	if (!_envUtil.canUseDOM) return;
	if (!hasVerticalScroll()) return;

	if (name) {
		winScrollLocker.push(name);
	}

	document.body.style.paddingRight = getScrollbarWidth() + 'px';
	document.body.style.overflowY = 'hidden';
}

// =====================================================================================
// =                                     Position                                      =
// =====================================================================================
var createPortal = exports.createPortal = function createPortal(node) {
	if (!_envUtil.canUseDOM) return null;

	return (0, _reactDom.createPortal)(node, $bambooHolder);
};

var getWinWidth = exports.getWinWidth = function getWinWidth() {
	var winWidth = window.innerWidth;
	if (hasVerticalScroll()) winWidth -= getScrollbarWidth();
	return winWidth;
};

var getWinHeight = exports.getWinHeight = function getWinHeight() {
	var winHeight = window.innerHeight;
	if (hasHorizontalScroll()) winHeight -= getScrollbarWidth();
	return winHeight;
};

/**
 * Get enabled position for element.
 * @param surroundRect
 * @param targetRect
 * @param position
 * @returns {{x: number, y: number}}
 */
var getEnablePosition = exports.getEnablePosition = function getEnablePosition(surroundRect, targetRect) {
	var position = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'dr';

	if (typeof window === 'undefined') return { x: 0, y: 0 };

	var _surroundRect$width = surroundRect.width,
	    sw = _surroundRect$width === undefined ? 0 : _surroundRect$width,
	    _surroundRect$height = surroundRect.height,
	    sh = _surroundRect$height === undefined ? 0 : _surroundRect$height;

	var sx = surroundRect.left || 0;
	var sy = surroundRect.top || 0;
	var _targetRect$width = targetRect.width,
	    tw = _targetRect$width === undefined ? 0 : _targetRect$width,
	    _targetRect$height = targetRect.height,
	    th = _targetRect$height === undefined ? 0 : _targetRect$height;


	var winWidth = getWinWidth();
	var winHeight = getWinHeight();
	var scrollX = window.scrollX;
	var scrollY = window.scrollY;

	var isR = position.includes('r');
	var isB = position.includes('b');
	var isT = position.includes('t');
	var isL = position.includes('l');
	var isLorR = isL && !isR || !isL && isR;
	var isTorB = isT && !isB || !isT && isB;

	var target = {
		x: sx + scrollX,
		y: sy + scrollY,
		direct: ''
	};

	if (isL && !isR) target.x = sx - tw + scrollX;
	if (isR && !isL) target.x = sx + sw + scrollX;
	if (isT && !isB) target.y = sy - th + scrollY;
	if (isB && !isT) target.y = sy + sh + scrollY;

	if (isL && isR) target.x = sx - (tw - sw) / 2 + scrollX;
	if (isT && isB) target.y = sy - (th - sh) / 2 + scrollY;

	target._x = target.x;
	target._y = target.y;

	// Bottom out of the window
	if (target.y - scrollY + th > winHeight) {
		if (isLorR) {
			target.y = winHeight - th + scrollY;
		} else {
			var ty = sy - th;
			if (ty >= 0) {
				target.y = sy + scrollY - th;
				target.direct = 'up';
			}
		}
	}

	// Top out of the window
	if (target.y - scrollY < 0) {
		if (isLorR) {
			target.y = scrollY;
		} else {
			target.y = sy + sh + scrollY;
		}
	}

	// Left out of the window
	if (target.x - scrollX < 0) {
		if (isTorB) {
			target.x = scrollX;
		} else {
			target.x = sx + sw + scrollX;
		}
	}

	// Right out of the window
	if (target.x - scrollX + tw > winWidth) {
		if (isTorB) {
			target.x = winWidth - tw + scrollX;
		} else {
			target.x = sx + scrollX - tw;
		}
	}

	return target;
};

/**
 * Get enabled position for element.
 * @param surroundRect
 * @param targetRect
 * @param position
 * @param switchPos		Switch position when position has no space left
 * @returns {{x: number, y: number}}
 */
/* export const getEnablePosition2 = (surroundRect, targetRect, position = 'dr', switchPos = true) => {
	if (typeof window === 'undefined') return { x: 0, y: 0 };

	const { width: sw = 0, height: sh = 0 } = surroundRect;
	const sx = surroundRect.left || 0;
	const sy = surroundRect.top || 0;
	const { width: tw = 0, height: th = 0 } = targetRect;

	const winWidth = getWinWidth();
	const winHeight = getWinHeight();
	const scrollX = window.scrollX;
	const scrollY = window.scrollY;

	const isR = position.includes('r');
	const isB = position.includes('b');
	const isT = position.includes('t');
	const isL = position.includes('l');

	const target = {
		x: sx + scrollX,
		y: sy + scrollY,
		direct: '',
	};

	if (isL && !isR) target.x = (sx - tw) + scrollX;
	if (isR && !isL) target.x = (sx + sw) + scrollX;
	if (isT && !isB) target.y = (sy - th) + scrollY;
	if (isB && !isT) target.y = (sy + sh) + scrollY;

	if (isL && isR) target.x = (sx - ((tw - sw) / 2)) + scrollX;
	if (isT && isB) target.y = (sy - ((th - sh) / 2)) + scrollY;

	target._x = target.x;
	target._y = target.y;

	// Bottom out of the window
	if ((target.y - scrollY) + th > winHeight) {
		if (isR) {
			target.y = (winHeight - th) + scrollY;
		} else {
			const ty = (sy + scrollY) - th;
			if (ty >= 0) {
				target.y = (sy + scrollY) - th;
				target.direct = 'up';
			}
		}
	}
	// Top out of the window
	if ((target.y - scrollY) < 0) {
		if (switchPos) {
			target.y = sy + sh + scrollY;
		} else {
			target.y = scrollY;
		}
	}

	// Left out of the window
	if (target.x - scrollX < 0) {
		if (switchPos) {
			target.x = sx + sw;
		} else {
			target.x = scrollX;
		}
	}

	// Right out of the window
	if ((target.x - scrollX) + tw > winWidth) {
		if (switchPos) {
			target.x = sx - tw;
		} else {
			target.x = (winWidth + scrollX) - tw;
		}
	}

	return target;
}; */

function isInRect(x, y, rect) {
	return rect.left < x && x < rect.right && rect.top < y && y < rect.bottom;
}

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _uiUtil = __webpack_require__(8);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TaskHolder = function () {
	function TaskHolder(config) {
		_classCallCheck(this, TaskHolder);

		this.config = config;
		this.list = [];
		this.index = 0;
		this.promise = null;
	}

	_createClass(TaskHolder, [{
		key: 'weakThan',
		value: function weakThan() {
			var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

			return (this.config.priority || 0) <= (config.priority || 0);
		}
	}, {
		key: 'next',
		value: function next(callback) {
			var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

			this.list.push({ callback: callback, config: config });
			return this;
		}
	}, {
		key: 'getCurrent',
		value: function getCurrent() {
			return this.list[this.index];
		}
	}, {
		key: 'nextStep',
		value: function nextStep() {
			this.index += 1;
		}
	}]);

	return TaskHolder;
}();

var Sequence = function () {
	function Sequence() {
		_classCallCheck(this, Sequence);

		this.taskHolder = null;
		this._destroy = false;
	}

	_createClass(Sequence, [{
		key: 'next',
		value: function next(callback) {
			var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

			var taskHolder = new TaskHolder(config);
			taskHolder.next(callback, config);

			if (!this.taskHolder || this.taskHolder.weakThan(config)) {
				this.taskHolder = taskHolder;
			}

			taskHolder.promise = this._doAction(taskHolder);

			return taskHolder;
		}
	}, {
		key: 'stop',
		value: function stop() {
			this.taskHolder = null;
		}
	}, {
		key: 'destroy',
		value: function destroy() {
			this._destroy = true;
		}
	}, {
		key: '_doAction',
		value: function _doAction(taskHolder) {
			var _this = this;

			return new Promise(function (resolve, reject) {
				if (_this._destroy) return;

				var step = function step() {
					var task = taskHolder.getCurrent();
					if (!task) {
						_this.taskHolder = null;
						resolve();
						return;
					}

					var exec = function exec() {
						try {
							if (_this.taskHolder !== taskHolder || _this._destroy) return;

							var taskCallback = task.callback;
							var needCallback = taskCallback.length !== 0;

							// Do next
							var doNext = function doNext() {
								// If is a looper
								if (task.config.loop) {
									step();
									return;
								}

								// Next task
								taskHolder.nextStep();
								step();
							};

							// Execute task
							var taskResult = taskCallback(doNext);
							if (taskResult === false) {
								_this.taskHolder = null;
								resolve();
								return;
							}

							if (!needCallback) {
								doNext();
							}
						} catch (err) {
							reject(err);
						}
					};

					if (task.config.delay !== undefined) {
						setTimeout(exec, task.config.delay);
					} else {
						(0, _uiUtil.requestAnimationFrame)(exec, task.config.frame || 2);
					}
				};

				step();
			});
		}
	}]);

	return Sequence;
}();

exports.default = Sequence;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.wrapperEventValue = undefined;
exports.addUniqueListener = addUniqueListener;
exports.removeUniqueListener = removeUniqueListener;
exports.isSameSource = isSameSource;

var _envUtil = __webpack_require__(11);

var events = {};

function addUniqueListener(event, listener) {
	if (!_envUtil.canUseDOM) return;

	if (events[event] === undefined) {
		window.addEventListener(event, function () {
			if (events[event]) {
				events[event].apply(events, arguments);
			}
		});
	}

	events[event] = listener;
}

function removeUniqueListener(event, listener) {
	var currentListener = events[event];

	if (currentListener === listener) {
		events[event] = null;
		return true;
	}

	return false;
}

function isSameSource(event, target) {
	var current = event.target;

	while (current) {
		if (current === target || current._bmbo_ignore) {
			return true;
		}

		current = current.parentElement;
	}

	return false;
}

var wrapperEventValue = exports.wrapperEventValue = function wrapperEventValue(originEvent, target, value) {
	target.value = value; // eslint-disable-line no-param-reassign

	return new Proxy(originEvent, {
		get: function get(tgt, key) {
			if (key === 'target') return target;
			return tgt[key];
		}
	});
};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var isDev = exports.isDev = "production" !== 'production';

exports.default = {};

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(7))(116);

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.BAMBOO_FORM_CHECKBOX = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _componentUtil = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var BAMBOO_FORM_CHECKBOX = exports.BAMBOO_FORM_CHECKBOX = 'BAMBOO_FORM_CHECKBOX';

var Checkbox = function Checkbox(_ref) {
	var children = _ref.children,
	    checked = _ref.checked,
	    disabled = _ref.disabled,
	    size = _ref.size,
	    onClick = _ref.onClick,
	    className = _ref.className,
	    props = _objectWithoutProperties(_ref, ['children', 'checked', 'disabled', 'size', 'onClick', 'className']);

	return _react2.default.createElement(
		'div',
		_extends({
			className: (0, _classnames2.default)('bmbo-checkbox', 'bmbo-' + (size || 'md'), checked && 'bmbo-checked', disabled && 'bmbo-disabled', className),
			role: 'button',
			tabIndex: 0,
			onClick: disabled ? null : onClick
		}, props),
		_react2.default.createElement('input', { type: 'checkbox', checked: checked, disabled: disabled, readOnly: true }),
		_react2.default.createElement('span', { className: 'bmbo-checkbox-check' }),
		_react2.default.createElement(
			'div',
			{ className: 'bmbo-checkbox-content' },
			children
		)
	);
};

Checkbox[_componentUtil.BAMBOO_COMPONENT] = BAMBOO_FORM_CHECKBOX;

exports.default = Checkbox;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(7))(232);

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Caret = function Caret(_ref) {
	var _ref$direct = _ref.direct,
	    direct = _ref$direct === undefined ? 'right' : _ref$direct,
	    className = _ref.className;
	return _react2.default.createElement('span', {
		className: (0, _classnames2.default)('bmbo-icon bmbo-caret', direct && 'bmbo-caret-' + direct, className)
	});
};

exports.default = Caret;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Button = function (_React$Component) {
	_inherits(Button, _React$Component);

	function Button() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, Button);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Button.__proto__ || Object.getPrototypeOf(Button)).call.apply(_ref, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(Button, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    children = _props.children,
			    className = _props.className,
			    disabled = _props.disabled,
			    size = _props.size,
			    transparent = _props.transparent,
			    checked = _props.checked,
			    props = _objectWithoutProperties(_props, ['children', 'className', 'disabled', 'size', 'transparent', 'checked']);

			var type = this.props.type || 'primary';

			delete props.type;
			delete props.onClick;

			return _react2.default.createElement(
				'button',
				_extends({
					className: (0, _classnames2.default)('bmbo-button', type && 'bmbo-' + type, disabled && 'bmbo-disabled', 'bmbo-' + (size || 'md'), transparent && 'bmbo-transparent', checked && 'bmbo-checked', className),
					onClick: this.onClick

				}, props),
				children
			);
		}
	}]);

	return Button;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
	var _this2 = this;

	this.onClick = function () {
		var _props2 = _this2.props,
		    onClick = _props2.onClick,
		    disabled = _props2.disabled;


		if (disabled) return;
		if (onClick) onClick.apply(undefined, arguments);
	};
};

exports.default = Button;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.BAMBOO_FORM_INPUT = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _componentUtil = __webpack_require__(4);

var _Icon = __webpack_require__(24);

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BAMBOO_FORM_INPUT = exports.BAMBOO_FORM_INPUT = 'BAMBOO_FORM_INPUT';

var Input = function (_React$PureComponent) {
	_inherits(Input, _React$PureComponent);

	function Input() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, Input);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Input.__proto__ || Object.getPrototypeOf(Input)).call.apply(_ref, [this].concat(args))), _this), _this.setRef = function (ele) {
			var setRef = _this.props[_componentUtil.BAMBOO_INTERNAL_REF];
			_this.$input = ele;

			if (setRef) setRef(ele);
		}, _this.focus = function () {
			if (_this.$input) {
				_this.$input.focus();
			}
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(Input, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    size = _props.size,
			    type = _props.type,
			    icon = _props.icon,
			    className = _props.className,
			    rest = _objectWithoutProperties(_props, ['size', 'type', 'icon', 'className']);

			delete rest[_componentUtil.BAMBOO_INTERNAL_REF];

			var $input = _react2.default.createElement('input', _extends({
				className: (0, _classnames2.default)('bmbo-input', icon && 'bmbo-with-icon', 'bmbo-' + (size || 'md'), type && 'bmbo-' + type, className),
				ref: this.setRef
			}, rest));

			if (icon) {
				return _react2.default.createElement(
					'div',
					{
						className: (0, _classnames2.default)('bmbo-input-container', 'bmbo-' + (size || 'md'))
					},
					$input,
					_react2.default.createElement(_Icon2.default, { name: icon, size: size, className: 'bmbo-input-icon' })
				);
			}

			return $input;
		}
	}]);

	return Input;
}(_react2.default.PureComponent);

Input[BAMBOO_FORM_INPUT] = BAMBOO_FORM_INPUT;

exports.default = Input;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var getValue = exports.getValue = function getValue(unit, path, defaultValue) {
	if (!path) return unit;

	var desList = Array.isArray(path) ? path : [path];
	var current = unit;
	var len = desList.length;

	for (var i = 0; i < len; i += 1) {
		var des = desList[i];
		current = current[des];

		if (current === undefined || i !== len - 1 && current === null) {
			current = defaultValue;
			break;
		}
	}

	return current;
};

var setValueByFn = exports.setValueByFn = function setValueByFn(unit, path, func) {
	var desList = Array.isArray(path) ? path : [path];
	var preLen = desList.length - 1;
	var current = unit;

	for (var i = 0; i < preLen; i += 1) {
		var des = desList[i];
		var tmp = current[des];
		if (tmp === null || tmp === undefined) {
			current = current[des] = typeof des === 'number' ? [] : {};
		} else if ((typeof tmp === 'undefined' ? 'undefined' : _typeof(tmp)) === 'object') {
			current = current[des];
		} else {
			throw new Error(des + ' is not an object!');
		}
	}

	current[desList[preLen]] = func(current[desList[preLen]]);

	return unit;
};

var setValue = exports.setValue = function setValue(unit, path, value) {
	return setValueByFn(unit, path, function () {
		return value;
	});
};

var updateValue = exports.updateValue = function updateValue(unit, path, updateFunc) {
	var desList = Array.isArray(path) ? path : [path];
	var preLen = desList.length - 1;
	var instance = Array.isArray(unit) ? [].concat(_toConsumableArray(unit)) : _extends({}, unit);
	var current = instance;
	var des = void 0;

	for (var i = 0; i < preLen; i += 1) {
		des = desList[i];
		var value = current[des];
		current = current[des] = Array.isArray(value) ? [].concat(_toConsumableArray(value)) : _extends({}, value);
	}

	current[desList[preLen]] = typeof updateFunc === 'function' ? updateFunc(current[desList[preLen]]) : updateFunc;

	return instance;
};

var merge = exports.merge = function merge() {
	var origin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	var myOrigin = origin;

	Object.keys(target).forEach(function (key) {
		var value = target[key];
		if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value !== null) {
			if (_typeof(myOrigin[key]) !== 'object' || myOrigin[key] === null) {
				myOrigin[key] = Array.isArray(value) ? [] : {};
			}

			merge(myOrigin[key], value);
		} else {
			myOrigin[key] = value;
		}
	});

	return myOrigin;
};

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
var toString = exports.toString = function toString(obj) {
	var maps = {};
	var id = 0;

	var str = JSON.stringify(obj, function (key, value) {
		if (typeof value === 'function') {
			var myId = id;
			id += 1;

			maps[myId] = value.toString().replace(/\t/g, '   ');
			return '[__' + myId + '__]';
		}

		return value;
	}, 3);

	var lines = str.split(/\n/);

	var _loop = function _loop(i) {
		var key = '"[__' + i + '__]"';

		lines.some(function (line, index) {
			if (line.includes(key)) {
				var preSpaceMatch = line.match(/^\s+/);
				var preSpace = (preSpaceMatch || [])[0] || '';
				preSpace = preSpace.slice(3);
				lines[index] = line.replace(key, maps[i]).split(/\n/).map(function (l, j) {
					return j === 0 ? l : '' + preSpace + l;
				}).join('\n');

				return true;
			}
			return false;
		});
	};

	for (var i = 0; i < id; i += 1) {
		_loop(i);
	}

	return lines.join('\n');
};

exports.default = {};

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(7))(242);

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(7))(258);

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(53);

var _reactRouterDom = __webpack_require__(21);

var _reactRedux = __webpack_require__(20);

var _reactCssModules = __webpack_require__(12);

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _Home = __webpack_require__(54);

var _Home2 = _interopRequireDefault(_Home);

var _Components = __webpack_require__(95);

var _Components2 = _interopRequireDefault(_Components);

var _GridPage = __webpack_require__(96);

var _GridPage2 = _interopRequireDefault(_GridPage);

var _ButtonPage = __webpack_require__(98);

var _ButtonPage2 = _interopRequireDefault(_ButtonPage);

var _IconPage = __webpack_require__(99);

var _IconPage2 = _interopRequireDefault(_IconPage);

var _SliderPage = __webpack_require__(100);

var _SliderPage2 = _interopRequireDefault(_SliderPage);

var _MenuPage = __webpack_require__(101);

var _MenuPage2 = _interopRequireDefault(_MenuPage);

var _GroupPage = __webpack_require__(102);

var _GroupPage2 = _interopRequireDefault(_GroupPage);

var _ModalPage = __webpack_require__(103);

var _ModalPage2 = _interopRequireDefault(_ModalPage);

var _NavPage = __webpack_require__(104);

var _NavPage2 = _interopRequireDefault(_NavPage);

var _CurtainPage = __webpack_require__(105);

var _CurtainPage2 = _interopRequireDefault(_CurtainPage);

var _ProgressPage = __webpack_require__(106);

var _ProgressPage2 = _interopRequireDefault(_ProgressPage);

var _TooltipPage = __webpack_require__(107);

var _TooltipPage2 = _interopRequireDefault(_TooltipPage);

var _DynamicNumberPage = __webpack_require__(108);

var _DynamicNumberPage2 = _interopRequireDefault(_DynamicNumberPage);

var _DynamicStringPage = __webpack_require__(109);

var _DynamicStringPage2 = _interopRequireDefault(_DynamicStringPage);

var _AutoCompletePage = __webpack_require__(110);

var _AutoCompletePage2 = _interopRequireDefault(_AutoCompletePage);

var _SelectPage = __webpack_require__(111);

var _SelectPage2 = _interopRequireDefault(_SelectPage);

var _TablePage = __webpack_require__(112);

var _TablePage2 = _interopRequireDefault(_TablePage);

var _LabelPage = __webpack_require__(113);

var _LabelPage2 = _interopRequireDefault(_LabelPage);

var _DatePickerPage = __webpack_require__(114);

var _DatePickerPage2 = _interopRequireDefault(_DatePickerPage);

var _PinBoxPage = __webpack_require__(115);

var _PinBoxPage2 = _interopRequireDefault(_PinBoxPage);

var _FlatListPage = __webpack_require__(116);

var _FlatListPage2 = _interopRequireDefault(_FlatListPage);

var _InputPage = __webpack_require__(117);

var _InputPage2 = _interopRequireDefault(_InputPage);

var _Nav = __webpack_require__(30);

var _Nav2 = _interopRequireDefault(_Nav);

var _index = __webpack_require__(118);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isProd = "production" === 'production';

var Main = function (_React$Component) {
	_inherits(Main, _React$Component);

	function Main() {
		_classCallCheck(this, Main);

		var _this = _possibleConstructorReturn(this, (Main.__proto__ || Object.getPrototypeOf(Main)).call(this));

		_this.goPage = function (path) {
			var push = _this.props.history.push;

			push(path);
		};

		_this.state = {};
		return _this;
	}

	_createClass(Main, [{
		key: 'render',
		value: function render() {
			return _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(
					_Nav2.default,
					null,
					_react2.default.createElement(
						_Nav2.default.Item,
						null,
						_react2.default.createElement(
							_reactRouterDom.Link,
							{ to: '/' },
							'Home'
						)
					),
					_react2.default.createElement(
						_Nav2.default.Item,
						null,
						_react2.default.createElement(
							_reactRouterDom.Link,
							{ to: '/grid' },
							'Components'
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ id: 'content' },
					_react2.default.createElement(_reactRouter.Route, { exact: true, path: '/', component: _Home2.default }),
					_react2.default.createElement(_reactRouter.Route, { path: '/grid', component: (0, _Components2.default)(_GridPage2.default) }),
					_react2.default.createElement(_reactRouter.Route, { path: '/button', component: (0, _Components2.default)(_ButtonPage2.default) }),
					_react2.default.createElement(_reactRouter.Route, { path: '/icon', component: (0, _Components2.default)(_IconPage2.default) }),
					_react2.default.createElement(_reactRouter.Route, { path: '/slider', component: (0, _Components2.default)(_SliderPage2.default) }),
					_react2.default.createElement(_reactRouter.Route, { path: '/menu', component: (0, _Components2.default)(_MenuPage2.default) }),
					_react2.default.createElement(_reactRouter.Route, { path: '/group', component: (0, _Components2.default)(_GroupPage2.default) }),
					_react2.default.createElement(_reactRouter.Route, { path: '/modal', component: (0, _Components2.default)(_ModalPage2.default) }),
					_react2.default.createElement(_reactRouter.Route, { path: '/nav', component: (0, _Components2.default)(_NavPage2.default) }),
					_react2.default.createElement(_reactRouter.Route, { path: '/curtain', component: (0, _Components2.default)(_CurtainPage2.default) }),
					_react2.default.createElement(_reactRouter.Route, { path: '/progress', component: (0, _Components2.default)(_ProgressPage2.default) }),
					_react2.default.createElement(_reactRouter.Route, { path: '/tooltip', component: (0, _Components2.default)(_TooltipPage2.default) }),
					_react2.default.createElement(_reactRouter.Route, { path: '/dynamic_number', component: (0, _Components2.default)(_DynamicNumberPage2.default) }),
					_react2.default.createElement(_reactRouter.Route, { path: '/dynamic_string', component: (0, _Components2.default)(_DynamicStringPage2.default) }),
					_react2.default.createElement(_reactRouter.Route, { path: '/auto_complete', component: (0, _Components2.default)(_AutoCompletePage2.default) }),
					_react2.default.createElement(_reactRouter.Route, { path: '/select', component: (0, _Components2.default)(_SelectPage2.default) }),
					_react2.default.createElement(_reactRouter.Route, { path: '/table', component: (0, _Components2.default)(_TablePage2.default) }),
					_react2.default.createElement(_reactRouter.Route, { path: '/label', component: (0, _Components2.default)(_LabelPage2.default) }),
					_react2.default.createElement(_reactRouter.Route, { path: '/date_picker', component: (0, _Components2.default)(_DatePickerPage2.default) }),
					_react2.default.createElement(_reactRouter.Route, { path: '/pin_box', component: (0, _Components2.default)(_PinBoxPage2.default) }),
					_react2.default.createElement(_reactRouter.Route, { path: '/flat_list', component: (0, _Components2.default)(_FlatListPage2.default) }),
					_react2.default.createElement(_reactRouter.Route, { path: '/input', component: (0, _Components2.default)(_InputPage2.default) })
				)
			);
		}
	}]);

	return Main;
}(_react2.default.Component);

exports.default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)()((0, _reactCssModules2.default)(Main, _index2.default)));

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var NavItem = function NavItem(_ref) {
	var children = _ref.children,
	    onClick = _ref.onClick,
	    active = _ref.active,
	    disabled = _ref.disabled,
	    className = _ref.className,
	    props = _objectWithoutProperties(_ref, ['children', 'onClick', 'active', 'disabled', 'className']);

	return _react2.default.createElement(
		'li',
		_extends({
			className: (0, _classnames2.default)('bmbo-nav-item', active && 'bmbo-active', disabled && 'bmbo-disabled', className),
			role: 'button',
			tabIndex: -1,
			onClick: onClick
		}, props),
		children
	);
};

exports.default = NavItem;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _Loading = __webpack_require__(60);

var _Loading2 = _interopRequireDefault(_Loading);

var _Caret = __webpack_require__(15);

var _Caret2 = _interopRequireDefault(_Caret);

var _Search = __webpack_require__(61);

var _Search2 = _interopRequireDefault(_Search);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Icon = function Icon(_ref) {
	var name = _ref.name,
	    spin = _ref.spin,
	    className = _ref.className;
	return _react2.default.createElement('span', { className: (0, _classnames2.default)('fa fa-' + name + ' bmbo-icon', spin && 'fa-spin', className) });
};

Icon.Loading = _Loading2.default;
Icon.Caret = _Caret2.default;
Icon.Search = _Search2.default;

exports.default = Icon;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.BAMBOO_FORM_RADIO = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _componentUtil = __webpack_require__(4);

var _eventUtil = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BAMBOO_FORM_RADIO = exports.BAMBOO_FORM_RADIO = 'BAMBOO_FORM_RADIO';

var Radio = function (_React$Component) {
	_inherits(Radio, _React$Component);

	function Radio() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, Radio);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Radio.__proto__ || Object.getPrototypeOf(Radio)).call.apply(_ref, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(Radio, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    children = _props.children,
			    checked = _props.checked,
			    className = _props.className,
			    props = _objectWithoutProperties(_props, ['children', 'checked', 'className']);

			delete props.checked;
			delete props.onClick;
			delete props.onChange;
			delete props.value;

			return _react2.default.createElement(
				'div',
				_extends({
					className: (0, _classnames2.default)('bmbo-radio', checked && 'bmbo-checked', className),
					role: 'button',
					tabIndex: 0,
					onClick: this.onClick
				}, props),
				_react2.default.createElement('input', { type: 'radio', checked: checked, readOnly: true }),
				_react2.default.createElement('span', { className: 'bmbo-radio-check' }),
				_react2.default.createElement(
					'div',
					{ className: 'bmbo-radio-content' },
					children
				)
			);
		}
	}]);

	return Radio;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
	var _this2 = this;

	this.onClick = function () {
		var _props2 = _this2.props,
		    onClick = _props2.onClick,
		    onChange = _props2.onChange,
		    value = _props2.value,
		    children = _props2.children;

		var event = arguments.length <= 0 ? undefined : arguments[0];

		if (onClick) onClick.apply(undefined, arguments);
		if (onChange) {
			onChange((0, _eventUtil.wrapperEventValue)(event, event.target, value !== undefined ? value : children));
		}
	};
};

Radio[_componentUtil.BAMBOO_COMPONENT] = BAMBOO_FORM_RADIO;

exports.default = Radio;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.toArray = exports.equals = undefined;

var _pathUtil = __webpack_require__(18);

var equals = exports.equals = function equals() {
	var list1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	var list2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

	var len = list1.length;
	if (len !== list2.length) return false;

	for (var i = 0; i < len; i += 1) {
		var item1 = (0, _pathUtil.getValue)(list1[i], path);
		var item2 = (0, _pathUtil.getValue)(list2[i], path);
		if (item1 !== item2) return false;
	}

	return true;
};

var toArray = exports.toArray = function toArray(value) {
	if (Array.isArray(value)) return value;
	if (!value) return [];
	return [value];
};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(14);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentUtil = __webpack_require__(4);

var _eventUtil = __webpack_require__(10);

var _EmptyWrapper = __webpack_require__(65);

var _EmptyWrapper2 = _interopRequireDefault(_EmptyWrapper);

var _Box = __webpack_require__(66);

var _Box2 = _interopRequireDefault(_Box);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PinBox = function (_React$Component) {
	_inherits(PinBox, _React$Component);

	function PinBox() {
		_classCallCheck(this, PinBox);

		var _this = _possibleConstructorReturn(this, (PinBox.__proto__ || Object.getPrototypeOf(PinBox)).call(this));

		_this.onBackdrop = function (event) {
			if ((0, _eventUtil.isSameSource)(event, (0, _reactDom.findDOMNode)(_this.$ele))) return;

			_this.setState({ visible: false }, _this.onVisibilityChange);
			(0, _eventUtil.removeUniqueListener)('mousedown', _this.onBackdrop);
		};

		_this.onClick = function () {
			var _this$props = _this.props,
			    backdrop = _this$props.backdrop,
			    disabled = _this$props.disabled;


			if (disabled) return;

			_this.setState(function (_ref) {
				var visible = _ref.visible;

				var newState = { visible: !visible };

				if (newState.visible && _this.$ele) {
					/** Use `findDOMNode` to support customize component.
      ** To avoid user need to support setRef for this component.
      **/
					newState.rect = (0, _reactDom.findDOMNode)(_this.$ele) // eslint-disable-line react/no-find-dom-node
					.getBoundingClientRect();

					if (backdrop) {
						(0, _eventUtil.addUniqueListener)('mousedown', _this.onBackdrop);
					}
				}

				return newState;
			}, _this.onVisibilityChange);
		};

		_this.onVisibilityChange = function () {
			var onVisibilityChange = _this.props.onVisibilityChange;
			var visible = _this.state.visible;


			if (onVisibilityChange) onVisibilityChange(visible);
		};

		_this.setRef = function (ele) {
			_this.$ele = ele;
		};

		_this.setVisible = function (visible) {
			_this.setState({ visible: visible }, _this.onVisibilityChange);
		};

		_this.state = {
			visible: false
		};
		return _this;
	}

	_createClass(PinBox, [{
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			(0, _eventUtil.removeUniqueListener)('mousedown', this.onBackdrop);
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    trigger = _props.trigger,
			    children = _props.children,
			    pin = _props.pin,
			    stretch = _props.stretch,
			    onVisibilityChanged = _props.onVisibilityChanged,
			    props = _objectWithoutProperties(_props, ['trigger', 'children', 'pin', 'stretch', 'onVisibilityChanged']);

			var _state = this.state,
			    visible = _state.visible,
			    rect = _state.rect;


			delete props.onVisibilityChange;
			delete props.backdrop;

			var $children = (0, _componentUtil.mapChildrenForNode)(children, function (node) {
				var onClick = node.props.onClick,
				    _ref2 = node.ref;

				var newProps = {
					ref: function ref() {
						if (_ref2) _ref2.apply(undefined, arguments);
						_this2.setRef.apply(_this2, arguments);
					}
				};

				if (!trigger || trigger === 'click') {
					// Click Trigger
					newProps.onClick = function () {
						if (onClick) onClick.apply(undefined, arguments);
						_this2.onClick.apply(_this2, arguments);
					};
				} else {
					console.warn('[PinBox] Trigger not realize:', trigger);
				}

				// Transform children to class component to avoid stateless function can't use ref
				return _react2.default.createElement(
					_EmptyWrapper2.default,
					newProps,
					node
				);
			});

			return [].concat(_toConsumableArray($children), [pin ? _react2.default.createElement(
				_Box2.default,
				_extends({
					key: '__BMBO_PIN_BOX_BOX__'
				}, props, {
					visible: visible,
					rect: rect,
					stretch: stretch,
					onVisibilityChanged: onVisibilityChanged
				}),
				pin
			) : null]);
		}
	}]);

	return PinBox;
}(_react2.default.Component);

exports.default = PinBox;

/***/ }),
/* 28 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"curtain":"bmbo_curtain_224b5","curtain-sample":"bmbo_curtain-sample_1NrMY"};

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(7))(40);

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _HorizontalNav = __webpack_require__(55);

var _HorizontalNav2 = _interopRequireDefault(_HorizontalNav);

var _VerticalNav = __webpack_require__(56);

var _VerticalNav2 = _interopRequireDefault(_VerticalNav);

var _NavGroup = __webpack_require__(57);

var _NavGroup2 = _interopRequireDefault(_NavGroup);

var _NavItem = __webpack_require__(23);

var _NavItem2 = _interopRequireDefault(_NavItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Nav = function (_React$Component) {
	_inherits(Nav, _React$Component);

	function Nav() {
		_classCallCheck(this, Nav);

		return _possibleConstructorReturn(this, (Nav.__proto__ || Object.getPrototypeOf(Nav)).apply(this, arguments));
	}

	_createClass(Nav, [{
		key: 'getChildContext',
		value: function getChildContext() {
			return {
				navType: this.props.type,
				navVertical: this.props.vertical,
				navInline: this.props.inline
			};
		}
	}, {
		key: 'render',
		value: function render() {
			var _props = this.props,
			    vertical = _props.vertical,
			    props = _objectWithoutProperties(_props, ['vertical']);

			delete props.inline;

			if (vertical) return _react2.default.createElement(_VerticalNav2.default, props);
			return _react2.default.createElement(_HorizontalNav2.default, props);
		}
	}]);

	return Nav;
}(_react2.default.Component);

Nav.childContextTypes = {
	navType: _propTypes2.default.string,
	navVertical: _propTypes2.default.bool,
	navInline: _propTypes2.default.bool
};

Nav.Group = _NavGroup2.default;
Nav.Item = _NavItem2.default;

exports.default = Nav;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var REGEX = /^(\d+)\/(\d+)$/;

function getMatch(numerator, denominator, total) {
	var multiple = total / denominator;
	if (multiple !== Math.floor(multiple)) return null;

	return numerator * multiple + '-' + total;
}

function getName(prefix, val) {
	if (!val) return '';
	if (val === '0') return prefix + '0';

	var myVal = val === '1' ? '1/1' : val;
	var match = Array.isArray(myVal) ? [null].concat(_toConsumableArray(myVal)) : myVal.match(REGEX);

	// Return full row if not match
	if (!match) return '10-10';

	var numerator = Number(match[1]);
	var denominator = Number(match[2]);

	var cal = getMatch(numerator, denominator, 24) || getMatch(numerator, denominator, 10);
	return '' + prefix + cal;
}

var Col = function Col(props, context) {
	var xs = props.xs,
	    sm = props.sm,
	    md = props.md,
	    lg = props.lg,
	    xl = props.xl,
	    xsOffset = props.xsOffset,
	    smOffset = props.smOffset,
	    mdOffset = props.mdOffset,
	    lgOffset = props.lgOffset,
	    xlOffset = props.xlOffset,
	    children = props.children,
	    className = props.className,
	    rest = _objectWithoutProperties(props, ['xs', 'sm', 'md', 'lg', 'xl', 'xsOffset', 'smOffset', 'mdOffset', 'lgOffset', 'xlOffset', 'children', 'className']);

	var rowGutter = context.rowGutter;


	var xsClassName = getName('bmbo-col-xs-', xs);
	var smClassName = getName('bmbo-col-sm-', sm);
	var mdClassName = getName('bmbo-col-md-', md);
	var lgClassName = getName('bmbo-col-lg-', lg);
	var xlClassName = getName('bmbo-col-xl-', xl);

	var xsOffsetClassName = getName('bmbo-col-xs-offset-', xsOffset);
	var smOffsetClassName = getName('bmbo-col-sm-offset-', smOffset);
	var mdOffsetClassName = getName('bmbo-col-md-offset-', mdOffset);
	var lgOffsetClassName = getName('bmbo-col-lg-offset-', lgOffset);
	var xlOffsetClassName = getName('bmbo-col-xl-offset-', xlOffset);

	var hg = rowGutter / 2;

	return _react2.default.createElement(
		'div',
		_extends({
			className: (0, _classnames2.default)('bmbo-col', xsClassName, smClassName, mdClassName, lgClassName, xlClassName, xsOffsetClassName, smOffsetClassName, mdOffsetClassName, lgOffsetClassName, xlOffsetClassName, className),
			style: { paddingLeft: hg + 'px', paddingRight: hg + 'px' }
		}, rest),
		children
	);
};

Col.contextTypes = {
	rowGutter: _propTypes2.default.number
};

exports.default = Col;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _Radio = __webpack_require__(25);

var _Checkbox = __webpack_require__(13);

var _Input = __webpack_require__(17);

var _componentUtil = __webpack_require__(4);

var _pathUtil = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Field = function (_React$Component) {
	_inherits(Field, _React$Component);

	function Field() {
		_classCallCheck(this, Field);

		var _this = _possibleConstructorReturn(this, (Field.__proto__ || Object.getPrototypeOf(Field)).call(this));

		_this.getPath = function () {
			var formPath = _this.context.formPath;
			var name = _this.props.name;


			return [].concat(_toConsumableArray(formPath), [Array.isArray(name) ? name : [name]]);
		};

		_this.getValue = function () {
			var formInstance = _this.context.formInstance;


			if ('value' in _this.props) {
				return _this.props.value;
			}

			if (formInstance) {
				return (0, _pathUtil.getValue)(formInstance, ['state'].concat(_toConsumableArray(_this.getPath())));
			}
			return _this.state.value;
		};

		_this.getList = function () {
			var _this$context = _this.context,
			    formInstance = _this$context.formInstance,
			    onFormChanged = _this$context.onFormChanged;
			var _this$props = _this.props,
			    title = _this$props.title,
			    children = _this$props.children;

			var myValue = _this.getValue();

			return (0, _componentUtil.mapChildrenForNode)(children, function (node) {
				var _node$props = node.props,
				    props = _node$props === undefined ? {} : _node$props;


				if (node.type[_componentUtil.BAMBOO_COMPONENT] === _Radio.BAMBOO_FORM_RADIO) {
					// ==================== Radio ====================
					var nodeValue = props.value !== undefined ? props.value : props.children;

					return _react2.default.cloneElement(node, {
						'aria-label': props.ariaLabel || title,
						onClick: function onClick() {
							if (props.onClick) props.onClick.apply(props, arguments);

							if (formInstance) {
								formInstance.setState(function (preState) {
									return (0, _pathUtil.updateValue)(preState, _this.getPath(), function () {
										return nodeValue;
									});
								}, onFormChanged);
							} else {
								_this.setState({ value: nodeValue }, onFormChanged);
							}
						},
						checked: myValue === nodeValue
					});
				} else if (node.type[_componentUtil.BAMBOO_COMPONENT] === _Checkbox.BAMBOO_FORM_CHECKBOX) {
					// ================== Check Box ==================
					return _react2.default.cloneElement(node, {
						'aria-label': props.ariaLabel || title,
						onClick: function onClick() {
							if (props.onClick) props.onClick.apply(props, arguments);

							if (formInstance) {
								formInstance.setState(function (preState) {
									return (0, _pathUtil.updateValue)(preState, _this.getPath(), function (value) {
										return !value;
									});
								}, onFormChanged);
							} else {
								_this.setState(function (_ref) {
									var value = _ref.value;
									return { value: !value };
								}, onFormChanged);
							}
						},
						checked: myValue
					});
				} else if (node.type[_componentUtil.BAMBOO_COMPONENT] === _Input.BAMBOO_FORM_INPUT) {
					// ==================== Input ====================
					return _react2.default.cloneElement(node, {
						value: props.value !== undefined ? props.value : myValue,
						'aria-label': props.ariaLabel || title,
						onChange: function onChange() {
							for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
								args[_key] = arguments[_key];
							}

							if (props.onChange) props.onChange.apply(props, args);

							var newVal = args[0].target.value;

							if (props.type === 'number') newVal = Number(newVal);

							if (formInstance) {
								formInstance.setState(function (preState) {
									return (0, _pathUtil.updateValue)(preState, _this.getPath(), function () {
										return newVal;
									});
								}, onFormChanged);
							} else {
								_this.setState({ value: newVal }, onFormChanged);
							}
						}
					});
				}

				// ==================== Rest =====================
				return _react2.default.cloneElement(node, {
					value: myValue,
					'aria-label': props.ariaLabel || title,
					onChange: function onChange() {
						for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
							args[_key2] = arguments[_key2];
						}

						if (props.onChange) props.onChange.apply(props, args);

						var newVal = args[0].target.value;

						if (formInstance) {
							formInstance.setState(function (preState) {
								return (0, _pathUtil.updateValue)(preState, _this.getPath(), function () {
									return newVal;
								});
							}, onFormChanged);
						} else {
							_this.setState({ value: newVal }, onFormChanged);
						}
					}
				});
			});
		};

		_this.state = {
			value: null
		};
		return _this;
	}

	_createClass(Field, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			var defaultValue = this.props.defaultValue;

			this.setState({ value: defaultValue });
		}
	}, {
		key: 'render',
		value: function render() {
			var _props = this.props,
			    name = _props.name,
			    title = _props.title,
			    className = _props.className,
			    props = _objectWithoutProperties(_props, ['name', 'title', 'className']);

			delete props.value;
			delete props.defaultValue;

			var list = this.getList();

			return _react2.default.createElement(
				'div',
				_extends({ className: (0, _classnames2.default)('bmbp-form-field', className) }, props),
				title !== undefined && _react2.default.createElement(
					'label',
					{ htmlFor: name },
					title
				),
				list
			);
		}
	}]);

	return Field;
}(_react2.default.Component);

Field.contextTypes = {
	formInstance: _propTypes2.default.object,
	formPath: _propTypes2.default.array,
	onFormChanged: _propTypes2.default.func
};

exports.default = Field;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _eventUtil = __webpack_require__(10);

var _arrayUtil = __webpack_require__(26);

var _Caret = __webpack_require__(15);

var _Caret2 = _interopRequireDefault(_Caret);

var _Checkbox = __webpack_require__(13);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _PinBox = __webpack_require__(27);

var _PinBox2 = _interopRequireDefault(_PinBox);

var _SelectOption = __webpack_require__(34);

var _SelectOption2 = _interopRequireDefault(_SelectOption);

var _SelectGroup = __webpack_require__(67);

var _SelectGroup2 = _interopRequireDefault(_SelectGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getTitle(optionList, value) {
	var option = optionList.find(function (opt) {
		return opt.value === value;
	});
	if (!option) return null;

	return option.title;
}

var Select = function (_React$Component) {
	_inherits(Select, _React$Component);

	function Select() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, Select);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Select.__proto__ || Object.getPrototypeOf(Select)).call.apply(_ref, [this].concat(args))), _this), _this.onSelectValue = function (value, event) {
			var _this$props = _this.props,
			    onChange = _this$props.onChange,
			    multi = _this$props.multi,
			    oriValue = _this$props.value;


			var newValue = void 0;
			if (multi) {
				newValue = oriValue;
				if (!Array.isArray(newValue)) {
					newValue = newValue ? [newValue] : [];
				}

				if (newValue.includes(value)) {
					newValue = newValue.filter(function (v) {
						return v !== value;
					});
				} else {
					newValue = [].concat(_toConsumableArray(newValue), [value]);
				}
			} else {
				newValue = value;
			}

			if (onChange) {
				onChange((0, _eventUtil.wrapperEventValue)(event, _this.$ele, newValue));
			}

			if (!multi && _this.$pin) {
				_this.$pin.setVisible(false);
			}
		}, _this.onSelectValues = function (event, valueList, checked) {
			var _this$props2 = _this.props,
			    children = _this$props2.children,
			    value = _this$props2.value,
			    onChange = _this$props2.onChange;

			var myList = valueList || (0, _SelectGroup.getValueList)(children);
			var myChecked = checked !== undefined ? checked : !_this.isAllValueChecked();
			var newValue = [].concat(_toConsumableArray((0, _arrayUtil.toArray)(value)));

			if (myChecked) {
				myList.forEach(function (val) {
					if (!newValue.includes(val)) {
						newValue.push(val);
					}
				});
			} else {
				newValue = newValue.filter(function (val) {
					return !myList.includes(val);
				});
			}

			if (onChange) {
				onChange((0, _eventUtil.wrapperEventValue)(event, _this.$ele, newValue));
			}
		}, _this.onSelectAllValue = function (event) {
			_this.onSelectValues(event);
		}, _this.setRef = function (ele) {
			_this.$ele = ele;
		}, _this.setPinRef = function (ele) {
			_this.$pin = ele;
		}, _this.isValueChecked = function (val) {
			var value = _this.props.value;

			return (0, _arrayUtil.toArray)(value).includes(val);
		}, _this.isAllValueChecked = function () {
			var _this$props3 = _this.props,
			    value = _this$props3.value,
			    children = _this$props3.children;

			var myValue = (0, _arrayUtil.toArray)(value);

			var allValueList = (0, _SelectGroup.getValueList)(children);
			return allValueList.every(function (val) {
				return myValue.includes(val);
			});
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(Select, [{
		key: 'getChildContext',
		value: function getChildContext() {
			return {
				bmboSelectSize: this.props.size,
				bmboSelectMulti: this.props.multi,
				bmboSelectDisabled: this.props.disabled,
				bmboOnSelectValue: this.onSelectValue,
				bmboOnSelectValues: this.onSelectValues,
				bmboSelectIsChecked: this.isValueChecked,
				bmboSelectIsAllChecked: this.isAllValueChecked
			};
		}
	}, {
		key: 'render',
		value: function render() {
			var _props = this.props,
			    disabled = _props.disabled,
			    size = _props.size,
			    title = _props.title,
			    className = _props.className,
			    value = _props.value,
			    multi = _props.multi,
			    flatten = _props.flatten,
			    noSelectAll = _props.noSelectAll,
			    children = _props.children,
			    props = _objectWithoutProperties(_props, ['disabled', 'size', 'title', 'className', 'value', 'multi', 'flatten', 'noSelectAll', 'children']);

			delete props.onChange;

			// =============================== Value ===============================
			var optionList = (0, _SelectGroup.getNodeList)(children);

			var $value = void 0;
			if (title !== undefined) {
				$value = title || '\xA0';
			} else if (multi) {
				var valueList = (0, _arrayUtil.toArray)(value);
				$value = _react2.default.createElement(
					'ul',
					{ className: 'bmbo-list-inline' },
					valueList.map(function (val) {
						return _react2.default.createElement(
							'li',
							{ key: val },
							getTitle(optionList, val)
						);
					}),
					!valueList.length && _react2.default.createElement(
						'li',
						null,
						'\xA0'
					)
				);
			} else {
				$value = getTitle(optionList, value) || '\xA0';
			}

			// ================================ List ===============================
			var canSelectAll = !noSelectAll && optionList.every(function (opt) {
				return !opt.disabled;
			});

			var $list = _react2.default.createElement(
				'ul',
				{
					className: (0, _classnames2.default)('bmbo-select-list', 'bmbo-list-unstyled', 'bmbo-' + (size || 'md'))
				},
				multi && canSelectAll && _react2.default.createElement(
					'li',
					{
						className: 'bmbo-select-item bmbo-padding bmbo-select-item-all',
						onClick: this.onSelectAllValue,
						role: 'button',
						tabIndex: -1
					},
					_react2.default.createElement(
						_Checkbox2.default,
						{ size: size, checked: this.isAllValueChecked() },
						'Select All'
					)
				),
				children
			);

			// =============================== Render ==============================
			if (multi && flatten) {
				return _react2.default.createElement(
					'div',
					_extends({
						className: (0, _classnames2.default)('bmbo-select', 'bmbo-select-flatten', disabled && 'bmbo-disabled')
					}, props, {
						ref: this.setRef
					}),
					$list
				);
			}

			return _react2.default.createElement(
				_PinBox2.default,
				{ pin: $list, ref: this.setPinRef, disabled: disabled, backdrop: true, stretch: true },
				_react2.default.createElement(
					'div',
					_extends({
						className: (0, _classnames2.default)('bmbo-select', disabled && 'bmbo-disabled')
					}, props, {
						ref: this.setRef
					}),
					_react2.default.createElement(
						'div',
						{
							className: (0, _classnames2.default)('bmbo-select-value', 'bmbo-' + (size || 'md'), className),

							role: 'button',
							tabIndex: 0
						},
						$value,
						_react2.default.createElement(_Caret2.default, { direct: 'down' })
					)
				)
			);
		}
	}]);

	return Select;
}(_react2.default.Component);

Select.childContextTypes = {
	bmboSelectSize: _propTypes2.default.string,
	bmboSelectMulti: _propTypes2.default.bool,
	bmboSelectDisabled: _propTypes2.default.bool,
	bmboSelectIsChecked: _propTypes2.default.func,
	bmboSelectIsAllChecked: _propTypes2.default.func,
	bmboOnSelectValue: _propTypes2.default.func,
	bmboOnSelectValues: _propTypes2.default.func
};

Select.Option = _SelectOption2.default;
Select.Group = _SelectGroup2.default;

exports.default = Select;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.BAMBOO_FORM_SELECT_OPTION = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _componentUtil = __webpack_require__(4);

var _Checkbox = __webpack_require__(13);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BAMBOO_FORM_SELECT_OPTION = exports.BAMBOO_FORM_SELECT_OPTION = 'BAMBOO_FORM_SELECT_OPTION';

var SelectOption = function (_React$Component) {
	_inherits(SelectOption, _React$Component);

	function SelectOption() {
		_classCallCheck(this, SelectOption);

		var _this = _possibleConstructorReturn(this, (SelectOption.__proto__ || Object.getPrototypeOf(SelectOption)).call(this));

		_this.onClick = function () {
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}

			var _this$props = _this.props,
			    onClick = _this$props.onClick,
			    value = _this$props.value,
			    children = _this$props.children;
			var bmboOnSelectValue = _this.context.bmboOnSelectValue;


			var myVal = value !== undefined ? value : children;

			if (bmboOnSelectValue) bmboOnSelectValue.apply(undefined, [myVal].concat(args));
			if (onClick) onClick.apply(undefined, args);
		};

		_this.state = {};
		return _this;
	}

	_createClass(SelectOption, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    disabled = _props.disabled,
			    value = _props.value,
			    children = _props.children,
			    props = _objectWithoutProperties(_props, ['disabled', 'value', 'children']);

			var _context = this.context,
			    bmboSelectMulti = _context.bmboSelectMulti,
			    bmboSelectDisabled = _context.bmboSelectDisabled,
			    bmboSelectSize = _context.bmboSelectSize,
			    bmboSelectIsChecked = _context.bmboSelectIsChecked;


			var myDisabled = void 0;
			if (disabled !== undefined) {
				myDisabled = disabled;
			} else if (bmboSelectDisabled !== undefined) {
				myDisabled = bmboSelectDisabled;
			}

			var $children = children;
			if (bmboSelectMulti) {
				$children = _react2.default.createElement(
					_Checkbox2.default,
					{
						size: bmboSelectSize,
						checked: bmboSelectIsChecked(value || children),
						disabled: myDisabled
					},
					children
				);
			}

			return _react2.default.createElement(
				'li',
				_extends({
					role: 'button',
					tabIndex: -1,
					className: (0, _classnames2.default)('bmbo-select-item bmbo-padding', myDisabled && 'bmbo-disabled')
				}, props, {
					onClick: myDisabled ? null : this.onClick
				}),
				$children
			);
		}
	}]);

	return SelectOption;
}(_react2.default.Component);

SelectOption.contextTypes = {
	bmboSelectSize: _propTypes2.default.string,
	bmboSelectMulti: _propTypes2.default.bool,
	bmboSelectDisabled: _propTypes2.default.bool,
	bmboOnSelectValue: _propTypes2.default.func,
	bmboSelectIsChecked: _propTypes2.default.func
};

SelectOption[_componentUtil.BAMBOO_COMPONENT] = BAMBOO_FORM_SELECT_OPTION;

exports.default = SelectOption;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _uiUtil = __webpack_require__(8);

var _Sequence = __webpack_require__(9);

var _Sequence2 = _interopRequireDefault(_Sequence);

var _MenuItem = __webpack_require__(69);

var _MenuItem2 = _interopRequireDefault(_MenuItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MenuList = function (_React$Component) {
	_inherits(MenuList, _React$Component);

	function MenuList() {
		_classCallCheck(this, MenuList);

		var _this = _possibleConstructorReturn(this, (MenuList.__proto__ || Object.getPrototypeOf(MenuList)).call(this));

		_this.onMouseDown = function (event) {
			event.stopPropagation();
		};

		_this.setRef = function (ele) {
			_this.$list = ele;
		};

		_this.state = {
			animateStatus: _uiUtil.ANIMATE_STATUS_NONE
		};
		_this.seq = new _Sequence2.default();
		return _this;
	}

	_createClass(MenuList, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var _this2 = this;

			var _props = this.props,
			    x = _props.x,
			    y = _props.y,
			    _props$width = _props.width,
			    width = _props$width === undefined ? 0 : _props$width,
			    _props$height = _props.height,
			    height = _props$height === undefined ? 0 : _props$height;

			var rect = this.$list.getBoundingClientRect();

			this.seq.next(function () {
				_this2.setState(_extends({}, (0, _uiUtil.getEnablePosition)({ left: x, top: y, width: width, height: height }, rect, 'r'), {
					animateStatus: _uiUtil.ANIMATE_STATUS_SHOWING
				}));
			}).next(function () {
				_this2.setState({
					animateStatus: _uiUtil.ANIMATE_STATUS_SHOWN
				});
			});
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.seq.destroy();
		}
	}, {
		key: 'render',
		value: function render() {
			var _props$list = this.props.list,
			    list = _props$list === undefined ? [] : _props$list;
			var menuSize = this.context.menuSize;
			var _state = this.state,
			    x = _state.x,
			    y = _state.y,
			    animateStatus = _state.animateStatus;


			return (0, _uiUtil.createPortal)(_react2.default.createElement(
				'ul',
				{
					ref: this.setRef,
					className: (0, _classnames2.default)('bmbo-box-absolute', 'bmbo-menu-list', {
						'bmbo-hidden': animateStatus === _uiUtil.ANIMATE_STATUS_NONE,
						'bmbo-showing': animateStatus === _uiUtil.ANIMATE_STATUS_SHOWING
					}, 'bmbo-' + (menuSize || 'md')),
					style: { left: x + 'px', top: y + 'px' },
					role: 'presentation',
					tabIndex: -1,
					onMouseDown: this.onMouseDown
				},
				list.map(function (item, index) {
					if (!item) return null;
					return _react2.default.createElement(_MenuItem2.default, { key: index, item: item });
				})
			));
		}
	}]);

	return MenuList;
}(_react2.default.Component);

MenuList.contextTypes = {
	menuSize: _propTypes2.default.string
};

exports.default = MenuList;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _componentUtil = __webpack_require__(4);

var _Item = __webpack_require__(37);

var _Item2 = _interopRequireDefault(_Item);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Group = function Group(_ref) {
	var children = _ref.children,
	    value = _ref.value,
	    onChange = _ref.onChange,
	    _ref$style = _ref.style,
	    style = _ref$style === undefined ? {} : _ref$style,
	    width = _ref.width,
	    className = _ref.className,
	    props = _objectWithoutProperties(_ref, ['children', 'value', 'onChange', 'style', 'width', 'className']);

	var myStyle = _extends({}, style);
	if (width) myStyle.width = width;

	// Wrap component with Item
	var itemList = (0, _componentUtil.mapChildrenForNode)(children, function (node) {
		var item = node;
		if (!node.type || node.type[_componentUtil.BAMBOO_COMPONENT] !== _Item.BAMBOO_GROUP_ITEM) {
			item = _react2.default.createElement(
				_Item2.default,
				null,
				node
			);
		}

		return item;
	}).filter(function (n) {
		return n;
	});
	var count = itemList.length;

	// Mark first & last Item
	var $children = itemList.map(function (node, index) {
		return _react2.default.cloneElement(node, {
			isFirst: index === 0,
			isLast: index === count - 1,
			value: value,
			onChange: onChange
		});
	});

	return _react2.default.createElement(
		'div',
		_extends({
			className: (0, _classnames2.default)('bmbo-group', className),
			style: myStyle
		}, props),
		$children
	);
};

Group.Item = _Item2.default;

exports.default = Group;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.BAMBOO_GROUP_ITEM = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _componentUtil = __webpack_require__(4);

var _eventUtil = __webpack_require__(10);

var _Button = __webpack_require__(16);

var _Button2 = _interopRequireDefault(_Button);

var _Radio = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BAMBOO_GROUP_ITEM = exports.BAMBOO_GROUP_ITEM = 'BAMBOO_GROUP_ITEM';

var Item = function (_React$Component) {
	_inherits(Item, _React$Component);

	function Item() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, Item);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Item.__proto__ || Object.getPrototypeOf(Item)).call.apply(_ref, [this].concat(args))), _this), _this.setRef = function (ele) {
			_this.$ele = ele;
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(Item, [{
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    _props$style = _props.style,
			    style = _props$style === undefined ? {} : _props$style,
			    width = _props.width,
			    children = _props.children,
			    isFirst = _props.isFirst,
			    isLast = _props.isLast,
			    value = _props.value,
			    onChange = _props.onChange,
			    className = _props.className,
			    props = _objectWithoutProperties(_props, ['style', 'width', 'children', 'isFirst', 'isLast', 'value', 'onChange', 'className']);

			if (width) style.width = width;

			var $child = _react2.default.Children.only(children);

			if (_react2.default.isValidElement($child) && $child.type && $child.type[_componentUtil.BAMBOO_COMPONENT] === _Radio.BAMBOO_FORM_RADIO) {
				var _$child$props = $child.props,
				    _onClick = _$child$props.onClick,
				    type = _$child$props.type,
				    transparent = _$child$props.transparent,
				    restProps = _objectWithoutProperties(_$child$props, ['onClick', 'type', 'transparent']);

				var checked = restProps.value === value;

				$child = _react2.default.createElement(_Button2.default, _extends({
					checked: checked,
					type: checked || !transparent ? type : 'weak',
					transparent: transparent
				}, restProps, {
					ref: this.setRef,
					onClick: function onClick() {
						var event = arguments.length <= 0 ? undefined : arguments[0];
						if (onChange) onChange((0, _eventUtil.wrapperEventValue)(event, _this2.$ele, restProps.value));
						if (_onClick) _onClick.apply(undefined, arguments);
					}
				}));
			}

			return _react2.default.createElement(
				'div',
				_extends({
					className: (0, _classnames2.default)('bmbo-group-item', {
						'bmbo-first': isFirst && !isLast,
						'bmbo-last': isLast && !isFirst,
						'bmbo-middle': !isFirst && !isLast,
						className: className
					}),
					style: style
				}, props),
				$child
			);
		}
	}]);

	return Item;
}(_react2.default.Component);

Item[_componentUtil.BAMBOO_COMPONENT] = BAMBOO_GROUP_ITEM;

exports.default = Item;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _uiUtil = __webpack_require__(8);

var _envUtil = __webpack_require__(11);

var _componentUtil = __webpack_require__(4);

var _Sequence = __webpack_require__(9);

var _Sequence2 = _interopRequireDefault(_Sequence);

var _ModalTitle = __webpack_require__(72);

var _ModalTitle2 = _interopRequireDefault(_ModalTitle);

var _ModalContent = __webpack_require__(73);

var _ModalContent2 = _interopRequireDefault(_ModalContent);

var _ModalFooter = __webpack_require__(74);

var _ModalFooter2 = _interopRequireDefault(_ModalFooter);

var _ModalPreface = __webpack_require__(75);

var _ModalPreface2 = _interopRequireDefault(_ModalPreface);

var _ModalLoading = __webpack_require__(76);

var _ModalLoading2 = _interopRequireDefault(_ModalLoading);

var _Button = __webpack_require__(16);

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var modalList = [];

// ========================================================
// =                          UI                          =
// ========================================================
function refreshWinScrollBar() {
	if (!_envUtil.canUseDOM) return;

	var hasActiveModal = modalList.some(function (_ref) {
		var _ref$state = _ref.state;
		_ref$state = _ref$state === undefined ? {} : _ref$state;
		var animateStatus = _ref$state.animateStatus;
		return animateStatus !== _uiUtil.ANIMATE_STATUS_NONE;
	});

	if (hasActiveModal) {
		(0, _uiUtil.disableWinScrollBar)('Modal');
	} else {
		(0, _uiUtil.enableWinScrollBar)('Modal');
	}
}

// ========================================================
// =                         Modal                        =
// ========================================================

var Modal = function (_React$Component) {
	_inherits(Modal, _React$Component);

	function Modal() {
		_classCallCheck(this, Modal);

		var _this = _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).call(this));

		_this.onBackgroundClick = function () {
			var noMaskClose = _this.props.noMaskClose;

			if (noMaskClose) return;

			// Put close request in next frame
			_this.closeSeq.next(function () {
				var onClose = _this.props.onClose;

				if (onClose) onClose();
			});
		};

		_this.onHolderClick = function () {
			// Occupy the close request if is holder click
			_this.closeSeq.next(function () {}, { priority: 1 });
		};

		_this.onTransitionEnd = function (event) {
			var onClosed = _this.props.onClosed;
			var animateStatus = _this.state.animateStatus;


			if (event.target === _this.$holder && animateStatus === _uiUtil.ANIMATE_STATUS_HIDING) {
				if (onClosed) onClosed(event);

				_this.seq.next(function () {
					_this.setState({
						animateStatus: _uiUtil.ANIMATE_STATUS_NONE
					}, refreshWinScrollBar);
				});
			}
		};

		_this.setHolderRef = function (ele) {
			_this.$holder = ele;
		};

		_this.getTitle = function () {
			var _this$props = _this.props,
			    children = _this$props.children,
			    title = _this$props.title;


			if (title) return _react2.default.createElement(
				_ModalTitle2.default,
				null,
				title
			);
			return (0, _componentUtil.mapChildrenByType)(children, _ModalTitle.BAMBOO_MODAL_TITLE);
		};

		_this.getBody = function () {
			var _this$props2 = _this.props,
			    children = _this$props2.children,
			    content = _this$props2.content;


			if (content) return _react2.default.createElement(
				_ModalContent2.default,
				null,
				content
			);

			var $children = (0, _componentUtil.mapChildrenByType)(children, _ModalContent.BAMBOO_MODAL_CONTENT);
			if ($children.length) return $children;

			return _react2.default.createElement(
				_ModalContent2.default,
				null,
				(0, _componentUtil.mapChildrenByNotType)(children, [_ModalTitle.BAMBOO_MODAL_TITLE, _ModalFooter.BAMBOO_MODAL_FOOTER, _ModalPreface.BAMBOO_MODAL_PREFACE, _ModalLoading.BAMBOO_MODAL_LOADING])
			);
		};

		_this.getFooter = function () {
			var _this$props3 = _this.props,
			    children = _this$props3.children,
			    footer = _this$props3.footer,
			    onClose = _this$props3.onClose,
			    onConfirm = _this$props3.onConfirm,
			    _this$props3$closeTex = _this$props3.closeText,
			    closeText = _this$props3$closeTex === undefined ? 'Close' : _this$props3$closeTex,
			    _this$props3$confirmT = _this$props3.confirmText,
			    confirmText = _this$props3$confirmT === undefined ? 'Confirm' : _this$props3$confirmT,
			    lock = _this$props3.lock;


			if (footer) return _react2.default.createElement(
				_ModalFooter2.default,
				null,
				footer
			);

			var $footer = (0, _componentUtil.mapChildrenByType)(children, _ModalFooter.BAMBOO_MODAL_FOOTER);
			if ($footer.length) return $footer;

			return _react2.default.createElement(
				_ModalFooter2.default,
				null,
				_react2.default.createElement(
					_Button2.default,
					{ type: 'weak', onClick: onClose, disabled: lock, transparent: true },
					closeText
				),
				onConfirm && _react2.default.createElement(
					_Button2.default,
					{ onClick: onConfirm, disabled: lock },
					confirmText
				)
			);
		};

		_this.getLoading = function () {
			var children = _this.props.children;

			var $loading = (0, _componentUtil.mapChildrenByType)(children, _ModalLoading.BAMBOO_MODAL_LOADING);

			if ($loading.length) return $loading;

			return _react2.default.createElement(_ModalLoading2.default, { defaultView: true });
		};

		_this.getPreface = function () {
			var _this$props4 = _this.props,
			    children = _this$props4.children,
			    visible = _this$props4.visible;

			return (0, _componentUtil.mapChildrenByType)(children, _ModalPreface.BAMBOO_MODAL_PREFACE, function (node) {
				return _react2.default.cloneElement(node, { visible: visible });
			});
		};

		_this.checkUpdate = function (prevProps, nextProps) {
			// Process when visibility changed
			if (!prevProps.visible !== !nextProps.visible) {
				if (nextProps.visible) {
					// Show modal
					_this.seq.next(function () {
						_this.setState({
							animateStatus: _uiUtil.ANIMATE_STATUS_SHOWING
						}, refreshWinScrollBar);
					}).next(function () {
						_this.setState({ animateStatus: _uiUtil.ANIMATE_STATUS_SHOWN });
					});
				} else {
					// Hide modal
					_this.seq.next(function () {
						_this.setState({
							animateStatus: _uiUtil.ANIMATE_STATUS_HIDING
						});
					}).next(function () {
						// Clean up when browser not support transitionEnd event
						var onClosed = _this.props.onClosed;

						_this.setState({ animateStatus: _uiUtil.ANIMATE_STATUS_NONE }, refreshWinScrollBar);

						if (onClosed) onClosed();
					}, { delay: 750 });
				}
			}
		};

		_this.state = {
			animateStatus: _uiUtil.ANIMATE_STATUS_NONE
		};

		_this.seq = new _Sequence2.default();
		_this.closeSeq = new _Sequence2.default();
		return _this;
	}

	_createClass(Modal, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			modalList.push(this);
			this.checkUpdate({}, this.props);
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			this.checkUpdate(this.props, nextProps);
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			var _this2 = this;

			this.seq.destroy();
			modalList = modalList.filter(function (mdl) {
				return mdl !== _this2;
			});
			refreshWinScrollBar();
		}
	}, {
		key: 'render',
		value: function render() {
			var _props = this.props,
			    size = _props.size,
			    type = _props.type,
			    loading = _props.loading,
			    className = _props.className,
			    props = _objectWithoutProperties(_props, ['size', 'type', 'loading', 'className']);

			var animateStatus = this.state.animateStatus;


			if (animateStatus === _uiUtil.ANIMATE_STATUS_NONE) return null;

			var $title = this.getTitle();
			var $body = this.getBody();
			var $footer = this.getFooter();
			var $preface = this.getPreface();
			var $loading = this.getLoading();

			var $modal = _react2.default.createElement(
				'div',
				{ className: 'bmbo-dialog' },
				$title,
				$body,
				$footer,
				$loading
			);

			delete props.visible;
			delete props.lock;
			delete props.title;
			delete props.content;
			delete props.footer;
			delete props.onClose;
			delete props.onClosed;
			delete props.onConfirm;
			delete props.closeText;
			delete props.confirmText;
			delete props.noMaskClose;

			return (0, _uiUtil.createPortal)(_react2.default.createElement(
				'div',
				_extends({}, props, {
					className: (0, _classnames2.default)('bmbo-modal', {
						'bmbo-showing': animateStatus === _uiUtil.ANIMATE_STATUS_SHOWING,
						'bmbo-hidding': animateStatus === _uiUtil.ANIMATE_STATUS_HIDING,
						'bmbo-loading': loading,
						className: className
					}, 'bmbo-modal-' + (size || 'md'), type && 'bmbo-' + type),
					role: 'presentation',
					onClick: this.onBackgroundClick
				}),
				_react2.default.createElement(
					'div',
					{
						className: 'bmbo-dialog-holder',
						role: 'presentation',
						onClick: this.onHolderClick,
						ref: this.setHolderRef,
						onTransitionEnd: this.onTransitionEnd
					},
					$preface,
					$modal
				)
			));
		}
	}]);

	return Modal;
}(_react2.default.Component);

Modal.Title = _ModalTitle2.default;
Modal.Content = _ModalContent2.default;
Modal.Footer = _ModalFooter2.default;
Modal.Preface = _ModalPreface2.default;
Modal.Loading = _ModalLoading2.default;

exports.default = Modal;

/***/ }),
/* 39 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(41);


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(14);

var _reactHotLoader = __webpack_require__(42);

var _reactRedux = __webpack_require__(20);

var _reactRouterDom = __webpack_require__(21);

var _redux = __webpack_require__(29);

var _reduxThunk = __webpack_require__(47);

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _reduxLogger = __webpack_require__(48);

var _reduxLogger2 = _interopRequireDefault(_reduxLogger);

var _jquery = __webpack_require__(49);

var _jquery2 = _interopRequireDefault(_jquery);

var _reducers = __webpack_require__(50);

var _reducers2 = _interopRequireDefault(_reducers);

var _Main = __webpack_require__(22);

var _Main2 = _interopRequireDefault(_Main);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var loggerMiddleware = (0, _reduxLogger2.default)({
	collapsed: true
});
var store = (0, _redux.createStore)(_reducers2.default, {}, (0, _redux.applyMiddleware)(_reduxThunk2.default, loggerMiddleware));
window.store = store;
window.$ = _jquery2.default;

__webpack_require__(119);
__webpack_require__(39);

__webpack_require__(120);

// Render & Hot Update
delete _reactHotLoader.AppContainer.prototype.unstable_handleError;
(0, _reactDom.render)(_react2.default.createElement(
	_reactHotLoader.AppContainer,
	null,
	_react2.default.createElement(
		_reactRouterDom.HashRouter,
		null,
		_react2.default.createElement(
			_reactRedux.Provider,
			{ store: store },
			_react2.default.createElement(_Main2.default, null)
		)
	)
), document.getElementById('root'));

// Hot Module Replacement API
if (true) {
	module.hot.accept(39);
	module.hot.accept(22, function () {
		var NextMain = __webpack_require__(22).default;
		(0, _reactDom.render)(_react2.default.createElement(
			_reactHotLoader.AppContainer,
			null,
			_react2.default.createElement(
				_reactRouterDom.HashRouter,
				null,
				_react2.default.createElement(
					_reactRedux.Provider,
					{ store: store },
					_react2.default.createElement(NextMain, null)
				)
			)
		), document.getElementById('root'));
	});
}

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(43)


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable global-require */

if (true) {
  module.exports = __webpack_require__(44);
} else {
  module.exports = require('./index.dev');
}

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports.AppContainer = __webpack_require__(45);

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable global-require */

if (true) {
  module.exports = __webpack_require__(46);
} else {
  module.exports = require('./AppContainer.dev');
}

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/prop-types */

var React = __webpack_require__(0);

var Component = React.Component;

var AppContainer = function (_Component) {
  _inherits(AppContainer, _Component);

  function AppContainer() {
    _classCallCheck(this, AppContainer);

    return _possibleConstructorReturn(this, (AppContainer.__proto__ || Object.getPrototypeOf(AppContainer)).apply(this, arguments));
  }

  _createClass(AppContainer, [{
    key: 'render',
    value: function render() {
      if (this.props.component) {
        return React.createElement(this.props.component, this.props.props);
      }

      return React.Children.only(this.props.children);
    }
  }]);

  return AppContainer;
}(Component);

module.exports = AppContainer;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(7))(110);

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(7))(105);

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(7))(111);

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _redux = __webpack_require__(29);

var _app = __webpack_require__(51);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)({
	app: _app2.default
});

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.defaultState = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _app = __webpack_require__(52);

var defaultState = exports.defaultState = {
	filter: ''
};

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
	var action = arguments[1];

	switch (action.type) {
		case _app.APP_UPDATE_FILTER:
			return _extends({}, state, { filter: action.filter });
	}
	return state;
};

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
var APP_UPDATE_FILTER = exports.APP_UPDATE_FILTER = 'APP_UPDATE_FILTER';

var updateFilter = exports.updateFilter = function updateFilter(filter) {
	return {
		type: APP_UPDATE_FILTER,
		filter: filter
	};
};

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(7))(249);

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(20);

var _reactCssModules = __webpack_require__(12);

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _components = __webpack_require__(3);

var _index = __webpack_require__(94);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Home = function (_React$Component) {
	_inherits(Home, _React$Component);

	function Home() {
		_classCallCheck(this, Home);

		return _possibleConstructorReturn(this, (Home.__proto__ || Object.getPrototypeOf(Home)).apply(this, arguments));
	}

	_createClass(Home, [{
		key: 'render',
		value: function render() {
			return _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(
					'h1',
					null,
					'Bamboo UI',
					_react2.default.createElement(
						'small',
						null,
						' (dev)'
					)
				),
				_react2.default.createElement(
					'p',
					{ className: 'lead' },
					'\u4F7F\u7528\u5168\u65B0CSS\u53CAHTML\u7279\u6027\u6784\u5EFA\u7684React\u73B0\u4EE3\u6E38\u89C8\u5668\u7EC4\u4EF6\u5E93\u3002 \uFF08\u542F\u53D1\u81EA',
					_react2.default.createElement(
						_components.A,
						{ href: 'http://getbootstrap.com/', target: '_blank' },
						'Bootstrap'
					),
					'\uFF0C',
					_react2.default.createElement(
						_components.A,
						{ href: 'https://ant.design', target: '_blank' },
						'ANT Design'
					),
					'\uFF09'
				),
				_react2.default.createElement('hr', null),
				_react2.default.createElement(
					'p',
					null,
					'\u5982\u679C\u4F60\u60F3\u5F00\u53D1\u4E00\u6B3E\u5168\u65B0\u7684web\u800C\u4E0D\u7528\u8003\u8651\u65E7\u7248\u6E38\u89C8\u5668\u517C\u5BB9\u6027\uFF0C \u90A3\u4E48\u8D76\u7D27\u5F00\u59CB\u5427\uFF01'
				),
				_react2.default.createElement(
					'h2',
					null,
					'\u81EA\u9002\u5E94\u5C3A\u5BF8'
				),
				_react2.default.createElement(
					'p',
					null,
					'\u6211\u4EEC\u4E3A\u7EC4\u4EF6\u63D0\u4F9B\u4E86',
					_react2.default.createElement(
						'code',
						null,
						'size'
					),
					'\u5C5E\u6027\u8BA9\u4F60\u65B9\u4FBF\u8C03\u6574\u5927\u5C0F\u3002 \u6B64\u5916\uFF0C\u7EC4\u4EF6\u57FA\u4E8E',
					_react2.default.createElement(
						'code',
						null,
						'em'
					),
					'\u5355\u4F4D\u4E3A\u6807\u51C6\uFF0C \u56E0\u4E3A\u4F60\u53EF\u4EE5\u5F88\u65B9\u4FBF\u7684\u901A\u8FC7\u4FEE\u6539',
					_react2.default.createElement(
						'code',
						null,
						'font-size'
					),
					'\u6765\u81EA\u5B9A\u4E49\u5927\u5C0F\u3002'
				),
				_react2.default.createElement(
					'h2',
					null,
					'\u66F4\u6539\u4E3B\u9898'
				),
				_react2.default.createElement(
					'p',
					null,
					'Bamboo UI\u901A\u8FC7CSS\u53D8\u91CF\u5B9A\u4E49\u4E867\u79CD\u989C\u8272\u7C7B\u578B\uFF1A',
					_react2.default.createElement(
						'code',
						null,
						'deprecated'
					),
					',',
					_react2.default.createElement(
						'code',
						null,
						'primary'
					),
					',',
					_react2.default.createElement(
						'code',
						null,
						'info'
					),
					',',
					_react2.default.createElement(
						'code',
						null,
						'success'
					),
					',',
					_react2.default.createElement(
						'code',
						null,
						'warning'
					),
					',',
					_react2.default.createElement(
						'code',
						null,
						'danger'
					),
					'\u548C',
					_react2.default.createElement(
						'code',
						null,
						'forbid'
					),
					'\u3002'
				),
				_react2.default.createElement(
					'p',
					null,
					'\u5982\u679C\u4F60\u5E0C\u671B\u81EA\u5B9A\u4E49\u989C\u8272\uFF0C\u4F60\u53EF\u4EE5\u76F4\u63A5\u5728CSS\u6587\u4EF6\u4E2D\u6539\u5199\u8FD9\u4E9B\u53D8\u91CF\u800C\u4E0D\u9700\u8981\u91CD\u65B0\u7F16\u8BD1\uFF1A'
				),
				_react2.default.createElement(
					'pre',
					{ className: 'code' },
					'\nbody {\n\t--bmbo-duration-fast: 0.15s;\n\t--bmbo-duration: 0.25s;\n\t--bmbo-duration-mid: 0.4s;\n\t--bmbo-duration-slow: 1s;\n\t--bmbo-duration-slow-db: 2s;\n\t--bmbo-duration-turtle: 3s;\n\n\t--bmbo-lead: #374249;\n\t--bmbo-lead-active: #45A7B9;\n\n\t--bmbo-component-spacing: 5px;\n\n\t--bmbo-weak: $weak;\n\t--bmbo-deprecated: $deprecated;\n\t--bmbo-primary: $primary;\n\t--bmbo-info: $info;\n\t--bmbo-success: $success;\n\t--bmbo-warning: $warning;\n\t--bmbo-danger: $danger;\n\t--bmbo-forbid: $forbid;\n\n\t--bmbo-weak-light: lighten($weak, 10%);\n\t--bmbo-deprecated-light: lighten($deprecated, 10%);\n\t--bmbo-primary-light: lighten($primary, 10%);\n\t--bmbo-info-light: lighten($info, 10%);\n\t--bmbo-success-light: lighten($success, 10%);\n\t--bmbo-warning-light: lighten($warning, 7%);\n\t--bmbo-danger-light: lighten($danger, 10%);\n\t--bmbo-forbid-light: lighten($forbid, 10%);\n\n\t--bmbo-weak-dark: darken($weak, 10%);\n\t--bmbo-deprecated-dark: darken($deprecated, 10%);\n\t--bmbo-primary-dark: darken($primary, 10%);\n\t--bmbo-info-dark: darken($info, 10%);\n\t--bmbo-success-dark: darken($success, 10%);\n\t--bmbo-warning-dark: darken($warning, 10%);\n\t--bmbo-danger-dark: darken($danger, 10%);\n\t--bmbo-forbid-dark: darken($forbid, 10%);\n\n\t--bmbo-disabled-opacity: 0.5;\n\n\t--bmbo-xs: 12px;\n\t--bmbo-sm: 13px;\n\t--bmbo-md: 14px;\n\t--bmbo-lg: 18px;\n\t--bmbo-xl: 25px;\n\n\t--bmbo-padding-xs: 0 0.3em;\n\t--bmbo-padding-sm: 0.2em 0.6em;\n\t--bmbo-padding-md: 0.3em 0.8em;\n\t--bmbo-padding-lg: 0.3em 1em;\n\t--bmbo-padding-xl: 0.3em 2em;\n\n\t--bmbo-input-padding-xs: 0 0.1em;\n\t--bmbo-input-padding-sm: 0.2em 0.2em;\n\t--bmbo-input-padding-md: 0.3em 0.3em;\n\t--bmbo-input-padding-lg: 0.3em 0.3em;\n\t--bmbo-input-padding-xl: 0.3em 0.3em;\n\n\t--bmbo-color: #333;\n\t--bmbo-color-dim: #767676;\n\t--bmbo-color-light: #FFF;\n\t--bmbo-color-weak: #666;\n\n\t--bmbo-border: $border;\n\t--bmbo-border-dim: lighten($border, 15%);\n\t--bmbo-bac: #EEE;\n\t--bmbo-bac-dark: #DDD;\n\n\t--bmbo-gap: 15px;\n\t--bmbo-gap-small: 10px;\n\n\t--bmbo-shadow: 0 1px 3px rgba(#000, 0.1);\n\n\t--bmbo-component-margin: 15px;\n}\n\t\t\t\t\t'.trim()
				)
			);
		}
	}]);

	return Home;
}(_react2.default.Component);

var mapState = function mapState(_ref) {
	var filter = _ref.app.filter;
	return {
		filter: filter
	};
};

exports.default = (0, _reactRedux.connect)(mapState)((0, _reactCssModules2.default)(Home, _index2.default));

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _NavItem = __webpack_require__(23);

var _NavItem2 = _interopRequireDefault(_NavItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var HorizontalNav = function HorizontalNav(_ref) {
	var type = _ref.type,
	    children = _ref.children,
	    className = _ref.className,
	    props = _objectWithoutProperties(_ref, ['type', 'children', 'className']);

	return _react2.default.createElement(
		'ul',
		_extends({
			className: (0, _classnames2.default)('bmbo-nav', 'bmbo-horizontal-nav', 'bmbo-' + (type || 'lead'), className)
		}, props),
		children
	);
};

exports.default = HorizontalNav;

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _NavItem = __webpack_require__(23);

var _NavItem2 = _interopRequireDefault(_NavItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var VerticalNav = function VerticalNav(_ref) {
	var type = _ref.type,
	    children = _ref.children,
	    className = _ref.className,
	    props = _objectWithoutProperties(_ref, ['type', 'children', 'className']);

	return _react2.default.createElement(
		'ul',
		_extends({
			className: (0, _classnames2.default)('bmbo-nav', 'bmbo-vertical-nav', 'bmbo-' + (type || 'lead'), className)
		}, props),
		children
	);
};

exports.default = VerticalNav;

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _uiUtil = __webpack_require__(8);

var _Caret = __webpack_require__(15);

var _Caret2 = _interopRequireDefault(_Caret);

var _NavList = __webpack_require__(58);

var _NavList2 = _interopRequireDefault(_NavList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NavGroup = function (_React$Component) {
	_inherits(NavGroup, _React$Component);

	function NavGroup() {
		_classCallCheck(this, NavGroup);

		var _this = _possibleConstructorReturn(this, (NavGroup.__proto__ || Object.getPrototypeOf(NavGroup)).call(this));

		_this.onMouseEnter = function () {
			var rect = _this.$item.getBoundingClientRect();
			_this.setState({ hover: true, rect: rect });
		};

		_this.onMouseLeave = function (event) {
			var clientX = event.clientX,
			    clientY = event.clientY;


			if (_this.$list) {
				var rect = _this.$list.getBoundingClientRect();

				// Chrome has the bug of click event will trigger mouse leave event
				// ref: https://stackoverflow.com/questions/45266854/mouseleave-triggered-by-click
				if ((0, _uiUtil.isInRect)(clientX, clientY, rect)) {
					return;
				}
			}

			_this.setState({ hover: false });
		};

		_this.onClick = function () {
			_this.setState(function (_ref) {
				var open = _ref.open;
				return {
					open: !open
				};
			});
		};

		_this.setItemRef = function (ele) {
			_this.$item = ele;
		};

		_this.setListRef = function (ele) {
			_this.$list = ele;
		};

		_this.state = {
			hover: false,
			rect: null,

			open: false
		};
		return _this;
	}

	_createClass(NavGroup, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    title = _props.title,
			    children = _props.children,
			    active = _props.active,
			    disabled = _props.disabled,
			    className = _props.className,
			    props = _objectWithoutProperties(_props, ['title', 'children', 'active', 'disabled', 'className']);

			var _context = this.context,
			    navVertical = _context.navVertical,
			    navInline = _context.navInline;
			var _state = this.state,
			    hover = _state.hover,
			    rect = _state.rect,
			    open = _state.open;


			return _react2.default.createElement(
				'li',
				_extends({
					className: (0, _classnames2.default)('bmbo-nav-group', hover && 'bmbo-hover', active && 'bmbo-active', disabled && 'bmbo-disabled', className),
					ref: this.setItemRef,
					onMouseEnter: this.onMouseEnter,
					onMouseLeave: this.onMouseLeave
				}, props),
				_react2.default.createElement(
					'div',
					{
						className: 'bmbo-nav-title',
						role: 'button',
						tabIndex: -1,
						onClick: this.onClick
					},
					title,
					navVertical && _react2.default.createElement(_Caret2.default, {
						direct: navInline && open ? 'down' : 'right'
					})
				),
				_react2.default.createElement(
					_NavList2.default,
					{
						visible: hover,
						rect: rect,
						setRef: this.setListRef,
						open: open
					},
					children
				)
			);
		}
	}]);

	return NavGroup;
}(_react2.default.Component);

NavGroup.contextTypes = {
	navVertical: _propTypes2.default.bool,
	navInline: _propTypes2.default.bool
};

exports.default = NavGroup;

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _uiUtil = __webpack_require__(8);

var _Sequence = __webpack_require__(9);

var _Sequence2 = _interopRequireDefault(_Sequence);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DRILL_SPEED = 4 / 5;

var NavList = function (_React$Component) {
	_inherits(NavList, _React$Component);

	function NavList() {
		_classCallCheck(this, NavList);

		var _this = _possibleConstructorReturn(this, (NavList.__proto__ || Object.getPrototypeOf(NavList)).call(this));

		_this.onTransitionEnd = function (event) {
			if (_this.state.animateStatus === _uiUtil.ANIMATE_STATUS_HIDING && event.target === _this.$list) {
				_this.seq.next(function () {
					_this.setState({ animateStatus: _uiUtil.ANIMATE_STATUS_NONE });
				});
			}
		};

		_this.setListRef = function (ele) {
			var setRef = _this.props.setRef;

			_this.$list = ele;
			setRef(ele);
		};

		_this.checkUpdate = function (prevProps, nextProps) {
			if (_this.context.navInline) {
				if (!prevProps.open === !nextProps.open) return;
				_this.doDrillAnimation(nextProps);
			} else {
				if (!prevProps.visible === !nextProps.visible) return;
				_this.doFloatAnimation(nextProps);
			}
		};

		_this.doDrillAnimation = function (props) {
			if (props.open) {
				_this.seq.next(function () {
					_this.setState({
						height: 0
					});
				}).next(function () {
					var clientHeight = _this.$list.clientHeight;
					var scrollHeight = _this.$list.scrollHeight;

					var currentHeight = Math.ceil(clientHeight * DRILL_SPEED + scrollHeight * (1 - DRILL_SPEED));
					if (scrollHeight - currentHeight <= 1) {
						currentHeight = scrollHeight;
						_this.setState({ height: null });
						return false;
					}

					_this.setState({ height: currentHeight });

					return null;
				}, {
					loop: true,
					frame: 1
				});
			} else {
				_this.seq.next(function () {
					_this.setState({
						height: null
					});
				}).next(function () {
					var clientHeight = _this.$list.clientHeight;

					var currentHeight = Math.floor(clientHeight * DRILL_SPEED);
					if (clientHeight <= 1) {
						_this.setState({ height: 0 });
						return false;
					}

					_this.setState({ height: currentHeight });

					return null;
				}, {
					loop: true,
					frame: 1
				});
			}
		};

		_this.doFloatAnimation = function (props) {
			if (props.visible) {
				_this.seq.next(function () {
					_this.setState({
						animateStatus: _uiUtil.ANIMATE_STATUS_INIT,
						x: 0,
						y: 0
					});
				}).next(function () {
					var rect = _this.props.rect;
					var navVertical = _this.context.navVertical;

					var listRect = _this.$list.getBoundingClientRect();

					var pos = navVertical ? 'r' : 'b';

					// Add offset to let nav list match with parent
					var superRect = {
						left: rect.left,
						top: rect.top,
						width: rect.width,
						height: rect.height
					};
					if (navVertical) {
						superRect.top -= 1;
						superRect.height += 2;
					} else {
						superRect.left -= 1;
						superRect.width += 2;
					}

					_this.setState(_extends({}, (0, _uiUtil.getEnablePosition)(superRect, listRect, pos), {
						animateStatus: _uiUtil.ANIMATE_STATUS_SHOWING
					}));
				}).next(function () {
					_this.setState({ animateStatus: _uiUtil.ANIMATE_STATUS_SHOWN });
				});
			} else {
				_this.seq.next(function () {
					var animateStatus = _this.state.animateStatus;

					if (animateStatus === _uiUtil.ANIMATE_STATUS_NONE || animateStatus === _uiUtil.ANIMATE_STATUS_INIT) {
						return false;
					}
					_this.setState({ animateStatus: _uiUtil.ANIMATE_STATUS_HIDING });
					return null;
				}).next(function () {
					_this.setState({ animateStatus: _uiUtil.ANIMATE_STATUS_NONE });
				}, { delay: 1000 });
			}
		};

		_this.state = {
			animateStatus: _uiUtil.ANIMATE_STATUS_NONE,
			x: 0,
			y: 0,
			height: 0
		};
		_this.seq = new _Sequence2.default();
		return _this;
	}

	_createClass(NavList, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.checkUpdate({}, this.props);
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			this.checkUpdate(this.props, nextProps);
		}
	}, {
		key: 'render',
		value: function render() {
			var _props = this.props,
			    children = _props.children,
			    rect = _props.rect;
			var _context = this.context,
			    navType = _context.navType,
			    navVertical = _context.navVertical,
			    navInline = _context.navInline;
			var _state = this.state,
			    animateStatus = _state.animateStatus,
			    x = _state.x,
			    y = _state.y,
			    height = _state.height;


			if (!navVertical || !navInline) {
				// Float display

				if (animateStatus === _uiUtil.ANIMATE_STATUS_NONE) return null;

				return (0, _uiUtil.createPortal)(_react2.default.createElement(
					'div',
					{
						className: (0, _classnames2.default)('bmbo-nav-list', {
							'bmbo-hidden': animateStatus === _uiUtil.ANIMATE_STATUS_INIT,
							'bmbo-showing': animateStatus === _uiUtil.ANIMATE_STATUS_SHOWING,
							'bmbo-hiding': animateStatus === _uiUtil.ANIMATE_STATUS_HIDING
						}, 'bmbo-' + (navType || 'lead')),
						ref: this.setListRef,
						style: { left: x + 'px', top: y + 'px', minWidth: rect.width + 'px' },
						onTransitionEnd: this.onTransitionEnd
					},
					children
				));
			}

			// Inline display
			var style = {};
			if (height !== null) {
				style.height = height + 'px';
			}

			return _react2.default.createElement(
				'ul',
				{
					className: 'bmbo-nav-list',
					style: style,
					ref: this.setListRef
				},
				children
			);
		}
	}]);

	return NavList;
}(_react2.default.Component);

NavList.contextTypes = {
	navType: _propTypes2.default.string,
	navVertical: _propTypes2.default.bool,
	navInline: _propTypes2.default.bool
};

exports.default = NavList;

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _Col = __webpack_require__(31);

var _Col2 = _interopRequireDefault(_Col);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DEFAULT_GUTTER = 15;

var Row = function (_React$PureComponent) {
	_inherits(Row, _React$PureComponent);

	function Row() {
		_classCallCheck(this, Row);

		return _possibleConstructorReturn(this, (Row.__proto__ || Object.getPrototypeOf(Row)).apply(this, arguments));
	}

	_createClass(Row, [{
		key: 'getChildContext',
		value: function getChildContext() {
			var _props$gutter = this.props.gutter,
			    gutter = _props$gutter === undefined ? DEFAULT_GUTTER : _props$gutter;


			return {
				rowGutter: gutter
			};
		}
	}, {
		key: 'render',
		value: function render() {
			var _props = this.props,
			    _props$gutter2 = _props.gutter,
			    gutter = _props$gutter2 === undefined ? DEFAULT_GUTTER : _props$gutter2,
			    children = _props.children,
			    className = _props.className,
			    props = _objectWithoutProperties(_props, ['gutter', 'children', 'className']);

			var hg = gutter / 2;

			return _react2.default.createElement(
				'div',
				_extends({ className: (0, _classnames2.default)('bmbo-row', className) }, props),
				_react2.default.createElement(
					'div',
					{ style: { marginLeft: '-' + hg + 'px', marginRight: '-' + hg + 'px' } },
					children
				)
			);
		}
	}]);

	return Row;
}(_react2.default.PureComponent);

Row.childContextTypes = {
	rowGutter: _propTypes2.default.number
};

Row.Col = _Col2.default;

exports.default = Row;

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Loading = function Loading(_ref) {
	var id = _ref.id,
	    className = _ref.className;
	return _react2.default.createElement('span', {
		className: (0, _classnames2.default)('bmbo-icon bmbo-loading', id && 'bmbo-loading-' + id, className)
	});
};

exports.default = Loading;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Search = function Search(_ref) {
	var className = _ref.className;
	return _react2.default.createElement('span', {
		className: (0, _classnames2.default)('bmbo-icon bmbo-search', className)
	});
};

exports.default = Search;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var A = function A(_ref) {
	var className = _ref.className,
	    target = _ref.target,
	    props = _objectWithoutProperties(_ref, ['className', 'target']);

	var myProps = { target: target };
	if (target === '_blank') {
		myProps.rel = 'noopener noreferrer';
	}

	return _react2.default.createElement('a', _extends({
		className: (0, _classnames2.default)('bmbo-a', className)
	}, myProps, props));
};

exports.default = A;

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _Field = __webpack_require__(32);

var _Field2 = _interopRequireDefault(_Field);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Form = function (_React$Component) {
	_inherits(Form, _React$Component);

	function Form() {
		_classCallCheck(this, Form);

		var _this = _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this));

		_this.onFormChanged = function () {
			var onChanged = _this.props.onChanged;

			if (onChanged) onChanged();
		};

		_this.getInstance = function () {
			return _this.props.instance || _this;
		};

		_this.state = {};
		return _this;
	}

	_createClass(Form, [{
		key: 'getChildContext',
		value: function getChildContext() {
			var _props$path = this.props.path,
			    path = _props$path === undefined ? [] : _props$path;


			return {
				formInstance: this.getInstance(),
				formPath: Array.isArray(path) ? path : [path],
				onFormChanged: this.onFormChanged
			};
		}
	}, {
		key: 'render',
		value: function render() {
			var _props = this.props,
			    children = _props.children,
			    className = _props.className,
			    props = _objectWithoutProperties(_props, ['children', 'className']);

			delete props.instance;
			delete props.path;
			delete props.onChanged;

			return _react2.default.createElement(
				'div',
				_extends({ className: (0, _classnames2.default)('bmbo-form', className) }, props),
				children
			);
		}
	}]);

	return Form;
}(_react2.default.Component);

Form.childContextTypes = {
	formInstance: _propTypes2.default.object,
	formPath: _propTypes2.default.array,
	onFormChanged: _propTypes2.default.func
};

Form.Field = _Field2.default;

exports.default = Form;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _eventUtil = __webpack_require__(10);

var _envUtil = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var currentSlider = void 0;

function getEventPercentage(holder, event) {
	var clientX = event.clientX;

	var _holder$getBoundingCl = holder.getBoundingClientRect(),
	    left = _holder$getBoundingCl.left,
	    width = _holder$getBoundingCl.width;

	var ptg = (clientX - left) / width;
	if (ptg < 0) ptg = 0;
	if (ptg > 1) ptg = 1;

	return ptg;
}

function getLeft(value, min, max) {
	var offset = value - min;
	var len = max - min;

	return offset / len * 100 + '%';
}

function valueSort(a, b) {
	return a - b;
}

if (_envUtil.canUseDOM) {
	window.addEventListener('mousemove', function (event) {
		if (!currentSlider) return;

		var ptg = getEventPercentage(currentSlider.$pinHolder, event);

		currentSlider.setValuePtg(ptg, event);
		event.preventDefault();
	});

	window.addEventListener('mouseup', function () {
		if (currentSlider) {
			currentSlider.pinIndex = undefined;
			currentSlider.finishUpdate();
			currentSlider = null;
		}
	});
}

var Pin = function (_React$Component) {
	_inherits(Pin, _React$Component);

	function Pin() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, Pin);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Pin.__proto__ || Object.getPrototypeOf(Pin)).call.apply(_ref, [this].concat(args))), _this), _this.onMouseDown = function (event) {
			var _this$props = _this.props,
			    onMouseDown = _this$props.onMouseDown,
			    index = _this$props.index;

			if (onMouseDown) onMouseDown(event, index);
		}, _this.setRef = function (ele) {
			var _this$props2 = _this.props,
			    setRef = _this$props2.setRef,
			    index = _this$props2.index;

			if (setRef) setRef(ele, index);
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(Pin, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    left = _props.left,
			    index = _props.index,
			    isMark = _props.isMark,
			    isActive = _props.isActive;


			return _react2.default.createElement('div', {
				className: (0, _classnames2.default)('bmbo-slider-pin', isMark && 'bmbo-mark', isActive && 'bmbo-active'),
				onMouseDown: this.onMouseDown,
				style: { left: left },
				role: 'button',
				tabIndex: -1,
				ref: this.setRef,
				'data-index': index
			});
		}
	}]);

	return Pin;
}(_react2.default.Component);

var Slider = function (_React$Component2) {
	_inherits(Slider, _React$Component2);

	function Slider() {
		_classCallCheck(this, Slider);

		var _this2 = _possibleConstructorReturn(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).call(this));

		_this2.onBarMouseDown = function () {
			for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
				args[_key2] = arguments[_key2];
			}

			var _this2$props = _this2.props,
			    disabled = _this2$props.disabled,
			    onMouseDown = _this2$props.onMouseDown,
			    value = _this2$props.value;

			if (disabled || _this2.getPinCount() > 1) return;

			if (onMouseDown) onMouseDown.apply(undefined, args);

			var event = args[0].nativeEvent;

			_this2.setState({
				value: value
			}, function () {
				_this2.pinIndex = 0;
				currentSlider = _this2;
				_this2.setValuePtg(getEventPercentage(_this2.$pinHolder, event), event);
			});
		};

		_this2.onPinMouseDown = function (event, index) {
			var _this2$props2 = _this2.props,
			    disabled = _this2$props2.disabled,
			    value = _this2$props2.value;

			if (disabled) return;

			_this2.setState({
				value: value
			}, function () {
				_this2.pinIndex = index;
				currentSlider = _this2;
			});

			event.stopPropagation();
		};

		_this2.setPinRef = function (ele, index) {
			_this2.$pins[index] = ele;
		};

		_this2.setPinHolderRef = function (ele) {
			_this2.$pinHolder = ele;
		};

		_this2.setValuePtg = function (ptg, event) {
			if (_this2.pinIndex === undefined) return;

			var onChange = _this2.props.onChange;

			var value = _this2.getValue();
			var _this2$props3 = _this2.props,
			    _this2$props3$min = _this2$props3.min,
			    min = _this2$props3$min === undefined ? 0 : _this2$props3$min,
			    _this2$props3$max = _this2$props3.max,
			    max = _this2$props3$max === undefined ? 100 : _this2$props3$max,
			    _this2$props3$step = _this2$props3.step,
			    step = _this2$props3$step === undefined ? 1 : _this2$props3$step;

			// Format number

			min = Number(min);
			max = Number(max);

			var len = max - min;
			var offset = void 0;
			var pinValue = void 0;

			var markValues = _this2.getMarkValues();

			if (step !== null) {
				step = Number(step);
				offset = Math.round(len * ptg / step) * step;
				pinValue = offset + min;

				// Stick mark if needed
				markValues.some(function (_ref2) {
					var markValue = _ref2.value,
					    stick = _ref2.stick;

					if (!stick) return false;

					if (markValue - stick <= pinValue && pinValue <= markValue + stick) {
						pinValue = markValue;
						return null;
					}

					return false;
				});
			} else {
				pinValue = min + len * ptg;
				var match = false;
				for (var i = markValues.length - 1; i > 0; i -= 1) {
					var cur = markValues[i].value;
					var prev = markValues[i - 1].value;
					if (pinValue >= prev) {
						match = true;
						pinValue = pinValue > (cur + prev) / 2 ? cur : prev;
						break;
					}
				}

				if (!match && markValues.length > 0) {
					pinValue = markValues[0].value;
				}
			}

			var newValue = void 0;
			if (Array.isArray(value)) {
				newValue = value.concat();
				newValue[_this2.pinIndex] = pinValue;
			} else if (_this2.getPinCount() === 1) {
				newValue = pinValue;
			} else {
				newValue = [];
				newValue[_this2.pinIndex] = pinValue;
			}

			var outputValue = newValue;

			// Clean up empty value
			if (Array.isArray(newValue)) {
				for (var _i = newValue.length - 1; _i >= 0; _i -= 1) {
					var val = newValue[_i];
					if (val === null || val === undefined) {
						newValue[_i] = min;
					}
				}

				outputValue = newValue.concat().sort(valueSort);
			}

			// Sync local value
			_this2.setState({
				value: newValue
			});

			var newEvent = (0, _eventUtil.wrapperEventValue)(event, _this2.$pins[_this2.pinIndex], outputValue);

			if (onChange) {
				onChange(newEvent);
			}
		};

		_this2.getMarkValues = function () {
			var _this2$props4 = _this2.props,
			    _this2$props4$min = _this2$props4.min,
			    min = _this2$props4$min === undefined ? 0 : _this2$props4$min,
			    _this2$props4$max = _this2$props4.max,
			    max = _this2$props4$max === undefined ? 100 : _this2$props4$max,
			    _this2$props4$marks = _this2$props4.marks,
			    marks = _this2$props4$marks === undefined ? {} : _this2$props4$marks;

			// No need to sort since number key is always in order

			return Object.keys(marks).map(function (markValue) {
				var value = Number(markValue);
				if (isNaN(value) || value < min || value > max) {
					console.warn('[Bamboo - Slider] Mark is out of range:', markValue, '(Range: ' + min + ' ~ ' + max);
					return null;
				}

				var config = marks[value];
				if (typeof config === 'string') {
					config = {
						title: config
					};
				}

				return _extends({}, config, {
					value: value
				});
			}).filter(function (n) {
				return n !== null;
			});
		};

		_this2.getPinCount = function () {
			var multi = _this2.props.multi;

			if (!multi) return 1;
			return multi === true ? 2 : Math.max(multi, 1);
		};

		_this2.getValue = function () {
			if (_this2.isOperating()) {
				return _this2.state.value;
			}
			return _this2.props.value;
		};

		_this2.getPinValue = function (index) {
			var value = _this2.getValue();
			var _this2$props5 = _this2.props,
			    _this2$props5$min = _this2$props5.min,
			    min = _this2$props5$min === undefined ? 0 : _this2$props5$min,
			    _this2$props5$max = _this2$props5.max,
			    max = _this2$props5$max === undefined ? 100 : _this2$props5$max;

			var current = void 0;

			if (Array.isArray(value)) {
				current = value[index];
			} else if (_this2.getPinCount() === 1) {
				current = value;
			} else {
				current = min;
			}

			min = Number(min);
			max = Number(max);
			current = Number(current);

			if (current === null || current === undefined || isNaN(current) || current < min) current = min;
			if (current > max) current = max;

			return current;
		};

		_this2.isOperating = function () {
			return currentSlider === _this2;
		};

		_this2.finishUpdate = function () {
			// Sync slider value with props value when user finish dragging
			Promise.resolve().then(function () {
				_this2.forceUpdate();
			});
		};

		_this2.$pins = {};
		_this2.state = {
			value: null // Component handle value when user is operating
		};
		return _this2;
	}

	_createClass(Slider, [{
		key: 'render',
		value: function render() {
			var _props2 = this.props,
			    _props2$min = _props2.min,
			    min = _props2$min === undefined ? 0 : _props2$min,
			    _props2$max = _props2.max,
			    max = _props2$max === undefined ? 100 : _props2$max,
			    disabled = _props2.disabled,
			    transparent = _props2.transparent,
			    type = _props2.type,
			    size = _props2.size,
			    className = _props2.className,
			    props = _objectWithoutProperties(_props2, ['min', 'max', 'disabled', 'transparent', 'type', 'size', 'className']);

			delete props.value;
			delete props.step;
			delete props.multi;
			delete props.marks;
			delete props.onMouseDown;
			delete props.onChange;

			var pinCount = this.getPinCount();

			var $pinList = [];
			var rangeMin = Number.MAX_VALUE;
			var rangeMax = Number.MIN_VALUE;

			for (var i = 0; i < pinCount; i += 1) {
				var value = this.getPinValue(i);

				// Pin list
				var left = getLeft(value, min, max);

				$pinList.push(_react2.default.createElement(Pin, {
					key: 'pin_' + i,
					index: i,
					setRef: this.setPinRef,
					onMouseDown: this.onPinMouseDown,
					left: left
				}));

				// Get limitation
				if (pinCount > 1) {
					rangeMin = Math.min(rangeMin, value);
				} else {
					rangeMin = min;
				}
				rangeMax = Math.max(rangeMax, value);
			}

			// Pin range
			var rangeWidthPtg = (rangeMax - rangeMin) / (max - min);

			// Marks
			var $markList = [];
			var $markTitleList = [];

			this.getMarkValues().forEach(function (_ref3) {
				var value = _ref3.value,
				    title = _ref3.title;

				var left = getLeft(value, min, max);

				// Mark
				$markList.push(_react2.default.createElement(Pin, {
					key: 'mark_' + value,
					left: left,
					isMark: true,
					isActive: rangeMin <= value && value <= rangeMax
				}));

				// Title
				$markTitleList.push(_react2.default.createElement(
					'div',
					{ key: 'title_' + value, className: 'bmbo-title-holder', style: { left: left } },
					_react2.default.createElement(
						'div',
						{ className: 'bmbo-title' },
						title
					)
				));
			});

			return _react2.default.createElement(
				'div',
				{
					className: (0, _classnames2.default)('bmbo-slider', pinCount === 1 && 'bmbo-single', 'bmbo-' + (type || 'primary'), 'bmbo-' + (size || 'md'), disabled && 'bmbo-disabled', transparent && 'bmbo-transparent', className),

					onMouseDown: this.onBarMouseDown
				},
				_react2.default.createElement(
					'div',
					{ className: 'bmbo-slider-content' },
					_react2.default.createElement('div', { className: 'bmbo-slider-bar', ref: this.setPinHolderRef }),
					_react2.default.createElement('div', {
						className: 'bmbo-slider-range',
						style: {
							left: getLeft(rangeMin, min, max),
							width: rangeWidthPtg * 100 + '%'
						}
					}),
					$markList,
					$pinList
				),
				_react2.default.createElement(
					'div',
					{ className: 'bmbo-slider-title' },
					$markTitleList
				)
			);
		}
	}]);

	return Slider;
}(_react2.default.Component);

exports.default = Slider;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EmptyWrapper = function (_React$Component) {
	_inherits(EmptyWrapper, _React$Component);

	function EmptyWrapper() {
		_classCallCheck(this, EmptyWrapper);

		return _possibleConstructorReturn(this, (EmptyWrapper.__proto__ || Object.getPrototypeOf(EmptyWrapper)).apply(this, arguments));
	}

	_createClass(EmptyWrapper, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    children = _props.children,
			    props = _objectWithoutProperties(_props, ['children']);

			return _react2.default.cloneElement(children, props);
		}
	}]);

	return EmptyWrapper;
}(_react2.default.Component);

exports.default = EmptyWrapper;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _uiUtil = __webpack_require__(8);

var _Sequence = __webpack_require__(9);

var _Sequence2 = _interopRequireDefault(_Sequence);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Box = function (_React$Component) {
	_inherits(Box, _React$Component);

	function Box() {
		_classCallCheck(this, Box);

		var _this = _possibleConstructorReturn(this, (Box.__proto__ || Object.getPrototypeOf(Box)).call(this));

		_this.onTransitionEnd = function (event) {
			if (_this.state.animateStatus === _uiUtil.ANIMATE_STATUS_HIDING && event.target === _this.$ele) {
				_this.seq.next(function () {
					_this.setState({ animateStatus: _uiUtil.ANIMATE_STATUS_NONE });
				});
			}
		};

		_this.setRef = function (ele) {
			_this.$ele = ele;

			// Let window event handler ignore this element
			if (_this.$ele) _this.$ele._bmbo_ignore = true;
		};

		_this.checkUpdate = function (prevProps, nextProps) {
			if (!prevProps.visible === !nextProps.visible) return;

			var onVisibilityChanged = nextProps.onVisibilityChanged;


			if (nextProps.visible) {
				_this.seq.next(function (done) {
					var rect = nextProps.rect,
					    stretch = nextProps.stretch;


					_this.setState({
						animateStatus: _uiUtil.ANIMATE_STATUS_INIT,
						x: 0,
						y: 0,
						width: stretch ? rect.width : null
					}, done);
				}, { frame: 1 }).next(function (done) {
					var rect = nextProps.rect;

					var pinRect = _this.$ele.getBoundingClientRect();

					if (onVisibilityChanged) {
						onVisibilityChanged(true);
					}

					_this.setState(_extends({
						animateStatus: _uiUtil.ANIMATE_STATUS_SHOWING
					}, (0, _uiUtil.getEnablePosition)(rect, pinRect, 'b')), done);
				}, { frame: 1 }).next(function () {
					_this.setState({ animateStatus: _uiUtil.ANIMATE_STATUS_SHOWN });
				});
			} else {
				_this.seq.next(function (done) {
					_this.setState({
						animateStatus: _uiUtil.ANIMATE_STATUS_HIDING
					}, done);
				}, { frame: 1 }).next(function () {
					if (onVisibilityChanged) {
						onVisibilityChanged(false);
					}
				}, { delay: 0 }).next(function () {
					/** Reset to none status.
      ** This will not trigger if `onTransitionEnd` works.
      */
					_this.setState({
						animateStatus: _uiUtil.ANIMATE_STATUS_NONE
					});
				}, { delay: 3000 });
			}
		};

		_this.state = {
			animateStatus: _uiUtil.ANIMATE_STATUS_NONE,
			x: 0,
			y: 0,
			width: null
		};

		_this.seq = new _Sequence2.default();
		return _this;
	}

	_createClass(Box, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.checkUpdate({}, this.props);
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			this.checkUpdate(this.props, nextProps);
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.seq.destroy();
		}
	}, {
		key: 'render',
		value: function render() {
			var _state = this.state,
			    animateStatus = _state.animateStatus,
			    x = _state.x,
			    y = _state.y,
			    width = _state.width,
			    direct = _state.direct;

			if (animateStatus === _uiUtil.ANIMATE_STATUS_NONE) return null;

			var _props = this.props,
			    children = _props.children,
			    className = _props.className,
			    props = _objectWithoutProperties(_props, ['children', 'className']);

			delete props.visible;
			delete props.rect;
			delete props.stretch;
			delete props.onVisibilityChanged;

			var style = {
				left: x + 'px',
				top: y + 'px'
			};

			if (width !== null) {
				style.width = width + 'px';
			}

			return (0, _uiUtil.createPortal)(_react2.default.createElement(
				'div',
				_extends({}, props, {

					style: style,
					className: (0, _classnames2.default)('bmbo-pin-box', {
						'bmbo-init': animateStatus === _uiUtil.ANIMATE_STATUS_INIT,
						'bmbo-showing': animateStatus === _uiUtil.ANIMATE_STATUS_SHOWING,
						'bmbo-hiding': animateStatus === _uiUtil.ANIMATE_STATUS_HIDING
					}, 'bmbo-' + direct, className),
					onTransitionEnd: this.onTransitionEnd,
					ref: this.setRef
				}),
				children
			));
		}
	}]);

	return Box;
}(_react2.default.Component);

exports.default = Box;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.BAMBOO_FORM_SELECT_GROUP = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.getNodeList = getNodeList;
exports.getValueList = getValueList;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Checkbox = __webpack_require__(13);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _componentUtil = __webpack_require__(4);

var _SelectOption = __webpack_require__(34);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BAMBOO_FORM_SELECT_GROUP = exports.BAMBOO_FORM_SELECT_GROUP = 'BAMBOO_FORM_SELECT_GROUP';

function getNodeList() {
	var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	var parentProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	var valueList = [];

	(0, _componentUtil.mapChildrenByType)(children, _SelectOption.BAMBOO_FORM_SELECT_OPTION, function (node) {
		var _node$props = node.props,
		    nodeVal = _node$props.value,
		    nodeChildren = _node$props.children,
		    disabled = _node$props.disabled;

		var myVal = nodeVal !== undefined ? nodeVal : nodeChildren;
		valueList.push({
			title: nodeChildren,
			value: myVal,
			disabled: disabled !== undefined ? disabled : parentProps.disabled
		});
	});

	(0, _componentUtil.mapChildrenByType)(children, BAMBOO_FORM_SELECT_GROUP, function (node) {
		valueList = valueList.concat(getNodeList(node.props.children, node.props || {}));
	});

	return valueList;
}

function getValueList() {
	var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

	return getNodeList(children).map(function (_ref) {
		var value = _ref.value;
		return value;
	});
}

var SelectGroup = function (_React$Component) {
	_inherits(SelectGroup, _React$Component);

	function SelectGroup() {
		var _ref2;

		var _temp, _this, _ret;

		_classCallCheck(this, SelectGroup);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = SelectGroup.__proto__ || Object.getPrototypeOf(SelectGroup)).call.apply(_ref2, [this].concat(args))), _this), _this.selectAllValue = function (event) {
			var children = _this.props.children;
			var bmboOnSelectValues = _this.context.bmboOnSelectValues;

			var valueList = getValueList(children);

			bmboOnSelectValues(event, valueList, !_this.isAllSelected());
		}, _this.isAllSelected = function () {
			var children = _this.props.children;
			var bmboSelectIsChecked = _this.context.bmboSelectIsChecked;

			var valueList = getValueList(children);

			return valueList.every(bmboSelectIsChecked);
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(SelectGroup, [{
		key: 'getChildContext',
		value: function getChildContext() {
			var bmboSelectDisabled = this.context.bmboSelectDisabled;


			return {
				bmboSelectDisabled: this.props.disabled !== undefined ? this.props.disabled : bmboSelectDisabled
			};
		}
	}, {
		key: 'render',
		value: function render() {
			var _props = this.props,
			    title = _props.title,
			    children = _props.children,
			    noSelectAll = _props.noSelectAll,
			    disabled = _props.disabled,
			    props = _objectWithoutProperties(_props, ['title', 'children', 'noSelectAll', 'disabled']);

			var _context = this.context,
			    bmboSelectMulti = _context.bmboSelectMulti,
			    bmboSelectSize = _context.bmboSelectSize,
			    bmboSelectDisabled = _context.bmboSelectDisabled;


			var myDisabled = void 0;
			if (disabled !== undefined) {
				myDisabled = disabled;
			} else if (bmboSelectDisabled !== undefined) {
				myDisabled = bmboSelectDisabled;
			}

			var $title = title;
			var selectAllProps = {};

			if (bmboSelectMulti && !noSelectAll) {
				$title = _react2.default.createElement(
					_Checkbox2.default,
					{ size: bmboSelectSize, disabled: myDisabled, checked: this.isAllSelected() },
					title
				);

				selectAllProps = {
					role: 'button',
					tabIndex: -1,
					onClick: myDisabled ? null : this.selectAllValue
				};
			} else {
				$title = _react2.default.createElement(
					'span',
					null,
					title
				);
			}

			return _react2.default.createElement(
				'li',
				_extends({
					className: 'bmbo-' + (bmboSelectSize || 'md') + ' bmbo-select-group'
				}, props),
				_react2.default.createElement(
					'div',
					_extends({
						className: 'bmbo-select-group-title bmbo-padding'
					}, selectAllProps),
					$title
				),
				_react2.default.createElement(
					'ul',
					null,
					children
				)
			);
		}
	}]);

	return SelectGroup;
}(_react2.default.Component);

SelectGroup.childContextTypes = {
	bmboSelectDisabled: _propTypes2.default.bool
};

SelectGroup.contextTypes = {
	bmboSelectSize: _propTypes2.default.string,
	bmboSelectMulti: _propTypes2.default.bool,
	bmboSelectDisabled: _propTypes2.default.bool,
	bmboOnSelectValue: _propTypes2.default.func,
	bmboOnSelectValues: _propTypes2.default.func,
	bmboSelectIsChecked: _propTypes2.default.func
};

SelectGroup[_componentUtil.BAMBOO_COMPONENT] = BAMBOO_FORM_SELECT_GROUP;

exports.default = SelectGroup;

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _envUtil = __webpack_require__(11);

var _MenuList = __webpack_require__(35);

var _MenuList2 = _interopRequireDefault(_MenuList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var $currentMenu = void 0;

if (_envUtil.canUseDOM) {
	window.addEventListener('mousedown', function () {
		if ($currentMenu) {
			$currentMenu.hideMenu();
			$currentMenu = null;
		}
	});
}

var Menu = function (_React$Component) {
	_inherits(Menu, _React$Component);

	function Menu() {
		_classCallCheck(this, Menu);

		var _this = _possibleConstructorReturn(this, (Menu.__proto__ || Object.getPrototypeOf(Menu)).call(this));

		_this.onContextMenu = function (event) {
			event.preventDefault();

			_this.setState({
				show: true,
				x: event.clientX,
				y: event.clientY
			});

			$currentMenu = _this;
		};

		_this.hideMenu = function (callback) {
			_this.setState({
				show: false
			}, callback);
		};

		_this.state = {
			show: false,
			x: 0,
			y: 0
		};
		return _this;
	}

	_createClass(Menu, [{
		key: 'getChildContext',
		value: function getChildContext() {
			return {
				hideMenu: this.hideMenu,
				menuSize: this.props.size
			};
		}
	}, {
		key: 'render',
		value: function render() {
			var _props = this.props,
			    _props$menu = _props.menu,
			    menu = _props$menu === undefined ? [] : _props$menu,
			    children = _props.children,
			    className = _props.className,
			    props = _objectWithoutProperties(_props, ['menu', 'children', 'className']);

			var _state = this.state,
			    show = _state.show,
			    x = _state.x,
			    y = _state.y;


			delete props.size;

			return _react2.default.createElement(
				'div',
				_extends({
					className: (0, _classnames2.default)('bmbo-menu-wrapper', className),
					onContextMenu: this.onContextMenu
				}, props),
				children,
				show && _react2.default.createElement(_MenuList2.default, { list: menu, x: x, y: y })
			);
		}
	}]);

	return Menu;
}(_react2.default.Component);

Menu.childContextTypes = {
	hideMenu: _propTypes2.default.func,
	menuSize: _propTypes2.default.string
};

exports.default = Menu;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _Caret = __webpack_require__(15);

var _Caret2 = _interopRequireDefault(_Caret);

var _MenuList = __webpack_require__(35);

var _MenuList2 = _interopRequireDefault(_MenuList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MenuItem = function (_React$Component) {
	_inherits(MenuItem, _React$Component);

	function MenuItem() {
		_classCallCheck(this, MenuItem);

		var _this = _possibleConstructorReturn(this, (MenuItem.__proto__ || Object.getPrototypeOf(MenuItem)).call(this));

		_this.onClick = function () {
			var _this$props$item = _this.props.item,
			    disabled = _this$props$item.disabled,
			    onClick = _this$props$item.onClick;


			if (disabled) return;

			var hideMenu = _this.context.hideMenu;


			if (hideMenu) hideMenu();
			if (onClick) onClick.apply(undefined, arguments);
		};

		_this.onMouseDown = function (event) {
			event.preventDefault();
		};

		_this.onMouseEnter = function () {
			var list = _this.props.item.list;


			_this.setState({
				active: true
			});

			if (!list) return;

			var rect = _this.$item.getBoundingClientRect();

			_this.setState({
				drillDown: list,
				rect: rect
			});
		};

		_this.onMouseLeave = function () {
			_this.setState({
				active: false,
				drillDown: null
			});
		};

		_this.setRef = function (ele) {
			_this.$item = ele;
		};

		_this.state = {
			drillDown: undefined,
			rect: undefined,
			active: false
		};
		return _this;
	}

	_createClass(MenuItem, [{
		key: 'render',
		value: function render() {
			var _props$item = this.props.item,
			    separator = _props$item.separator,
			    title = _props$item.title,
			    disabled = _props$item.disabled,
			    list = _props$item.list;
			var _state = this.state,
			    drillDown = _state.drillDown,
			    _state$rect = _state.rect;
			_state$rect = _state$rect === undefined ? {} : _state$rect;
			var left = _state$rect.left,
			    top = _state$rect.top,
			    width = _state$rect.width,
			    height = _state$rect.height,
			    active = _state.active;


			if (separator) {
				return _react2.default.createElement('li', { className: 'bmbo-separator' });
			}

			return _react2.default.createElement(
				'li',
				{
					className: (0, _classnames2.default)('bmbo-menu-item', disabled && 'bmbo-disabled', !disabled && active && 'bmbo-active'),
					role: 'button',
					tabIndex: -1,
					ref: this.setRef,
					onClick: this.onClick,
					onMouseDown: this.onMouseDown,
					onMouseEnter: this.onMouseEnter,
					onMouseLeave: this.onMouseLeave
				},
				title,
				list && _react2.default.createElement(_Caret2.default, null),
				drillDown && _react2.default.createElement(_MenuList2.default, {
					list: drillDown,
					x: left,
					y: top - 1,
					width: width,
					height: height
				})
			);
		}
	}]);

	return MenuItem;
}(_react2.default.Component);

MenuItem.contextTypes = {
	hideMenu: _propTypes2.default.func
};

exports.default = MenuItem;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(14);

var _envUtil = __webpack_require__(11);

var _ModalFlexHolder = __webpack_require__(71);

var _ModalFlexHolder2 = _interopRequireDefault(_ModalFlexHolder);

var _Modal = __webpack_require__(38);

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BAMBOO_MODAL_FLEX_HOLDER = 'bmbo_modal_flex_holder';

var $modalFlexHolder = void 0;
if (_envUtil.canUseDOM) {
	// Clean up menu holder for hot module reload
	window.document.querySelectorAll('#' + BAMBOO_MODAL_FLEX_HOLDER).forEach(function (ele) {
		ele.remove();
	});

	// Set up menu holder
	var $flexHolder = window.document.createElement('div');
	$flexHolder.id = BAMBOO_MODAL_FLEX_HOLDER;

	(0, _reactDom.render)(_react2.default.createElement(_ModalFlexHolder2.default, {
		ref: function ref(node) {
			$modalFlexHolder = node;
		}
	}), $flexHolder);
}

_Modal2.default.showDialog = function (config) {
	if (!$modalFlexHolder) {
		console.error('[Modal] Flex holder not defined.(Isomorphic render?)');
		return;
	}

	$modalFlexHolder.showDialog(config);
};

exports.default = _Modal2.default;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Modal = __webpack_require__(38);

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ModalFlexHolder = function (_React$Component) {
	_inherits(ModalFlexHolder, _React$Component);

	function ModalFlexHolder() {
		_classCallCheck(this, ModalFlexHolder);

		var _this = _possibleConstructorReturn(this, (ModalFlexHolder.__proto__ || Object.getPrototypeOf(ModalFlexHolder)).call(this));

		_this.showDialog = function (config) {
			_this.setState(function (_ref) {
				var list = _ref.list;
				return {
					list: [].concat(_toConsumableArray(list), [{
						visible: true,
						config: config
					}])
				};
			});
		};

		_this.lockDialog = function (index) {
			var lock = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

			_this.setState(function (_ref2) {
				var list = _ref2.list;

				var newList = list.concat();
				newList[index] = _extends({}, list[index], {
					lock: lock
				});

				return { list: newList };
			});
		};

		_this.hideDialog = function (index) {
			_this.setState(function (_ref3) {
				var list = _ref3.list;

				var newList = list.concat();
				newList[index] = _extends({}, list[index], {
					visible: false
				});

				return { list: newList };
			});
		};

		_this.removeDialog = function (index) {
			_this.setState(function (_ref4) {
				var list = _ref4.list;

				var dialog = list[index];
				return {
					list: list.filter(function (d) {
						return d !== dialog;
					})
				};
			});
		};

		_this.state = {
			list: []
		};
		return _this;
	}

	_createClass(ModalFlexHolder, [{
		key: 'render',
		value: function render() {
			var _this2 = this;

			var list = this.state.list;


			return _react2.default.createElement(
				'div',
				null,
				list.map(function (dialog, index) {
					var config = dialog.config,
					    visible = dialog.visible,
					    lock = dialog.lock;
					var _onClose = config.onClose,
					    onConfirm = config.onConfirm;


					var closeWrapper = function closeWrapper(func) {
						var ret = void 0;
						if (func) ret = func();

						_this2.lockDialog(index, true);

						Promise.resolve(ret).then(function (close) {
							if (close === false) {
								_this2.lockDialog(index, false);
								return;
							}

							_this2.hideDialog(index);
						}).catch(function () {
							_this2.lockDialog(index, false);
						});
					};

					var props = {
						onClose: function onClose() {
							closeWrapper(_onClose);
						},
						onClosed: function onClosed() {
							_this2.removeDialog(index);
						}
					};

					if (onConfirm) {
						props.onConfirm = function () {
							closeWrapper(onConfirm);
						};
					}

					return _react2.default.createElement(_Modal2.default, _extends({
						key: index
					}, config, {

						visible: visible,
						lock: lock
					}, props));
				})
			);
		}
	}]);

	return ModalFlexHolder;
}(_react2.default.Component);

exports.default = ModalFlexHolder;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.BAMBOO_MODAL_TITLE = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _componentUtil = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var BAMBOO_MODAL_TITLE = exports.BAMBOO_MODAL_TITLE = 'BAMBOO_MODAL_TITLE';

var ModalTitle = function ModalTitle(_ref) {
	var children = _ref.children,
	    className = _ref.className,
	    props = _objectWithoutProperties(_ref, ['children', 'className']);

	return _react2.default.createElement(
		'div',
		_extends({ className: (0, _classnames2.default)('bmbo-modal-title', className) }, props),
		children
	);
};

ModalTitle[_componentUtil.BAMBOO_COMPONENT] = BAMBOO_MODAL_TITLE;

exports.default = ModalTitle;

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.BAMBOO_MODAL_CONTENT = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _componentUtil = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var BAMBOO_MODAL_CONTENT = exports.BAMBOO_MODAL_CONTENT = 'BAMBOO_MODAL_CONTENT';

var ModalContent = function ModalContent(_ref) {
	var children = _ref.children,
	    className = _ref.className,
	    props = _objectWithoutProperties(_ref, ['children', 'className']);

	return _react2.default.createElement(
		'div',
		_extends({ className: (0, _classnames2.default)('bmbo-modal-body', className) }, props),
		children
	);
};

ModalContent[_componentUtil.BAMBOO_COMPONENT] = BAMBOO_MODAL_CONTENT;

exports.default = ModalContent;

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.BAMBOO_MODAL_FOOTER = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _componentUtil = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var BAMBOO_MODAL_FOOTER = exports.BAMBOO_MODAL_FOOTER = 'BAMBOO_MODAL_FOOTER';

var ModalFooter = function ModalFooter(_ref) {
	var children = _ref.children,
	    className = _ref.className,
	    props = _objectWithoutProperties(_ref, ['children', 'className']);

	return _react2.default.createElement(
		'div',
		_extends({ className: (0, _classnames2.default)('bmbo-modal-footer', className) }, props),
		children
	);
};

ModalFooter[_componentUtil.BAMBOO_COMPONENT] = BAMBOO_MODAL_FOOTER;

exports.default = ModalFooter;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.BAMBOO_MODAL_PREFACE = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _componentUtil = __webpack_require__(4);

var _uiUtil = __webpack_require__(8);

var _Sequence = __webpack_require__(9);

var _Sequence2 = _interopRequireDefault(_Sequence);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BAMBOO_MODAL_PREFACE = exports.BAMBOO_MODAL_PREFACE = 'BAMBOO_MODAL_PREFACE';

var ModalPreface = function (_React$Component) {
	_inherits(ModalPreface, _React$Component);

	function ModalPreface() {
		_classCallCheck(this, ModalPreface);

		var _this = _possibleConstructorReturn(this, (ModalPreface.__proto__ || Object.getPrototypeOf(ModalPreface)).call(this));

		_this.setContentRef = function (ele) {
			_this.$content = ele;
		};

		_this.checkUpdate = function (preProps, nextProps) {
			if (!preProps.visible !== !nextProps.visible) {
				if (nextProps.visible) {
					var _nextProps$delay = nextProps.delay,
					    delay = _nextProps$delay === undefined ? 400 : _nextProps$delay;

					// Show preface

					_this.seq.next(function () {
						_this.setState({
							animateStatus: _uiUtil.ANIMATE_STATUS_SHOWING,
							contentWidth: 0
						});
					}).next(function () {
						var newState = { animateStatus: _uiUtil.ANIMATE_STATUS_SHOWN };

						if (_this.$content) {
							newState.contentWidth = _this.$content.scrollWidth;
						}

						_this.setState(newState);
					}, { delay: delay });
				} else {
					// Hide preface
					_this.seq.next(function () {
						_this.setState({
							animateStatus: _uiUtil.ANIMATE_STATUS_NONE
						});
					});
				}
			}
		};

		_this.state = {
			animateStatus: _uiUtil.ANIMATE_STATUS_NONE,
			contentWidth: 0
		};
		_this.seq = new _Sequence2.default();
		return _this;
	}

	_createClass(ModalPreface, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.checkUpdate({}, this.props);
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			this.checkUpdate(this.props, nextProps);
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.seq.destroy();
		}
	}, {
		key: 'render',
		value: function render() {
			var _props = this.props,
			    children = _props.children,
			    className = _props.className,
			    props = _objectWithoutProperties(_props, ['children', 'className']);

			var _state = this.state,
			    animateStatus = _state.animateStatus,
			    contentWidth = _state.contentWidth;


			delete props.delay;
			delete props.visible;

			return _react2.default.createElement(
				'div',
				_extends({
					className: (0, _classnames2.default)('bmbo-modal-preface', {
						'bmbo-showing': animateStatus === _uiUtil.ANIMATE_STATUS_SHOWING,
						className: className
					}),
					style: { width: contentWidth ? contentWidth + 'px' : null }
				}, props),
				_react2.default.createElement(
					'div',
					{ className: 'bmbo-modal-preface-content', ref: this.setContentRef },
					children
				)
			);
		}
	}]);

	return ModalPreface;
}(_react2.default.Component);

ModalPreface[_componentUtil.BAMBOO_COMPONENT] = BAMBOO_MODAL_PREFACE;

exports.default = ModalPreface;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.BAMBOO_MODAL_LOADING = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _componentUtil = __webpack_require__(4);

var _Icon = __webpack_require__(24);

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var BAMBOO_MODAL_LOADING = exports.BAMBOO_MODAL_LOADING = 'BAMBOO_MODAL_LOADING';

var ModalLoading = function ModalLoading(_ref) {
	var children = _ref.children,
	    loading = _ref.loading,
	    defaultView = _ref.defaultView,
	    className = _ref.className,
	    props = _objectWithoutProperties(_ref, ['children', 'loading', 'defaultView', 'className']);

	var $content = children;

	if (defaultView) {
		$content = _react2.default.createElement(
			'div',
			{ className: (0, _classnames2.default)('bmbo-default-loading') },
			_react2.default.createElement(_Icon2.default.Loading, null)
		);
	}

	return _react2.default.createElement(
		'div',
		_extends({
			className: (0, _classnames2.default)('bmbo-modal-loading', {
				'bmbo-shown': loading,
				className: className
			})
		}, props),
		$content
	);
};

ModalLoading[_componentUtil.BAMBOO_COMPONENT] = BAMBOO_MODAL_LOADING;

exports.default = ModalLoading;

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _uiUtil = __webpack_require__(8);

var _Sequence = __webpack_require__(9);

var _Sequence2 = _interopRequireDefault(_Sequence);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Curtain = function (_React$Component) {
	_inherits(Curtain, _React$Component);

	function Curtain() {
		_classCallCheck(this, Curtain);

		var _this = _possibleConstructorReturn(this, (Curtain.__proto__ || Object.getPrototypeOf(Curtain)).call(this));

		_this.onTransitionEnd = function (event) {
			if (_this.state.animateStatus === _uiUtil.ANIMATE_STATUS_HIDING && _this.$curtain === event.target) {
				_this.seq.next(function () {
					(0, _uiUtil.enableWinScrollBar)('Curtain');
					_this.setState({ animateStatus: _uiUtil.ANIMATE_STATUS_NONE });
				});
			}
		};

		_this.setCurtainRef = function (ele) {
			_this.$curtain = ele;
		};

		_this.checkUpdate = function (prevProps, nextProps) {
			if (!prevProps.visible === !nextProps.visible) return;

			if (nextProps.visible) {
				_this.seq.next(function () {
					(0, _uiUtil.disableWinScrollBar)('Curtain');
					_this.setState({ animateStatus: _uiUtil.ANIMATE_STATUS_SHOWING });
				}).next(function () {
					_this.setState({ animateStatus: _uiUtil.ANIMATE_STATUS_SHOWN });
				});
			} else {
				_this.seq.next(function () {
					_this.setState({ animateStatus: _uiUtil.ANIMATE_STATUS_HIDING });
				}).next(function () {
					(0, _uiUtil.enableWinScrollBar)('Curtain');
					_this.setState({ animateStatus: _uiUtil.ANIMATE_STATUS_NONE });
				}, { delay: 1000 });
			}
		};

		_this.state = {
			animateStatus: _uiUtil.ANIMATE_STATUS_NONE
		};
		_this.seq = new _Sequence2.default();
		return _this;
	}

	_createClass(Curtain, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.checkUpdate({}, this.props);
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			this.checkUpdate(this.props, nextProps);
		}
	}, {
		key: 'render',
		value: function render() {
			var _props = this.props,
			    children = _props.children,
			    className = _props.className,
			    onClose = _props.onClose,
			    props = _objectWithoutProperties(_props, ['children', 'className', 'onClose']);

			var animateStatus = this.state.animateStatus;


			if (animateStatus === _uiUtil.ANIMATE_STATUS_NONE) return null;

			delete props.visible;

			return _react2.default.createElement(
				'div',
				_extends({
					className: (0, _classnames2.default)('bmbo-curtain', {
						'bmbo-showing': animateStatus === _uiUtil.ANIMATE_STATUS_SHOWING,
						'bmbo-hiding': animateStatus === _uiUtil.ANIMATE_STATUS_HIDING
					}, className),

					ref: this.setCurtainRef,
					onTransitionEnd: this.onTransitionEnd
				}, props),
				_react2.default.createElement(
					'div',
					{ className: 'bmbo-curtain-content-holder' },
					_react2.default.createElement(
						'div',
						{ className: 'bmbo-curtain-content' },
						children,
						onClose && _react2.default.createElement('a', {
							role: 'button',
							tabIndex: -1,
							onClick: onClose,
							className: 'bmbo-curtain-close bmbo-times'
						})
					)
				)
			);
		}
	}]);

	return Curtain;
}(_react2.default.Component);

exports.default = Curtain;

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Progress = function (_React$Component) {
	_inherits(Progress, _React$Component);

	function Progress() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, Progress);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Progress.__proto__ || Object.getPrototypeOf(Progress)).call.apply(_ref, [this].concat(args))), _this), _this.getPercentage = function () {
			var _this$props = _this.props,
			    min = _this$props.min,
			    max = _this$props.max,
			    value = _this$props.value;

			var myValue = value;
			if (myValue > max) myValue = max;
			if (myValue < min) myValue = min;
			return Math.floor((myValue - min) * 100 / (max - min));
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(Progress, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    type = _props.type,
			    size = _props.size,
			    active = _props.active,
			    showMark = _props.showMark,
			    className = _props.className,
			    props = _objectWithoutProperties(_props, ['type', 'size', 'active', 'showMark', 'className']);

			var ptg = this.getPercentage();

			delete props.min;
			delete props.max;
			delete props.value;

			return _react2.default.createElement(
				'div',
				_extends({
					className: (0, _classnames2.default)('bmbo-progress', 'bmbo-' + (type || 'primary'), 'bmbo-' + (size || 'md'), active && 'bmbo-active', className),
					role: 'progressbar'
				}, props),
				_react2.default.createElement(
					'div',
					{ className: 'bmbo-progress-bar', style: { width: ptg + '%' } },
					showMark && _react2.default.createElement(
						'span',
						{ className: 'bmbo-mark' },
						ptg,
						'%'
					)
				)
			);
		}
	}]);

	return Progress;
}(_react2.default.Component);

Progress.defaultProps = {
	min: 0,
	max: 100,
	value: 100
};

exports.default = Progress;

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _Tooltip = __webpack_require__(80);

var _Tooltip2 = _interopRequireDefault(_Tooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TooltipHolder = function (_React$Component) {
	_inherits(TooltipHolder, _React$Component);

	function TooltipHolder() {
		_classCallCheck(this, TooltipHolder);

		var _this = _possibleConstructorReturn(this, (TooltipHolder.__proto__ || Object.getPrototypeOf(TooltipHolder)).call(this));

		_this.onMouseEnter = function (event) {
			var rect = event.currentTarget.getBoundingClientRect();
			_this.setState({ hover: true, rect: rect });
		};

		_this.onMouseLeave = function () {
			_this.setState({ hover: false });
		};

		_this.state = {
			hover: false
		};
		return _this;
	}

	_createClass(TooltipHolder, [{
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    title = _props.title,
			    children = _props.children,
			    placement = _props.placement,
			    maxWidth = _props.maxWidth,
			    className = _props.className,
			    inject = _props.inject,
			    props = _objectWithoutProperties(_props, ['title', 'children', 'placement', 'maxWidth', 'className', 'inject']);

			var _state = this.state,
			    hover = _state.hover,
			    rect = _state.rect;


			if (inject) {
				var childList = _react2.default.Children.map(children, function (node) {
					return _react2.default.cloneElement(node, {
						onMouseEnter: _this2.onMouseEnter,
						onMouseLeave: _this2.onMouseLeave,
						ref: _this2.setHolderRef
					});
				});

				return childList.concat(_react2.default.createElement(
					_Tooltip2.default,
					{ key: 'bmbo-tooltip', visible: hover, rect: rect, placement: placement, maxWidth: maxWidth },
					title
				));
			}

			return _react2.default.createElement(
				'div',
				_extends({
					className: (0, _classnames2.default)('bmbo-tooltip-holder', className),
					onMouseEnter: this.onMouseEnter,
					onMouseLeave: this.onMouseLeave
				}, props),
				children,
				_react2.default.createElement(
					_Tooltip2.default,
					{ visible: hover, rect: rect, placement: placement, maxWidth: maxWidth },
					title
				)
			);
		}
	}]);

	return TooltipHolder;
}(_react2.default.Component);

exports.default = TooltipHolder;

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _uiUtil = __webpack_require__(8);

var _Sequence = __webpack_require__(9);

var _Sequence2 = _interopRequireDefault(_Sequence);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ARROW_DES = 5;

var Tooltip = function (_React$Component) {
	_inherits(Tooltip, _React$Component);

	function Tooltip() {
		_classCallCheck(this, Tooltip);

		var _this = _possibleConstructorReturn(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call(this));

		_this.onTransitionEnd = function (event) {
			if (_this.state.animateStatus === _uiUtil.ANIMATE_STATUS_HIDING && event.target === _this.$holder) {
				_this.seq.next(function () {
					_this.setState({ animateStatus: _uiUtil.ANIMATE_STATUS_NONE });
				});
			}
		};

		_this.setHolderRef = function (ele) {
			_this.$holder = ele;
		};

		_this.checkUpdate = function (prevProps, nextProps) {
			if (!prevProps.visible === !nextProps.visible) return;

			if (nextProps.visible) {
				_this.seq.next(function () {
					_this.setState({ animateStatus: _uiUtil.ANIMATE_STATUS_INIT, x: 0, y: 0 });
				}).next(function () {
					var rect = _this.props.rect;

					if (!_this.$holder) return;

					var ps = void 0;
					switch (nextProps.placement) {
						case 'bottom':
							ps = 'b,lr';
							break;
						case 'left':
							ps = 'l,tb';
							break;
						case 'right':
							ps = 'r,tb';
							break;
						default:
							ps = 't,lr';
					}

					var left = rect.left,
					    width = rect.width,
					    top = rect.top,
					    height = rect.height;

					var tgtRect = _this.$holder.getBoundingClientRect();

					var _getEnablePosition = (0, _uiUtil.getEnablePosition)({
						left: left - ARROW_DES,
						top: top - ARROW_DES,
						width: width + 2 * ARROW_DES,
						height: height + 2 * ARROW_DES
					}, tgtRect, ps),
					    _x = _getEnablePosition._x,
					    _y = _getEnablePosition._y,
					    pos = _objectWithoutProperties(_getEnablePosition, ['_x', '_y']);

					var arrowOffsetX = _x - pos.x;
					var arrowOffsetY = _y - pos.y;

					_this.setState(_extends({
						animateStatus: _uiUtil.ANIMATE_STATUS_SHOWING
					}, pos, {
						arrowOffsetX: arrowOffsetX,
						arrowOffsetY: arrowOffsetY
					}));
				}).next(function () {
					_this.setState({ animateStatus: _uiUtil.ANIMATE_STATUS_SHOWN });
				});
			} else {
				_this.seq.next(function () {
					_this.setState({ animateStatus: _uiUtil.ANIMATE_STATUS_HIDING });
				}).next(function () {
					_this.setState({ animateStatus: _uiUtil.ANIMATE_STATUS_NONE });
				}, { delay: 1000 });
			}
		};

		_this.state = {
			animateStatus: _uiUtil.ANIMATE_STATUS_NONE,
			x: 0,
			y: 0
		};
		_this.seq = new _Sequence2.default();
		return _this;
	}

	_createClass(Tooltip, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			this.checkUpdate({}, this.props);
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			this.checkUpdate(this.props, nextProps);
		}
	}, {
		key: 'render',
		value: function render() {
			var _props = this.props,
			    children = _props.children,
			    placement = _props.placement,
			    maxWidth = _props.maxWidth;
			var _state = this.state,
			    animateStatus = _state.animateStatus,
			    x = _state.x,
			    y = _state.y,
			    arrowOffsetX = _state.arrowOffsetX,
			    arrowOffsetY = _state.arrowOffsetY;


			if (animateStatus === _uiUtil.ANIMATE_STATUS_NONE) return null;

			return (0, _uiUtil.createPortal)(_react2.default.createElement(
				'div',
				{
					className: (0, _classnames2.default)('bmbo-tooltip', {
						'bmbo-hidden': animateStatus === _uiUtil.ANIMATE_STATUS_INIT,
						'bmbo-showing': animateStatus === _uiUtil.ANIMATE_STATUS_SHOWING,
						'bmbo-hiding': animateStatus === _uiUtil.ANIMATE_STATUS_HIDING
					}, 'bmbo-' + (placement || 'top')),
					style: { left: x + 'px', top: y + 'px' },
					ref: this.setHolderRef,
					onTransitionEnd: this.onTransitionEnd
				},
				_react2.default.createElement(
					'div',
					{
						className: 'bmbo-tooltip-title',
						style: { maxWidth: maxWidth && maxWidth + 'px' }
					},
					children
				),
				_react2.default.createElement('div', {
					className: 'bmbo-tooltip-arrow',
					style: { marginLeft: arrowOffsetX + 'px', marginTop: arrowOffsetY + 'px' }
				})
			));
		}
	}]);

	return Tooltip;
}(_react2.default.Component);

exports.default = Tooltip;

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Sequence = __webpack_require__(9);

var _Sequence2 = _interopRequireDefault(_Sequence);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DynamicNumber = function (_React$Component) {
	_inherits(DynamicNumber, _React$Component);

	function DynamicNumber() {
		_classCallCheck(this, DynamicNumber);

		var _this = _possibleConstructorReturn(this, (DynamicNumber.__proto__ || Object.getPrototypeOf(DynamicNumber)).call(this));

		_this.doAnimation = function (props) {
			var value = props.value,
			    duration = props.duration,
			    step = props.step,
			    decimal = props.decimal;

			var currentValue = Number(_this.state.current);

			// Ignore if value not change
			if (value === currentValue) {
				_this.seq.stop();
				return;
			}

			var startValue = isNaN(currentValue) ? 0 : currentValue;

			if (step) {
				// Use step
				var myStep = Math.abs(step);
				if (isNaN(myStep) || myStep === 0) myStep = 1;

				var frameStep = currentValue < value ? myStep : -myStep;
				var current = currentValue;

				_this.seq.next(function () {
					if (Math.abs(current - value) <= myStep) {
						_this.setState({ current: value.toFixed(decimal) });
						return false;
					}

					current += frameStep;
					_this.setState({ current: current.toFixed(decimal) });

					return null;
				}, {
					loop: true
				});
			} else {
				// Use duration
				var startTime = Date.now();

				_this.seq.next(function () {
					var currentTime = Date.now();
					var distance = currentTime - startTime;

					if (distance >= duration) {
						_this.setState({ current: value.toFixed(decimal) });
						return false;
					}

					var current = (startValue + (value - startValue) * (distance / duration)).toFixed(decimal);
					_this.setState({ current: current });

					return null;
				}, {
					loop: true
				});
			}
		};

		_this.state = {
			current: 0
		};

		_this.seq = new _Sequence2.default();
		return _this;
	}

	_createClass(DynamicNumber, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			this.doAnimation(this.props);
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			this.doAnimation(nextProps);
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.seq.destroy();
		}
	}, {
		key: 'render',
		value: function render() {
			var current = this.state.current;

			var props = _extends({}, this.props);
			delete props.value;
			delete props.duration;
			delete props.decimal;
			delete props.step;

			return _react2.default.createElement(
				'span',
				props,
				current
			);
		}
	}]);

	return DynamicNumber;
}(_react2.default.Component);

DynamicNumber.defaultProps = {
	duration: 1000,
	decimal: 0
};

exports.default = DynamicNumber;

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Sequence = __webpack_require__(9);

var _Sequence2 = _interopRequireDefault(_Sequence);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DynamicString = function (_React$Component) {
	_inherits(DynamicString, _React$Component);

	function DynamicString() {
		_classCallCheck(this, DynamicString);

		var _this = _possibleConstructorReturn(this, (DynamicString.__proto__ || Object.getPrototypeOf(DynamicString)).call(this));

		_this.doAnimation = function (props) {
			var value = props.value,
			    duration = props.duration,
			    step = props.step;

			var currentValue = _this.state.current;

			// Ignore if value not change
			if (value === currentValue) {
				_this.seq.stop();
				return;
			}

			var totalLen = currentValue.length + value.length;
			if (totalLen === 0) {
				// Skip if not word left
				_this.seq.stop();
				_this.setState({ current: '' });
				return;
			}

			var hidePtg = currentValue.length / totalLen;

			if (step) {
				// Use step
				var myStep = Math.ceil(Math.abs(step));
				if (isNaN(myStep) || myStep === 0) myStep = 1;

				var hiding = true;
				var current = currentValue;
				_this.seq.next(function () {
					if (hiding) {
						var len = Math.max(0, current.length - step);
						current = current.slice(0, len);
						_this.setState({ current: current });

						if (len === 0) hiding = false;
					} else {
						current = value.slice(0, current.length + step);
						_this.setState({ current: current });

						if (current.length === value.length) return false;
					}

					return null;
				}, {
					loop: true
				});
			} else {
				// Use duration
				var startTime = Date.now();
				_this.seq.next(function () {
					var currentTime = Date.now();
					var distance = currentTime - startTime;

					if (distance >= duration) {
						_this.setState({ current: value });
						return false;
					}

					var ptg = distance / duration;
					if (ptg < hidePtg) {
						var desPtg = (hidePtg - ptg) / hidePtg;
						_this.setState({
							current: currentValue.slice(0, Math.floor(currentValue.length * desPtg))
						});
					} else {
						var _desPtg = (ptg - hidePtg) / (1 - hidePtg);
						_this.setState({ current: value.slice(0, Math.floor(value.length * _desPtg)) });
					}

					return null;
				}, {
					loop: true
				});
			}
		};

		_this.state = {
			current: ''
		};

		_this.seq = new _Sequence2.default();
		return _this;
	}

	_createClass(DynamicString, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			this.doAnimation(this.props);
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			this.doAnimation(nextProps);
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.seq.destroy();
		}
	}, {
		key: 'render',
		value: function render() {
			var current = this.state.current;

			var _props = this.props,
			    cursor = _props.cursor,
			    props = _objectWithoutProperties(_props, ['cursor']);

			delete props.value;
			delete props.duration;
			delete props.step;

			return _react2.default.createElement(
				'span',
				props,
				current,
				cursor && _react2.default.createElement('span', { className: 'bmbo-text-cursor' })
			);
		}
	}]);

	return DynamicString;
}(_react2.default.Component);

DynamicString.defaultProps = {
	duration: 1000
};

exports.default = DynamicString;

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _pathUtil = __webpack_require__(18);

var _Input = __webpack_require__(17);

var _Input2 = _interopRequireDefault(_Input);

var _List = __webpack_require__(84);

var _List2 = _interopRequireDefault(_List);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KEY_UP = 38;
var KEY_DOWN = 40;
var KEY_ENTER = 13;
var OP_KEY_LIST = [KEY_UP, KEY_DOWN, KEY_ENTER];
var id = 0;

var AutoComplete = function (_React$PureComponent) {
	_inherits(AutoComplete, _React$PureComponent);

	function AutoComplete() {
		_classCallCheck(this, AutoComplete);

		var _this = _possibleConstructorReturn(this, (AutoComplete.__proto__ || Object.getPrototypeOf(AutoComplete)).call(this));

		_this.onKeyDown = function (nodeOnChange) {
			for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
				args[_key - 1] = arguments[_key];
			}

			var event = args[0];

			// Ignore if list is empty
			var _this$state = _this.state,
			    selectedIndex = _this$state.selectedIndex,
			    list = _this$state.list;

			if (!list || !list.length) return;

			// Check if is direct key
			var which = event.which;

			if (!OP_KEY_LIST.includes(which)) return;
			event.preventDefault();

			if (which === KEY_UP || which === KEY_DOWN) {
				// Move operation
				var myIndex = selectedIndex;
				if (which === 38) {
					myIndex -= 1;
				} else if (which === 40) {
					myIndex += 1;
				}
				myIndex = (myIndex + list.length) % list.length;

				_this.setState({
					selectedIndex: myIndex
				});
			} else if (which === KEY_ENTER) {
				// Select item
				event.target.value = list[selectedIndex].value;
				nodeOnChange.apply(undefined, args);

				_this.setState({
					selectedIndex: 0,
					list: null
				});
			}
		};

		_this.onKeyUp = function (event) {
			var which = event.which,
			    target = event.target;


			if (OP_KEY_LIST.includes(which)) return;

			var list = _this.getMatchList(target.value);

			_this.setState({
				list: list,
				rect: target.getBoundingClientRect()
			});
		};

		_this.onBlur = function () {
			_this.setState({
				selectedIndex: 0,
				list: null
			});
		};

		_this.getMatchList = function (str) {
			var matcher = _this.props.matcher;

			if (!matcher || !str) return null;

			var myStr = str.toUpperCase();

			if (Array.isArray(matcher)) {
				var len = matcher.length;
				var list = [];
				for (var i = 0; i < len; i += 1) {
					var cur = matcher[i];

					// String match
					if (typeof cur === 'string') {
						if (cur.toUpperCase().includes(myStr)) {
							list.push({ value: cur });
						}
					} else {
						var value = cur.value;

						if (String(value).toUpperCase().includes(myStr)) {
							list.push(cur);
						}
					}

					if (list.length >= 10) break;
				}

				return list;
			}

			return [];
		};

		_this.state = {
			list: null,
			selectedIndex: 0
		};

		_this.id = id;
		id += 1;
		return _this;
	}

	_createClass(AutoComplete, [{
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    children = _props.children,
			    props = _objectWithoutProperties(_props, ['children']);

			var _state = this.state,
			    list = _state.list,
			    rect = _state.rect,
			    selectedIndex = _state.selectedIndex;


			delete props.matcher;

			var myChildren = children || _react2.default.createElement(_Input2.default, null);

			var $children = _react2.default.Children.map(myChildren, function (node) {
				var nodeOnKeyDown = (0, _pathUtil.getValue)(node, ['props', 'onKeyDown']);
				var nodeOnKeyUp = (0, _pathUtil.getValue)(node, ['props', 'onKeyUp']);
				var nodeOnBlur = (0, _pathUtil.getValue)(node, ['props', 'onBlur']);
				var nodeOnChange = (0, _pathUtil.getValue)(node, ['props', 'onChange']) || _this2.props.onChange;

				return _react2.default.cloneElement(node, _extends({}, props, {
					onKeyDown: function onKeyDown() {
						for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
							args[_key2] = arguments[_key2];
						}

						if (nodeOnKeyDown) nodeOnKeyDown.apply(undefined, args);
						_this2.onKeyDown.apply(_this2, [nodeOnChange].concat(args));
					},
					onKeyUp: function onKeyUp() {
						if (nodeOnKeyUp) nodeOnKeyUp.apply(undefined, arguments);
						_this2.onKeyUp.apply(_this2, arguments);
					},
					onBlur: function onBlur() {
						if (nodeOnBlur) nodeOnBlur.apply(undefined, arguments);
						_this2.onBlur.apply(_this2, arguments);
					}
				}));
			});

			return [].concat(_toConsumableArray($children), [_react2.default.createElement(_List2.default, { key: 'list_' + this.id, list: list, rect: rect, selectedIndex: selectedIndex })]);
		}
	}]);

	return AutoComplete;
}(_react2.default.PureComponent);

exports.default = AutoComplete;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _uiUtil = __webpack_require__(8);

var _arrayUtil = __webpack_require__(26);

var _Sequence = __webpack_require__(9);

var _Sequence2 = _interopRequireDefault(_Sequence);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var List = function (_React$PureComponent) {
	_inherits(List, _React$PureComponent);

	function List() {
		_classCallCheck(this, List);

		var _this = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this));

		_this.onContainerTransitionEnd = function (event) {
			// Set state to NONE when hide animation done
			if (event.target !== _this.$container || _this.state.animateStatus !== _uiUtil.ANIMATE_STATUS_HIDING) return;
			_this.seq.next(function () {
				_this.setState({
					animateStatus: _uiUtil.ANIMATE_STATUS_NONE
				});
			});
		};

		_this.setContainerRef = function (ele) {
			_this.$container = ele;
		};

		_this.setListRef = function (ele) {
			_this.$list = ele;
		};

		_this.checkUpdate = function (prevProps, nextProps) {
			var list = nextProps.list,
			    rect = nextProps.rect;

			if (prevProps.list === list || !prevProps.list && !list) return;
			if (prevProps.list && list && (0, _arrayUtil.equals)(prevProps.list, list, ['value'])) return;

			if (!list || list.length === 0) {
				// Hide list
				_this.seq.next(function () {
					_this.setState({
						height: 0,
						animateStatus: _uiUtil.ANIMATE_STATUS_HIDING
					});
				});
			} else {
				// Show list
				var height = void 0;

				_this.seq.next(function (done) {
					_this.setState(function (preState) {
						var myState = {
							currentList: list,
							width: rect.width
						};

						if (preState.animateStatus === _uiUtil.ANIMATE_STATUS_NONE) {
							myState.animateStatus = _uiUtil.ANIMATE_STATUS_INIT;
						} else {
							myState.animateStatus = _uiUtil.ANIMATE_STATUS_SHOWING;
						}

						return myState;
					}, done);
				}).next(function (done) {
					var listRect = _this.$list.getBoundingClientRect();
					height = listRect.height;

					_this.setState(_extends({}, (0, _uiUtil.getEnablePosition)(rect, listRect, 'b')), done);
				}).next(function () {
					_this.setState({
						height: height,
						animateStatus: _uiUtil.ANIMATE_STATUS_SHOWN
					});
				});
			}
		};

		_this.state = {
			x: 0,
			y: 0,
			animateStatus: _uiUtil.ANIMATE_STATUS_NONE,

			height: 0,
			width: 0,
			currentList: null
		};

		_this.seq = new _Sequence2.default();
		return _this;
	}

	_createClass(List, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			this.checkUpdate({}, this.props);
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			this.checkUpdate(this.props, nextProps);
		}
	}, {
		key: 'render',
		value: function render() {
			var _state = this.state,
			    currentList = _state.currentList,
			    height = _state.height,
			    width = _state.width,
			    animateStatus = _state.animateStatus,
			    x = _state.x,
			    y = _state.y;


			if (animateStatus === _uiUtil.ANIMATE_STATUS_NONE) return null;

			var selectedIndex = this.props.selectedIndex;


			return (0, _uiUtil.createPortal)(_react2.default.createElement(
				'div',
				{
					className: (0, _classnames2.default)('bmbo-auto-container', {
						'bmbo-init': animateStatus === _uiUtil.ANIMATE_STATUS_INIT,
						'bmbo-showing': animateStatus === _uiUtil.ANIMATE_STATUS_SHOWING,
						'bmbo-hiding': animateStatus === _uiUtil.ANIMATE_STATUS_HIDING
					}),
					style: {
						height: height + 'px',
						width: width + 'px',
						left: x + 'px',
						top: y + 'px'
					},

					ref: this.setContainerRef,
					onTransitionEnd: this.onContainerTransitionEnd
				},
				_react2.default.createElement(
					'ul',
					{ className: 'bmbo-auto-list', ref: this.setListRef },
					(currentList || []).map(function (_ref, index) {
						var value = _ref.value;
						return _react2.default.createElement(
							'li',
							{ key: index, className: (0, _classnames2.default)(selectedIndex === index && 'bmbo-active') },
							value
						);
					})
				)
			));
		}
	}]);

	return List;
}(_react2.default.PureComponent);

exports.default = List;

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _componentUtil = __webpack_require__(4);

var _pathUtil = __webpack_require__(18);

var _Column = __webpack_require__(86);

var _Column2 = _interopRequireDefault(_Column);

var _Pagination = __webpack_require__(87);

var _Pagination2 = _interopRequireDefault(_Pagination);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Table = function (_React$Component) {
	_inherits(Table, _React$Component);

	function Table() {
		_classCallCheck(this, Table);

		var _this = _possibleConstructorReturn(this, (Table.__proto__ || Object.getPrototypeOf(Table)).call(this));

		_this.getPage = function () {
			var page = _this.props.page;

			return page === undefined ? _this.state.page : page;
		};

		_this.getCount = function () {
			var _this$props = _this.props,
			    count = _this$props.count,
			    data = _this$props.data;

			return count === undefined ? (data || []).length : count;
		};

		_this.getColumnList = function () {
			var children = _this.props.children;

			return (0, _componentUtil.mapChildrenByType)(children, _Column.BAMBOO_TABLE_COLUMN);
		};

		_this.getList = function () {
			var _this$props2 = _this.props,
			    pageSize = _this$props2.pageSize,
			    page = _this$props2.page,
			    count = _this$props2.count,
			    data = _this$props2.data;
			var list = _this.state.list;


			if (page !== undefined && count !== undefined) {
				return data;
			}

			var myPage = _this.getPage();
			return list.slice((myPage - 1) * pageSize, myPage * pageSize);
		};

		_this.checkUpdate = function (prevProps, nextProps) {
			if (prevProps.data === nextProps.data) return;

			_this.setState({
				list: (nextProps.data || []).concat()
			}, function () {
				// TODO: Support sort function
			});
		};

		_this.gotoPage = function (page) {
			var onPageChange = _this.props.onPageChange;

			_this.setState({ page: page });

			if (onPageChange) onPageChange(page);
		};

		_this.state = {
			page: 1,
			list: []
		};
		return _this;
	}

	_createClass(Table, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			this.checkUpdate({}, this.props);
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			this.checkUpdate(this.props, nextProps);
		}
	}, {
		key: 'render',
		value: function render() {
			var _props = this.props,
			    className = _props.className,
			    pageSize = _props.pageSize,
			    bordered = _props.bordered,
			    hover = _props.hover,
			    onRowClick = _props.onRowClick,
			    props = _objectWithoutProperties(_props, ['className', 'pageSize', 'bordered', 'hover', 'onRowClick']);

			delete props.page;
			delete props.count;
			delete props.data;
			delete props.onPageChange;

			var page = this.getPage();

			var columnList = this.getColumnList().map(function (c) {
				return c.props;
			});
			var list = this.getList();

			return _react2.default.createElement(
				'div',
				{ className: 'bmbo-table-container' },
				_react2.default.createElement(
					'table',
					_extends({
						className: (0, _classnames2.default)('bmbo-table', bordered && 'bmbo-bordered', className)

					}, props),
					_react2.default.createElement(
						'colgroup',
						null,
						columnList.map(function (_ref, colIndex) {
							var width = _ref.width;
							return _react2.default.createElement('col', { key: colIndex, width: width });
						})
					),
					_react2.default.createElement(
						'thead',
						null,
						_react2.default.createElement(
							'tr',
							null,
							columnList.map(function (_ref2, colIndex) {
								var title = _ref2.title,
								    name = _ref2.name;
								return _react2.default.createElement(
									'td',
									{ key: colIndex },
									title || name
								);
							})
						)
					),
					_react2.default.createElement(
						'tbody',
						{ className: (0, _classnames2.default)(hover && 'bmbo-hover') },
						list.map(function (item, rowIndex) {
							var trProps = {};

							if (onRowClick) {
								trProps.role = 'button';
								trProps.tabIndex = -1;
								trProps.onClick = function () {
									onRowClick(item, rowIndex);
								};
							}

							return _react2.default.createElement(
								'tr',
								_extends({ key: rowIndex }, trProps),
								columnList.map(function (column, colIndex) {
									var name = column.name,
									    render = column.render,
									    colProps = _objectWithoutProperties(column, ['name', 'render']);

									delete colProps.width;

									return _react2.default.createElement(
										'td',
										_extends({ key: colIndex }, colProps),
										render ? render(item) : (0, _pathUtil.getValue)(item, name)
									);
								})
							);
						})
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'bmbo-table-pagination' },
					_react2.default.createElement(_Pagination2.default, {
						page: page,
						pageSize: pageSize,
						count: this.getCount(),
						gotoPage: this.gotoPage
					})
				)
			);
		}
	}]);

	return Table;
}(_react2.default.Component);

Table.defaultProps = {
	pageSize: 10
};

Table.Column = _Column2.default;

exports.default = Table;

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.BAMBOO_TABLE_COLUMN = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentUtil = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BAMBOO_TABLE_COLUMN = exports.BAMBOO_TABLE_COLUMN = 'BAMBOO_TABLE_COLUMN';

var Column = function Column() {
	return null;
};

Column.propTypes = {
	title: _propTypes2.default.node,
	render: _propTypes2.default.func
};

Column[_componentUtil.BAMBOO_COMPONENT] = BAMBOO_TABLE_COLUMN;

exports.default = Column;

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _Button = __webpack_require__(16);

var _Button2 = _interopRequireDefault(_Button);

var _Group = __webpack_require__(36);

var _Group2 = _interopRequireDefault(_Group);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Pagination = function (_React$Component) {
	_inherits(Pagination, _React$Component);

	function Pagination() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, Pagination);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Pagination.__proto__ || Object.getPrototypeOf(Pagination)).call.apply(_ref, [this].concat(args))), _this), _this.gotoPage = function (page) {
			var gotoPage = _this.props.gotoPage;

			if (gotoPage) gotoPage(page);
		}, _this.goPrevPage = function () {
			var page = _this.props.page;

			if (page > 1) _this.gotoPage(page - 1);
		}, _this.goNextPage = function () {
			var _this$props = _this.props,
			    page = _this$props.page,
			    count = _this$props.count,
			    pageSize = _this$props.pageSize;

			var totalPages = Math.ceil(count / pageSize);
			if (page < totalPages) _this.gotoPage(page + 1);
		}, _this.goFirstPage = function () {
			_this.gotoPage(1);
		}, _this.goLastPage = function () {
			var _this$props2 = _this.props,
			    count = _this$props2.count,
			    pageSize = _this$props2.pageSize;

			var totalPages = Math.ceil(count / pageSize);
			_this.gotoPage(totalPages);
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(Pagination, [{
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    count = _props.count,
			    pageSize = _props.pageSize,
			    _props$page = _props.page,
			    page = _props$page === undefined ? 1 : _props$page,
			    _props$range = _props.range,
			    range = _props$range === undefined ? 9 : _props$range,
			    disabled = _props.disabled,
			    className = _props.className,
			    props = _objectWithoutProperties(_props, ['count', 'pageSize', 'page', 'range', 'disabled', 'className']);

			delete props.gotoPage;

			var totalPages = Math.ceil(count / pageSize);

			var lRange = Math.floor((range - 1) / 2);
			var rRange = range - 1 - lRange;
			var minPage = page - lRange;
			var maxPage = page + rRange;

			if (minPage < 1) {
				maxPage += -minPage + 1;
				minPage = 1;
			}
			if (maxPage > totalPages) {
				minPage -= maxPage - totalPages;
				maxPage = totalPages;
			}
			if (minPage < 1) minPage = 1;

			var $navItems = [];
			var index = 0;

			var _loop = function _loop(i) {
				$navItems.push(_react2.default.createElement(
					_Button2.default,
					{
						key: index,
						disabled: disabled,
						onClick: function onClick() {
							_this2.gotoPage(i);
						},
						type: page === i ? 'primary' : 'weak',
						transparent: true
					},
					i
				));

				index += 1;
			};

			for (var i = minPage; i <= maxPage; i += 1) {
				_loop(i);
			}

			return _react2.default.createElement(
				_Group2.default,
				_extends({ className: (0, _classnames2.default)('bmbo-pagination', className) }, props),
				_react2.default.createElement(
					_Button2.default,
					{ type: 'weak', transparent: true, onClick: this.goFirstPage, disabled: page <= 1 || disabled },
					'\xAB'
				),
				_react2.default.createElement(
					_Button2.default,
					{ type: 'weak', transparent: true, onClick: this.goPrevPage, disabled: page <= 1 || disabled },
					'\u2039'
				),
				$navItems,
				_react2.default.createElement(
					_Button2.default,
					{ type: 'weak', transparent: true, onClick: this.goNextPage, disabled: page >= totalPages || disabled },
					'\u203A'
				),
				_react2.default.createElement(
					_Button2.default,
					{ type: 'weak', transparent: true, onClick: this.goLastPage, disabled: page >= totalPages || disabled },
					'\xBB'
				)
			);
		}
	}]);

	return Pagination;
}(_react2.default.Component);

exports.default = Pagination;

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Label = function Label(_ref) {
	var type = _ref.type,
	    size = _ref.size,
	    className = _ref.className,
	    children = _ref.children,
	    props = _objectWithoutProperties(_ref, ['type', 'size', 'className', 'children']);

	return _react2.default.createElement(
		'span',
		_extends({
			className: (0, _classnames2.default)('bmbo-label', 'bmbo-' + (type || 'primary'), 'bmbo-' + (size || 'md'), className)
		}, props),
		children
	);
};

exports.default = Label;

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _arrayUtil = __webpack_require__(26);

var _eventUtil = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FlatList = function (_React$Component) {
	_inherits(FlatList, _React$Component);

	function FlatList() {
		_classCallCheck(this, FlatList);

		var _this = _possibleConstructorReturn(this, (FlatList.__proto__ || Object.getPrototypeOf(FlatList)).call(this));

		_this.onItemClick = function (event, level, itemValue) {
			var _this$props = _this.props,
			    value = _this$props.value,
			    onChange = _this$props.onChange;


			var myValue = (0, _arrayUtil.toArray)(value).slice(0, level);
			myValue[level] = itemValue;

			if (onChange) {
				onChange((0, _eventUtil.wrapperEventValue)(event, _this.$ele, myValue));
			}
		};

		_this.setRef = function (ele) {
			_this.$ele = ele;
		};

		_this.getMaxLevel = function () {
			return _this.props.columns || _this.state.maxLevel;
		};

		_this.getList = function () {
			var level = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
			var _this$props$list = _this.props.list,
			    list = _this$props$list === undefined ? [] : _this$props$list;
			var levelLists = _this.state.levelLists;


			if (level === 0) return list;

			return levelLists[level] || [];
		};

		_this.refreshList = function (prevProps, nextProps) {
			if (prevProps.value === nextProps.value && prevProps.list === nextProps.list) return;

			var _nextProps$list = nextProps.list,
			    list = _nextProps$list === undefined ? [] : _nextProps$list;

			var levelLists = {};
			var valueList = (0, _arrayUtil.toArray)(nextProps.value);

			var current = list;

			var _loop = function _loop(i) {
				var currentValue = valueList[i];
				current = current.find(function (_ref) {
					var value = _ref.value;
					return value === currentValue;
				});

				if (!current) {
					// Skip if path not match
					return 'break';
				}

				current = current.list || [];
				levelLists[i + 1] = current;
			};

			for (var i = 0; i < valueList.length; i += 1) {
				var _ret = _loop(i);

				if (_ret === 'break') break;
			}

			_this.setState({ levelLists: levelLists });
		};

		_this.state = {
			maxLevel: 1,
			levelLists: {}
		};
		return _this;
	}

	_createClass(FlatList, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			this.refreshList({}, this.props);
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			this.refreshList(this.props, nextProps);
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    size = _props.size,
			    className = _props.className,
			    props = _objectWithoutProperties(_props, ['size', 'className']);

			delete props.value;
			delete props.list;
			delete props.multi;
			delete props.columns;
			delete props.onChange;

			var myValue = (0, _arrayUtil.toArray)(this.props.value);

			return _react2.default.createElement(
				'div',
				_extends({}, props, {
					className: (0, _classnames2.default)('bmbo-flat-list', 'bmbo-' + (size || 'md'), className),
					ref: this.setRef
				}),
				new Array(this.getMaxLevel()).fill(0).map(function (_, level) {
					var list = _this2.getList(level);
					var levelValue = myValue[level];

					return _react2.default.createElement(
						'ul',
						{
							key: level,
							className: 'bmbo-flat-list-column'
						},
						list.map(function (_ref2) {
							var title = _ref2.title,
							    value = _ref2.value;
							return _react2.default.createElement(
								'li',
								{
									className: (0, _classnames2.default)('bmbo-flat-list-item', levelValue === value && 'bmbo-active'),
									key: value
								},
								_react2.default.createElement(
									'span',
									{
										className: 'bmbo-padding',
										role: 'button',
										tabIndex: -1,
										onClick: function onClick(event) {
											_this2.onItemClick(event, level, value);
										}
									},
									title || value
								)
							);
						})
					);
				})
			);
		}
	}]);

	return FlatList;
}(_react2.default.Component);

exports.default = FlatList;

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentUtil = __webpack_require__(4);

var _eventUtil = __webpack_require__(10);

var _PinBox = __webpack_require__(27);

var _PinBox2 = _interopRequireDefault(_PinBox);

var _Input = __webpack_require__(17);

var _Input2 = _interopRequireDefault(_Input);

var _DatePicker = __webpack_require__(91);

var _DatePicker2 = _interopRequireDefault(_DatePicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Picker = function (_React$Component) {
	_inherits(Picker, _React$Component);

	function Picker() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, Picker);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Picker.__proto__ || Object.getPrototypeOf(Picker)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function (event) {
			var onChange = _this.props.onChange;

			if (onChange) {
				onChange((0, _eventUtil.wrapperEventValue)(event, _this.$input, event.target.value));
			}
		}, _this.setRef = function (ele) {
			_this.$input = ele;
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(Picker, [{
		key: 'render',
		value: function render() {
			var value = this.props.value;


			var $pin = _react2.default.createElement(_DatePicker2.default, { value: value, onChange: this.onChange });

			return _react2.default.createElement(
				_PinBox2.default,
				{ pin: $pin, backdrop: true },
				_react2.default.createElement(_Input2.default, _extends({}, _defineProperty({}, _componentUtil.BAMBOO_INTERNAL_REF, this.setRef), this.props))
			);
		}
	}]);

	return Picker;
}(_react2.default.Component);

exports.default = Picker;

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _dateUtils = __webpack_require__(92);

var _eventUtil = __webpack_require__(10);

var _envUtil = __webpack_require__(11);

var _uiUtil = __webpack_require__(8);

var _Sequence = __webpack_require__(9);

var _Sequence2 = _interopRequireDefault(_Sequence);

var _DatePanel = __webpack_require__(93);

var _DatePanel2 = _interopRequireDefault(_DatePanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DATE_LIST = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];

var DatePicker = function (_React$Component) {
	_inherits(DatePicker, _React$Component);

	function DatePicker() {
		_classCallCheck(this, DatePicker);

		var _this = _possibleConstructorReturn(this, (DatePicker.__proto__ || Object.getPrototypeOf(DatePicker)).call(this));

		_this.onSwitchDateView = function (nextDate) {
			if (_this.state.animateStatus !== _uiUtil.ANIMATE_STATUS_NONE) return;
			_this.switchDateView(nextDate);
		};

		_this.onTransitionEnd = function (event) {
			var _this$state = _this.state,
			    animateStatus = _this$state.animateStatus,
			    nextViewDate = _this$state.nextViewDate;


			if (event.target === _this.$nextView && animateStatus === _uiUtil.ANIMATE_STATUS_SHOWN) {
				_this.seq.next(function () {
					_this.setState({
						animateStatus: _uiUtil.ANIMATE_STATUS_NONE,
						viewDate: nextViewDate,
						nextViewDate: null
					});
				});
			}
		};

		_this.setRef = function (ele) {
			_this.$ele = ele;
		};

		_this.setViewRef = function (ele) {
			_this.$view = ele;
		};

		_this.setNextViewRef = function (ele) {
			_this.$nextView = ele;
		};

		_this.checkUpdate = function (prevProps, nextProps) {
			if (prevProps.value === nextProps.value) return;

			var viewDate = _this.state.viewDate;

			var nextDate = new _dateUtils.BambooDate(nextProps.value);

			if (!prevProps.value || viewDate && viewDate.format('YYYY-MM') === nextDate.format('YYYY-MM')) {
				_this.setState({
					viewDate: nextDate
				});
			} else {
				var prevDate = new _dateUtils.BambooDate(prevProps.value);
				if (prevDate.format('YYYY-MM') === nextDate.format('YYYY-MM')) return;

				_this.switchDateView(nextDate);
			}
		};

		_this.switchDateView = function (nextDate) {
			_this.seq.next(function (done) {
				_this.setState({
					animateStatus: _uiUtil.ANIMATE_STATUS_SHOWING,
					nextViewDate: nextDate
				}, done);
			}).next(function (done) {
				_this.setState({
					animateStatus: _uiUtil.ANIMATE_STATUS_SHOWN
				}, done);
			});
		};

		_this.triggerChangeEvent = function (event, date) {
			var onChange = _this.props.onChange;

			if (onChange) {
				onChange((0, _eventUtil.wrapperEventValue)(event, _this.$ele, date.format('YYYY-MM-DD')));
			}
		};

		_this.state = {
			animateStatus: _uiUtil.ANIMATE_STATUS_NONE,

			viewDate: null, // This is used for show current year-month panel
			nextViewDate: null // This is used for animation panel
		};

		_this.seq = new _Sequence2.default();
		return _this;
	}

	_createClass(DatePicker, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			this.checkUpdate({}, this.props);
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			this.checkUpdate(this.props, nextProps);
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _state = this.state,
			    animateStatus = _state.animateStatus,
			    viewDate = _state.viewDate,
			    nextViewDate = _state.nextViewDate;

			if (!viewDate) return null;

			var _props = this.props,
			    value = _props.value,
			    className = _props.className,
			    props = _objectWithoutProperties(_props, ['value', 'className']);

			delete props.onChange;

			var date = new _dateUtils.BambooDate(value);

			var isShowing = animateStatus === _uiUtil.ANIMATE_STATUS_SHOWING;
			var isShown = animateStatus === _uiUtil.ANIMATE_STATUS_SHOWN;

			// Current view
			var startDate = viewDate.clone().setDate(1);
			var endDate = viewDate.clone().setDate(1);
			startDate.setDay(0);
			endDate.setMonth(endDate.getMonth() + 1).setDate(0).setDay(6);
			var $view = _react2.default.createElement(_DatePanel2.default, {
				date: date,
				viewDate: viewDate,
				startDate: startDate,
				endDate: endDate,
				triggerChangeEvent: this.triggerChangeEvent,
				setRef: this.setViewRef,
				className: (0, _classnames2.default)({
					'bmbo-left': isShown && nextViewDate.getTime() > viewDate.getTime(),
					'bmbo-right': isShown && nextViewDate.getTime() < viewDate.getTime()
				})
			});

			// Next view
			var $nextView = void 0;
			if (animateStatus !== _uiUtil.ANIMATE_STATUS_NONE) {
				var nextStartDate = nextViewDate.clone().setDate(1);
				var nextEndDate = nextViewDate.clone().setDate(1);
				nextStartDate.setDay(0);
				nextEndDate.setMonth(nextEndDate.getMonth() + 1).setDate(0).setDay(6);
				$nextView = _react2.default.createElement(_DatePanel2.default, {
					date: date,
					viewDate: nextViewDate,
					startDate: nextStartDate,
					endDate: nextEndDate,
					setRef: this.setNextViewRef,
					onTransitionEnd: this.onTransitionEnd,
					className: (0, _classnames2.default)('bmbo-target', {
						'bmbo-left': isShowing && nextViewDate.getTime() < viewDate.getTime(),
						'bmbo-right': isShowing && nextViewDate.getTime() > viewDate.getTime()
					})
				});
			}

			// Content style
			var contentStyle = {};
			if (_envUtil.canUseDOM) {
				if (isShowing && this.$view) {
					contentStyle.height = this.$view.clientHeight + 'px';
				} else if (!isShowing && this.$nextView) {
					contentStyle.height = this.$nextView.clientHeight + 'px';
				}
			}

			return _react2.default.createElement(
				'div',
				_extends({
					className: (0, _classnames2.default)('bmbo-date-picker', className),
					ref: this.setRef
				}, props),
				_react2.default.createElement(
					'div',
					{ className: 'bmbo-date-picker-header' },
					_react2.default.createElement('a', {
						role: 'button',
						tabIndex: -1,
						'aria-label': 'Prev Year',
						className: 'bmbo-date-picker-operation bmbo-year-prev',
						onClick: function onClick() {
							_this2.onSwitchDateView(viewDate.clone().setFullYear(viewDate.getFullYear() - 1));
						}
					}),
					_react2.default.createElement('a', {
						role: 'button',
						tabIndex: -1,
						'aria-label': 'Prev Month',
						className: 'bmbo-date-picker-operation bmbo-month-prev',
						onClick: function onClick() {
							_this2.onSwitchDateView(viewDate.clone().setMonth(viewDate.getMonth() - 1));
						}
					}),
					viewDate.format('YYYY-MM'),
					_react2.default.createElement('a', {
						role: 'button',
						tabIndex: -1,
						'aria-label': 'Next Year',
						className: 'bmbo-date-picker-operation bmbo-year-next',
						onClick: function onClick() {
							_this2.onSwitchDateView(viewDate.clone().setFullYear(viewDate.getFullYear() + 1));
						}
					}),
					_react2.default.createElement('a', {
						role: 'button',
						tabIndex: -1,
						'aria-label': 'Next Month',
						className: 'bmbo-date-picker-operation bmbo-month-next',
						onClick: function onClick() {
							_this2.onSwitchDateView(viewDate.clone().setMonth(viewDate.getMonth() + 1));
						}
					})
				),
				_react2.default.createElement(
					'ul',
					{ className: 'bmbo-date-picker-title' },
					DATE_LIST.map(function (str) {
						return _react2.default.createElement(
							'li',
							{ key: str },
							_react2.default.createElement(
								'strong',
								null,
								str
							)
						);
					})
				),
				_react2.default.createElement(
					'div',
					{
						className: (0, _classnames2.default)('bmbo-date-picker-content', {
							'bmbo-none': animateStatus === _uiUtil.ANIMATE_STATUS_NONE,
							'bmbo-showing': isShowing
						}),
						style: contentStyle
					},
					$view,
					$nextView
				)
			);
		}
	}]);

	return DatePicker;
}(_react2.default.Component);

exports.default = DatePicker;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.toDate = toDate;
exports.parseDate = parseDate;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FUNC_LIST = ['getFullYear', 'getMonth', 'getDate', 'getDay', 'getHours', 'getMinutes', 'getSeconds', 'getTime', { name: 'setFullYear', returnThis: true }, { name: 'setMonth', returnThis: true }, { name: 'setDate', returnThis: true }, { name: 'setHours', returnThis: true }, { name: 'setMinutes', returnThis: true }, { name: 'setSeconds', returnThis: true }, 'toString', 'toISOString'];

function toDate(date) {
	if (date === undefined || date === null) return null;

	var myDate = date;
	var type = typeof date === 'undefined' ? 'undefined' : _typeof(date);

	switch (type) {
		case 'number':
		case 'string':
			if (date === '') {
				myDate = new Date();
			} else {
				myDate = new Date(date);
			}
			break;
	}

	if (myDate._isAMomentObject) {
		// Process if is moment object
		myDate = new Date();
		myDate.setFullYear(myDate.year(), myDate.month(), myDate.date());
		myDate.setHours(myDate.hour(), myDate.minute(), myDate.second());

		return myDate;
	} else if (myDate instanceof Date) {
		return myDate;
	}

	return null;
}

/**
 * Wrap a simple Date class like light version of moment.
 */

var BambooDate = function () {
	function BambooDate() {
		_classCallCheck(this, BambooDate);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		var myArgs = args.length === 0 ? [''] : args;
		this.date = toDate.apply(undefined, myArgs);
	}

	_createClass(BambooDate, [{
		key: 'setDay',
		value: function setDay(target) {
			var currentDay = this.date.getDay();
			var distance = target - currentDay;
			this.date.setDate(this.date.getDate() + distance);
			return this;
		}
	}, {
		key: 'clone',
		value: function clone() {
			return new BambooDate(this.getTime());
		}
	}, {
		key: 'format',
		value: function format() {
			var _format = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

			return _format.replace(/YYYY/g, this.getFullYear()).replace(/MM/g, String(this.getMonth() + 1).padStart(2, '0')).replace(/DD/g, String(this.getDate()).padStart(2, '0')).replace(/HH/g, String(this.getHours()).padStart(2, '0')).replace(/mm/g, String(this.getMinutes()).padStart(2, '0')).replace(/SS/g, String(this.getSeconds()).padStart(2, '0'));
		}
	}]);

	return BambooDate;
}();

// Pass origin date function


exports.BambooDate = BambooDate;
FUNC_LIST.forEach(function (func) {
	var config = typeof func === 'string' ? { name: func } : func;

	BambooDate.prototype[config.name] = function dateFunc() {
		var _date;

		var returnValue = (_date = this.date)[config.name].apply(_date, arguments);

		if (config.returnThis) return this;
		return returnValue;
	};
});

function parseDate(date) {
	var myDate = toDate(date);
	if (myDate === null) return null;

	return {
		year: myDate.getFullYear(),
		month: myDate.getMonth(),
		date: myDate.getDate(),
		hour: myDate.getHours(),
		minute: myDate.getMinutes()
	};
}

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var DatePanel = function DatePanel(_ref) {
	var date = _ref.date,
	    viewDate = _ref.viewDate,
	    startDate = _ref.startDate,
	    endDate = _ref.endDate,
	    triggerChangeEvent = _ref.triggerChangeEvent,
	    className = _ref.className,
	    setRef = _ref.setRef,
	    props = _objectWithoutProperties(_ref, ['date', 'viewDate', 'startDate', 'endDate', 'triggerChangeEvent', 'className', 'setRef']);

	var $dateList = [];
	var currentDate = startDate.clone();

	var _loop = function _loop() {
		var pointDate = currentDate.clone();

		$dateList.push(_react2.default.createElement(
			'li',
			{
				key: pointDate.format('YYYY-MM-DD'),
				className: (0, _classnames2.default)({
					'bmbo-deprecated': viewDate && pointDate.getMonth() !== viewDate.getMonth(),
					'bmbo-active': date && pointDate.getFullYear() === date.getFullYear() && pointDate.getMonth() === date.getMonth() && pointDate.getDate() === date.getDate()
				}),
				role: 'button',
				tabIndex: -1,
				onClick: function onClick(event) {
					triggerChangeEvent(event, pointDate);
				}
			},
			pointDate.getDate()
		));

		currentDate.setDate(currentDate.getDate() + 1);
	};

	while (currentDate.getTime() <= endDate.getTime()) {
		_loop();
	}

	return _react2.default.createElement(
		'ul',
		_extends({ className: (0, _classnames2.default)('bmbo-date-picker-panel', className), ref: setRef }, props),
		$dateList
	);
};

exports.default = DatePanel;

/***/ }),
/* 94 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"component":"bmbo_component_1_Krc","preview":"bmbo_preview_vVc6O","preview-item":"bmbo_preview-item_24hps","information":"bmbo_information_3ddeo"};

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _components = __webpack_require__(3);

var _reactRouterDom = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (Component) {
	var $sidebar = _react2.default.createElement(
		_components.Navigation,
		{ vertical: true },
		_react2.default.createElement(
			_components.Navigation.Item,
			null,
			_react2.default.createElement(
				_reactRouterDom.Link,
				{ to: '/grid' },
				'Grid'
			)
		),
		_react2.default.createElement(
			_components.Navigation.Item,
			null,
			_react2.default.createElement(
				_reactRouterDom.Link,
				{ to: '/button' },
				'Button'
			)
		),
		_react2.default.createElement(
			_components.Navigation.Item,
			null,
			_react2.default.createElement(
				_reactRouterDom.Link,
				{ to: '/icon' },
				'Icon'
			)
		),
		_react2.default.createElement(
			_components.Navigation.Item,
			null,
			_react2.default.createElement(
				_reactRouterDom.Link,
				{ to: '/slider' },
				'Slider'
			)
		),
		_react2.default.createElement(
			_components.Navigation.Item,
			null,
			_react2.default.createElement(
				_reactRouterDom.Link,
				{ to: '/menu' },
				'Menu'
			)
		),
		_react2.default.createElement(
			_components.Navigation.Item,
			null,
			_react2.default.createElement(
				_reactRouterDom.Link,
				{ to: '/group' },
				'Group'
			)
		),
		_react2.default.createElement(
			_components.Navigation.Item,
			null,
			_react2.default.createElement(
				_reactRouterDom.Link,
				{ to: '/modal' },
				'Modal'
			)
		),
		_react2.default.createElement(
			_components.Navigation.Item,
			null,
			_react2.default.createElement(
				_reactRouterDom.Link,
				{ to: '/nav' },
				'Navigation'
			)
		),
		_react2.default.createElement(
			_components.Navigation.Item,
			null,
			_react2.default.createElement(
				_reactRouterDom.Link,
				{ to: '/curtain' },
				'Curtain'
			)
		),
		_react2.default.createElement(
			_components.Navigation.Item,
			null,
			_react2.default.createElement(
				_reactRouterDom.Link,
				{ to: '/progress' },
				'Progress'
			)
		),
		_react2.default.createElement(
			_components.Navigation.Item,
			null,
			_react2.default.createElement(
				_reactRouterDom.Link,
				{ to: '/tooltip' },
				'Tooltip'
			)
		),
		_react2.default.createElement(
			_components.Navigation.Item,
			null,
			_react2.default.createElement(
				_reactRouterDom.Link,
				{ to: '/dynamic_number' },
				'Dynamic Number'
			)
		),
		_react2.default.createElement(
			_components.Navigation.Item,
			null,
			_react2.default.createElement(
				_reactRouterDom.Link,
				{ to: '/dynamic_string' },
				'Dynamic String'
			)
		),
		_react2.default.createElement(
			_components.Navigation.Item,
			null,
			_react2.default.createElement(
				_reactRouterDom.Link,
				{ to: '/auto_complete' },
				'Auto Complete'
			)
		),
		_react2.default.createElement(
			_components.Navigation.Item,
			null,
			_react2.default.createElement(
				_reactRouterDom.Link,
				{ to: '/select' },
				'Select'
			)
		),
		_react2.default.createElement(
			_components.Navigation.Item,
			null,
			_react2.default.createElement(
				_reactRouterDom.Link,
				{ to: '/input' },
				'Input'
			)
		),
		_react2.default.createElement(
			_components.Navigation.Item,
			null,
			_react2.default.createElement(
				_reactRouterDom.Link,
				{ to: '/table' },
				'Table'
			)
		),
		_react2.default.createElement(
			_components.Navigation.Item,
			null,
			_react2.default.createElement(
				_reactRouterDom.Link,
				{ to: '/label' },
				'Label'
			)
		),
		_react2.default.createElement(
			_components.Navigation.Item,
			null,
			_react2.default.createElement(
				_reactRouterDom.Link,
				{ to: '/date_picker' },
				'Date Picker'
			)
		),
		_react2.default.createElement(
			_components.Navigation.Item,
			null,
			_react2.default.createElement(
				_reactRouterDom.Link,
				{ to: '/pin_box' },
				'Pin Box'
			)
		),
		_react2.default.createElement(
			_components.Navigation.Item,
			null,
			_react2.default.createElement(
				_reactRouterDom.Link,
				{ to: '/flat_list' },
				'Flat List'
			)
		)
	);

	return function () {
		return _react2.default.createElement(
			_components.Row,
			null,
			_react2.default.createElement(
				_components.Col,
				{ xs: '1/3', md: '1/4', lg: '1/5' },
				$sidebar
			),
			_react2.default.createElement(
				_components.Col,
				{ xs: '2/3', md: '3/4', lg: '4/5' },
				_react2.default.createElement(Component, null)
			)
		);
	};
};

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactCssModules = __webpack_require__(12);

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _components = __webpack_require__(3);

var _propsUtil = __webpack_require__(6);

var _GridPage = __webpack_require__(97);

var _GridPage2 = _interopRequireDefault(_GridPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GRID_LIST = [3, 5, 10, 24];

var GRID_COUNT = [1, 2, 3, 4, 5, 6, 8, 10, 12, 24];
var GRID_COUNT_MARKS = {};

GRID_COUNT.forEach(function (count, index) {
	GRID_COUNT_MARKS[index] = String(count);
});

var toNumArray = function toNumArray(num) {
	var list = [];
	for (var i = 0; i < num; i += 1) {
		list.push(i);
	}
	return list;
};

var GridPage = function (_React$Component) {
	_inherits(GridPage, _React$Component);

	function GridPage() {
		_classCallCheck(this, GridPage);

		var _this = _possibleConstructorReturn(this, (GridPage.__proto__ || Object.getPrototypeOf(GridPage)).call(this));

		_this.getSampleCode = function () {
			var form = _this.state.form;

			var gutter = '';
			if (form.gutter !== 15) {
				gutter = ' gutter={' + Math.max(0, form.gutter) + '}';
			}

			var offset = '';
			if (form.hasOffset) {
				offset = ' xsOffset="1/12"';
			}

			return '<Row' + gutter + '>\n   <Col xs="1/' + GRID_COUNT[form.countIndex] + '"' + offset + '>Column</Col>\n</Row>';
		};

		_this.state = {
			form: {
				countIndex: 1,
				hasOffset: false,
				gutter: 15
			}
		};
		return _this;
	}

	_createClass(GridPage, [{
		key: 'render',
		value: function render() {
			var form = this.state.form;

			var $cols = [];

			var sampleCount = GRID_COUNT[form.countIndex];
			for (var i = 0; i < (form.hasOffset ? 1 : sampleCount); i += 1) {
				$cols.push(_react2.default.createElement(
					_components.Col,
					{ key: i, xs: [1, sampleCount], xsOffset: form.hasOffset ? '1/12' : null },
					_react2.default.createElement('div', { styleName: 'col' })
				));
			}

			return _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(
					'h1',
					null,
					'\u6805\u683C'
				),
				_react2.default.createElement(
					'p',
					null,
					'\u6211\u4EEC\u63D0\u4F9B\u4E86',
					_react2.default.createElement(
						'code',
						null,
						'24'
					),
					'\u548C',
					_react2.default.createElement(
						'code',
						null,
						'10'
					),
					'\u5207\u5206\u76842\u79CD\u6805\u683C\u7CFB\u7EDF\uFF0C\u60A8\u53EF\u4EE5\u5728\u9875\u9762\u4E2D\u6DF7\u5408\u4F7F\u7528\u8BE5\u7CFB\u7EDF\u3002'
				),
				_react2.default.createElement(
					'p',
					null,
					'\u540C\u4E8E',
					_react2.default.createElement(
						'code',
						null,
						'Bootstrap'
					),
					'\uFF0C\u6805\u683C\u7CFB\u7EDF\u63D0\u4F9B\u4E86\u54CD\u5E94\u5F0F\u89E3\u51B3\u65B9\u6848\u3002\u60A8\u53EF\u4EE5\u6839\u636E\u4E0D\u540C\u9875\u9762\u5C3A\u5BF8\u8FDB\u884C\u54CD\u5E94\u5F0F\u8BBE\u8BA1\u3002'
				),
				GRID_LIST.map(function (number, index) {
					return _react2.default.createElement(
						'div',
						{ key: index, styleName: 'grid-preview' },
						_react2.default.createElement(
							_components.Row,
							{ gutter: 0 },
							toNumArray(number).map(function (n) {
								return _react2.default.createElement(
									_components.Col,
									{ key: n, xs: [1, number] },
									_react2.default.createElement(
										'div',
										{ styleName: 'col' },
										'1/',
										number
									)
								);
							})
						)
					);
				}),
				_react2.default.createElement(
					'h2',
					null,
					'\u8BD5\u4E00\u8BD5'
				),
				_react2.default.createElement(
					'div',
					{ className: 'measurement' },
					_react2.default.createElement(
						'div',
						{ className: 'preview' },
						_react2.default.createElement(
							'div',
							{ styleName: 'grid-preview' },
							_react2.default.createElement(
								_components.Row,
								{ gutter: form.gutter },
								$cols
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'form' },
						_react2.default.createElement(
							_components.Form,
							{ instance: this, path: 'form' },
							_react2.default.createElement(
								_components.Form.Field,
								{ name: 'countIndex', title: 'Count' },
								_react2.default.createElement(_components.Slider, { marks: GRID_COUNT_MARKS, min: 0, max: GRID_COUNT.length - 1 })
							),
							_react2.default.createElement(
								_components.Form.Field,
								{ name: 'hasOffset', title: 'With Offset' },
								_react2.default.createElement(
									_components.Checkbox,
									null,
									'Show with offset: 1/12'
								)
							),
							_react2.default.createElement(
								_components.Form.Field,
								{ name: 'gutter', title: 'Gutter ( >= 0)' },
								_react2.default.createElement(_components.Input, { type: 'number' })
							)
						)
					),
					_react2.default.createElement(
						'pre',
						{ className: 'code' },
						this.getSampleCode()
					)
				)
			);
		}
	}]);

	return GridPage;
}(_react2.default.Component);

exports.default = (0, _reactCssModules2.default)(GridPage, _GridPage2.default);

/***/ }),
/* 97 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"grid-preview":"bmbo_grid-preview_1i8PK","col":"bmbo_col_2VORM"};

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _components = __webpack_require__(3);

var _enum = __webpack_require__(5);

var _propsUtil = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ButtonPage = function (_React$Component) {
	_inherits(ButtonPage, _React$Component);

	function ButtonPage() {
		_classCallCheck(this, ButtonPage);

		var _this = _possibleConstructorReturn(this, (ButtonPage.__proto__ || Object.getPrototypeOf(ButtonPage)).call(this));

		_this.onNavClick = function (path) {
			var history = _this.props.history;

			history.push(path);
		};

		_this.getSampleCode = function () {
			var _this$state$form = _this.state.form,
			    text = _this$state$form.text,
			    form = _objectWithoutProperties(_this$state$form, ['text']);

			return '<Button' + (0, _propsUtil.toString)(form, { type: 'primary', size: 'md' }) + '>\n   ' + text + '\n</Button>';
		};

		_this.state = {
			form: {
				text: '你的测试按钮',
				type: 'primary',
				disabled: false,
				size: 'md',
				transparent: false,
				checked: false
			}
		};
		return _this;
	}

	_createClass(ButtonPage, [{
		key: 'render',
		value: function render() {
			var form = this.state.form;


			return _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(
					'h1',
					null,
					'\u6309\u94AE'
				),
				_react2.default.createElement(
					'p',
					null,
					'\u6309\u94AE\u901A\u8FC7',
					_react2.default.createElement(
						'code',
						null,
						'Button'
					),
					'\u8C03\u7528\uFF0C\u6211\u4EEC\u63D0\u4F9B\u4E86\u4E00\u4E0B\u51E0\u79CD\u6837\u5F0F\u3002 \u4F60\u53EF\u4EE5\u901A\u8FC7',
					_react2.default.createElement(
						'code',
						null,
						'type'
					),
					'\u5C5E\u6027\u6765\u8FDB\u884C\u8BBE\u7F6E\u3002'
				),
				_react2.default.createElement(
					'div',
					{ className: 'preview' },
					_react2.default.createElement(
						'span',
						{ className: 'margin' },
						_react2.default.createElement(
							_components.Button,
							{ type: 'deprecated' },
							'deprecated'
						)
					),
					_react2.default.createElement(
						'span',
						{ className: 'margin' },
						_react2.default.createElement(
							_components.Button,
							null,
							'primary'
						)
					),
					_react2.default.createElement(
						'span',
						{ className: 'margin' },
						_react2.default.createElement(
							_components.Button,
							{ type: 'info' },
							'info'
						)
					),
					_react2.default.createElement(
						'span',
						{ className: 'margin' },
						_react2.default.createElement(
							_components.Button,
							{ type: 'success' },
							'success'
						)
					),
					_react2.default.createElement(
						'span',
						{ className: 'margin' },
						_react2.default.createElement(
							_components.Button,
							{ type: 'warning' },
							'warning'
						)
					),
					_react2.default.createElement(
						'span',
						{ className: 'margin' },
						_react2.default.createElement(
							_components.Button,
							{ type: 'danger' },
							'danger'
						)
					),
					_react2.default.createElement(
						'span',
						{ className: 'margin' },
						_react2.default.createElement(
							_components.Button,
							{ type: 'forbid' },
							'forbid'
						)
					)
				),
				_react2.default.createElement(
					'h2',
					null,
					'\u8BD5\u4E00\u8BD5'
				),
				_react2.default.createElement(
					'div',
					{ className: 'measurement' },
					_react2.default.createElement(
						'div',
						{ className: 'preview' },
						_react2.default.createElement(
							_components.Button,
							{
								type: form.type,
								disabled: form.disabled,
								size: form.size,
								transparent: form.transparent,
								checked: form.checked
							},
							form.text
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'form' },
						_react2.default.createElement(
							_components.Form,
							{ instance: this, path: 'form' },
							_react2.default.createElement(
								_components.Form.Field,
								{ name: 'text', title: 'Text' },
								_react2.default.createElement(_components.Input, null)
							),
							_react2.default.createElement(
								_components.Form.Field,
								{ name: 'type', title: 'Type' },
								_enum.TYPE_LIST.map(function (_ref) {
									var name = _ref.name,
									    isDefault = _ref.isDefault;
									return _react2.default.createElement(
										_components.Radio,
										{ key: name, value: name },
										name,
										isDefault && ' (default)'
									);
								})
							),
							_react2.default.createElement(
								_components.Form.Field,
								{ name: 'disabled', title: 'Disabled' },
								_react2.default.createElement(
									_components.Checkbox,
									null,
									'disabled'
								)
							),
							_react2.default.createElement(
								_components.Form.Field,
								{ name: 'size', title: 'Size' },
								_enum.SIZE_LIST.map(function (_ref2) {
									var name = _ref2.name,
									    displayName = _ref2.displayName,
									    isDefault = _ref2.isDefault;
									return _react2.default.createElement(
										_components.Radio,
										{ key: name, value: name },
										displayName,
										isDefault && ' (default)'
									);
								})
							),
							_react2.default.createElement(
								_components.Form.Field,
								{ name: 'transparent', title: 'Transparent' },
								_react2.default.createElement(
									_components.Checkbox,
									null,
									'transparent'
								)
							),
							_react2.default.createElement(
								_components.Form.Field,
								{ name: 'checked', title: 'Checked' },
								_react2.default.createElement(
									_components.Checkbox,
									null,
									'checked'
								)
							)
						)
					),
					_react2.default.createElement(
						'pre',
						{ className: 'code' },
						this.getSampleCode()
					)
				)
			);
		}
	}]);

	return ButtonPage;
}(_react2.default.Component);

exports.default = ButtonPage;

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _components = __webpack_require__(3);

var _objectUtil = __webpack_require__(19);

var _Select = __webpack_require__(33);

var _Select2 = _interopRequireDefault(_Select);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GroupPage = function (_React$Component) {
	_inherits(GroupPage, _React$Component);

	function GroupPage() {
		_classCallCheck(this, GroupPage);

		var _this = _possibleConstructorReturn(this, (GroupPage.__proto__ || Object.getPrototypeOf(GroupPage)).call(this));

		_this.state = {
			direct: 'right'
		};
		return _this;
	}

	_createClass(GroupPage, [{
		key: 'render',
		value: function render() {
			return _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(
					'h1',
					null,
					'\u56FE\u6807'
				),
				_react2.default.createElement(
					'p',
					null,
					'\u6211\u4EEC\u5C01\u88C5\u4E86\u6765\u81EA',
					_react2.default.createElement(
						_components.A,
						{ href: 'http://fontawesome.io', target: '_blank' },
						'Font Awesome'
					),
					'\u7684\u56FE\u6807\uFF0C\u5F53\u7136\u5982\u679C\u4F60\u6709\u504F\u597D\u4E5F\u53EF\u4EE5\u6765\u4F7F\u7528\u81EA\u5DF1\u7684\u5B57\u4F53\u56FE\u6807\uFF08\u4F8B\u5982',
					_react2.default.createElement(
						_components.A,
						{ href: 'http://iconfont.cn/', target: '_blank' },
						'iconfont'
					),
					'\uFF09\u3002'
				),
				_react2.default.createElement(
					'h2',
					null,
					'\u51C6\u5907\u5DE5\u4F5C'
				),
				_react2.default.createElement(
					'p',
					null,
					'Bamboo UI\u9ED8\u8BA4\u4E0D\u4F1A\u5F15\u5165Font Awesome css\u6587\u4EF6\uFF0C\u56E0\u800C\u4F60\u9700\u8981\u81EA\u5DF1\u5728\u9875\u9762\u4E2D\u5F15\u5165\uFF1A'
				),
				_react2.default.createElement(
					'pre',
					{ className: 'code' },
					'<link href="[你的资源路径]/font-awesome.min.css" rel="stylesheet">'
				),
				_react2.default.createElement(
					'h2',
					null,
					'\u4F7F\u7528'
				),
				_react2.default.createElement(
					'p',
					null,
					_react2.default.createElement(
						'code',
						null,
						'Icon'
					),
					'\u7EC4\u4EF6\u7B80\u5355\u7684\u5BF9\u56FE\u6807\u8FDB\u884C\u5C01\u88C5\uFF0C\u56E0\u800C\u4F60\u53EF\u4EE5\u76F4\u63A5\u901A\u8FC7',
					_react2.default.createElement(
						'code',
						null,
						'name'
					),
					'\u5C5E\u6027\u6765\u8FDB\u884C\u8C03\u7528\u3002 \u5E26\u6709\u65CB\u8F6C\u52A8\u753B\u7684\u56FE\u6807\u901A\u8FC7\u6DFB\u52A0',
					_react2.default.createElement(
						'code',
						null,
						'spin'
					),
					'\u5C5E\u6027\u8C03\u7528\u3002'
				),
				_react2.default.createElement(
					'div',
					{ className: 'measurement' },
					_react2.default.createElement(
						'div',
						{ className: 'preview' },
						_react2.default.createElement(_components.Icon, { name: 'smile-o' }),
						' ',
						_react2.default.createElement(_components.Icon, { name: 'refresh', spin: true })
					),
					_react2.default.createElement(
						'pre',
						{ className: 'code' },
						'\n<Icon name="smile-o" />\n<Icon name="refresh" spin />\n'.trim()
					)
				),
				_react2.default.createElement(
					'h2',
					null,
					'\u7279\u6B8A\u7684\u56FE\u6807'
				),
				_react2.default.createElement(
					'p',
					null,
					'\u4E3A\u4E86\u9632\u6B62\u60A8\u6CA1\u6709\u4F7F\u7528',
					_react2.default.createElement(
						_components.A,
						{ href: 'http://fontawesome.io', target: '_blank' },
						'Font Awesome'
					),
					'\u56FE\u6807\u800C\u5BFC\u81F4\u90E8\u5206\u7EC4\u4EF6\u8F7D\u5165\u52A8\u753B\u5931\u6548\uFF0C \u6211\u4EEC\u5185\u7F6E\u4E86\u4E00\u4E9B\u8F7D\u5165\u56FE\u6807\u3002 \u60A8\u53EF\u4EE5\u901A\u8FC7',
					_react2.default.createElement(
						'code',
						null,
						'Icon.Loading'
					),
					'\u6765\u4F7F\u7528\u3002'
				),
				_react2.default.createElement(
					'div',
					{ className: 'measurement' },
					_react2.default.createElement(
						'div',
						{ className: 'preview' },
						_react2.default.createElement(_components.Icon.Loading, null),
						' ',
						_react2.default.createElement(_components.Icon.Loading, { id: 1 }),
						' ',
						_react2.default.createElement(_components.Icon.Loading, { id: 2 }),
						' ',
						_react2.default.createElement(_components.Icon.Loading, { id: 3 }),
						' ',
						_react2.default.createElement(_components.Icon.Loading, { id: 4 })
					),
					_react2.default.createElement(
						'pre',
						{ className: 'code' },
						'\n<Icon.Loading />\n<Icon.Loading id={1} />\n<Icon.Loading id={2} />\n<Icon.Loading id={3} />\n<Icon.Loading id={4} />\n'.trim()
					)
				),
				_react2.default.createElement(
					'p',
					null,
					'\u6B64\u5916\uFF0C\u6211\u4EEC\u8FD8\u63D0\u4F9B\u4E86\u7BAD\u5934\u56FE\u6807\u3002\u60A8\u53EF\u4EE5\u901A\u8FC7',
					_react2.default.createElement(
						'code',
						null,
						'Icon.Caret'
					),
					'\u6765\u4F7F\u7528\u3002'
				),
				_react2.default.createElement(
					'div',
					{ className: 'measurement' },
					_react2.default.createElement(
						'div',
						{ className: 'preview' },
						'\u8FD9\u662F\u4E2A',
						_react2.default.createElement(_components.Icon.Caret, { direct: this.state.direct }),
						'\u56FE\u6807'
					),
					_react2.default.createElement(
						'div',
						{ className: 'form' },
						_react2.default.createElement(
							_components.Form,
							{ instance: this },
							_react2.default.createElement(
								_components.Form.Field,
								{ name: 'direct' },
								['right', 'left', 'up', 'down'].map(function (direct) {
									return _react2.default.createElement(
										_components.Radio,
										{ value: direct, key: direct },
										direct
									);
								})
							)
						)
					),
					_react2.default.createElement(
						'pre',
						{ className: 'code' },
						'<Icon.Caret direct="' + this.state.direct + '" />'
					)
				),
				_react2.default.createElement(
					'p',
					null,
					'\u641C\u7D22\u56FE\u6807\uFF1A'
				),
				_react2.default.createElement(
					'div',
					{ className: 'measurement' },
					_react2.default.createElement(
						'div',
						{ className: 'preview' },
						_react2.default.createElement(_components.Icon.Search, null)
					),
					_react2.default.createElement(
						'pre',
						{ className: 'code' },
						'<Icon.Search />'
					)
				)
			);
		}
	}]);

	return GroupPage;
}(_react2.default.Component);

exports.default = GroupPage;

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _components = __webpack_require__(3);

var _enum = __webpack_require__(5);

var _propsUtil = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MARKS_SAMPLE = {
	20: {
		title: '粘附',
		stick: 3
	},
	60: '合格',
	75: '良好',
	90: '优秀'
};

var SliderPage = function (_React$Component) {
	_inherits(SliderPage, _React$Component);

	function SliderPage() {
		_classCallCheck(this, SliderPage);

		var _this = _possibleConstructorReturn(this, (SliderPage.__proto__ || Object.getPrototypeOf(SliderPage)).call(this));

		_this.onFormChanged = function () {
			var form = _this.state.form;
			var value = form.value,
			    hasMulti = form.hasMulti,
			    multi = form.multi;


			if (hasMulti && multi > 1 && !Array.isArray(value)) {
				_this.setState({
					form: _extends({}, form, {
						value: [value]
					})
				});
			} else if ((!hasMulti || multi <= 1) && Array.isArray(value)) {
				_this.setState({
					form: _extends({}, form, {
						value: value[0]
					})
				});
			}
		};

		_this.getSampleCode = function () {
			var form = _extends({}, _this.state.form);
			form.min = Number(form.min);
			form.max = Number(form.max);
			form.step = Number(form.step);
			form.multi = Number(form.multi);

			if (!form.hasStep) form.step = null;
			if (!form.hasMulti) delete form.multi;

			var markStr = form.hasMarks ? ' marks={markList}' : '';

			delete form.hasStep;
			delete form.hasMulti;
			delete form.hasMarks;

			var defaultProps = {
				type: 'primary',
				size: 'md',
				min: 0,
				max: 100,
				step: 1
			};

			return ('<Slider' + (0, _propsUtil.toString)(form, defaultProps) + markStr + ' />').replace(/\t/g, '   ').trim();
		};

		_this.state = {
			value: 0,

			form: {
				type: 'primary',
				size: 'md',
				value: 50,
				min: 0,
				max: 100,
				step: 1,
				hasStep: true,
				multi: 2,
				hasMulti: false,
				disabled: false,
				transparent: false,
				hasMarks: true
			}
		};
		return _this;
	}

	_createClass(SliderPage, [{
		key: 'render',
		value: function render() {
			var form = this.state.form;


			return _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(
					'h1',
					null,
					'\u6ED1\u52A8\u6761'
				),
				_react2.default.createElement(
					'p',
					null,
					'\u63D0\u4F9B\u4E86\u5355\u503C\u4EE5\u53CA\u8303\u56F4\u9009\u53D6\u7684\u529F\u80FD\u3002'
				),
				_react2.default.createElement(
					_components.Form,
					{ instance: this },
					_react2.default.createElement(
						_components.Form.Field,
						{ name: 'value' },
						_react2.default.createElement(_components.Slider, { type: 'primary' })
					)
				),
				_react2.default.createElement(
					'h2',
					null,
					'\u8BD5\u4E00\u8BD5'
				),
				_react2.default.createElement(
					_components.Form,
					{ instance: this, path: 'form', onChanged: this.onFormChanged },
					_react2.default.createElement(
						'div',
						{ className: 'measurement' },
						_react2.default.createElement(
							'div',
							{ className: 'preview' },
							_react2.default.createElement(
								_components.Form.Field,
								{ name: 'value' },
								_react2.default.createElement(_components.Slider, {
									type: form.type,
									size: form.size,
									step: form.hasStep ? form.step : null,
									min: form.min,
									max: form.max,
									multi: form.hasMulti ? form.multi : false,
									disabled: form.disabled,
									transparent: form.transparent,
									marks: form.hasMarks ? MARKS_SAMPLE : undefined
								})
							),
							'Current Value: ',
							JSON.stringify(form.value)
						),
						_react2.default.createElement(
							'div',
							{ className: 'form' },
							_react2.default.createElement(
								_components.Form.Field,
								{ name: 'type', title: 'Type' },
								_enum.TYPE_LIST.map(function (_ref) {
									var name = _ref.name,
									    isDefault = _ref.isDefault;
									return _react2.default.createElement(
										_components.Radio,
										{ key: name, value: name },
										name,
										isDefault && ' (default)'
									);
								})
							),
							_react2.default.createElement(
								_components.Form.Field,
								{ name: 'size', title: 'Size' },
								_enum.SIZE_LIST.map(function (_ref2) {
									var name = _ref2.name,
									    displayName = _ref2.displayName,
									    isDefault = _ref2.isDefault;
									return _react2.default.createElement(
										_components.Radio,
										{ key: name, value: name },
										displayName,
										isDefault && ' (default)'
									);
								})
							),
							_react2.default.createElement(
								_components.Form.Field,
								{ name: 'value', title: 'Value' },
								(!form.hasMulti || form.multi <= 1) && _react2.default.createElement(_components.Input, { type: 'number' }),
								form.hasMulti && form.multi > 1 && _react2.default.createElement(_components.Input, { disabled: true, value: JSON.stringify(form.value) })
							),
							_react2.default.createElement(
								_components.Form.Field,
								{ name: 'min', title: 'Min' },
								_react2.default.createElement(_components.Input, { type: 'number' })
							),
							_react2.default.createElement(
								_components.Form.Field,
								{ name: 'max', title: 'Max' },
								_react2.default.createElement(_components.Input, { type: 'number' })
							),
							_react2.default.createElement(
								_components.Form.Field,
								{ name: 'hasStep', title: 'Use Step' },
								_react2.default.createElement(
									_components.Checkbox,
									null,
									'Use Step'
								)
							),
							form.hasStep && _react2.default.createElement(
								_components.Form.Field,
								{ name: 'step', title: 'Step ( > 0)' },
								_react2.default.createElement(_components.Input, { type: 'number' })
							),
							_react2.default.createElement(
								_components.Form.Field,
								{ name: 'hasMulti', title: 'Use Multi' },
								_react2.default.createElement(
									_components.Checkbox,
									null,
									'Use Multi'
								)
							),
							form.hasMulti && _react2.default.createElement(
								_components.Form.Field,
								{ name: 'multi', title: 'Multi ( >= 1)' },
								_react2.default.createElement(_components.Input, { type: 'number' })
							),
							_react2.default.createElement(
								_components.Form.Field,
								{ name: 'disabled', title: 'Disabled' },
								_react2.default.createElement(
									_components.Checkbox,
									null,
									'disabled'
								)
							),
							_react2.default.createElement(
								_components.Form.Field,
								{ name: 'transparent', title: 'Transparent' },
								_react2.default.createElement(
									_components.Checkbox,
									null,
									'transparent'
								)
							),
							_react2.default.createElement(
								_components.Form.Field,
								{ name: 'hasMarks', title: 'Marks' },
								_react2.default.createElement(
									_components.Checkbox,
									null,
									'marks'
								),
								form.hasMarks && _react2.default.createElement(
									'pre',
									null,
									'Marks Sample:\n',
									'const markList = ',
									JSON.stringify(MARKS_SAMPLE, null, 3)
								)
							)
						),
						_react2.default.createElement(
							'pre',
							{ className: 'code' },
							this.getSampleCode()
						)
					)
				)
			);
		}
	}]);

	return SliderPage;
}(_react2.default.Component);

exports.default = SliderPage;

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _components = __webpack_require__(3);

var _objectUtil = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MENU_SAMPLE = [{
	title: '默认选项',
	onClick: function onClick() {
		// TODO: Change this to alert / dialog component
		alert('Clicked!');
	}
}, {
	title: '禁用选项',
	disabled: true
}, {
	separator: true
}, {
	title: '包含子菜单',
	list: [{
		title: '子菜单 1'
	}, {
		title: '子菜单 2',
		list: [{
			title: '子子菜单'
		}]
	}]
}];

var MenuPage = function (_React$Component) {
	_inherits(MenuPage, _React$Component);

	function MenuPage() {
		_classCallCheck(this, MenuPage);

		var _this = _possibleConstructorReturn(this, (MenuPage.__proto__ || Object.getPrototypeOf(MenuPage)).call(this));

		_this.state = {
			form: {}
		};
		return _this;
	}

	_createClass(MenuPage, [{
		key: 'render',
		value: function render() {
			var form = this.state.form;


			return _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(
					'h1',
					null,
					'\u83DC\u5355'
				),
				_react2.default.createElement(
					'p',
					null,
					'\u83DC\u5355\u63D0\u4F9B\u4E86\u4E0B\u62C9\u548C\u53F3\u51FB\u83DC\u5355\u529F\u80FD\u3002'
				),
				_react2.default.createElement(
					_components.Menu,
					{ menu: MENU_SAMPLE },
					_react2.default.createElement(
						'strong',
						null,
						'[\u53F3\u51FB\u8FD9\u6BB5\u6587\u5B57\u6765\u5B9E\u9A8C\u4E00\u4E0B]'
					)
				),
				_react2.default.createElement(
					'pre',
					null,
					'const menu = ' + (0, _objectUtil.toString)(MENU_SAMPLE) + ';\n\n<Menu menu={menu}>\n<strong>[\u53F3\u51FB\u8FD9\u6BB5\u6587\u5B57\u6765\u5B9E\u9A8C\u4E00\u4E0B]</strong>\n</Menu>'
				),
				_react2.default.createElement(
					'p',
					null,
					'* \u540C\u5176\u4ED6\u7EC4\u4EF6\u4E00\u6837\uFF0C\u4F60\u53EF\u4EE5\u901A\u8FC7',
					_react2.default.createElement(
						'code',
						null,
						'size'
					),
					'\u5C5E\u6027\u6765\u63A7\u5236\u83DC\u5355\u5927\u5C0F\u3002'
				)
			);
		}
	}]);

	return MenuPage;
}(_react2.default.Component);

exports.default = MenuPage;

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _components = __webpack_require__(3);

var _enum = __webpack_require__(5);

var _propsUtil = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GroupPage = function (_React$Component) {
	_inherits(GroupPage, _React$Component);

	function GroupPage() {
		_classCallCheck(this, GroupPage);

		var _this = _possibleConstructorReturn(this, (GroupPage.__proto__ || Object.getPrototypeOf(GroupPage)).call(this));

		_this.getSampleCode = function () {
			var _this$state = _this.state,
			    radio = _this$state.radio,
			    form = _objectWithoutProperties(_this$state, ['radio']);

			var btnStr = (0, _propsUtil.toString)(form, { type: 'primary', size: 'md' });

			return ('\n<Group>\n   <Button' + btnStr + '>Button 1</Button>\n   <Button' + btnStr + '>Button 2</Button>\n   <Button' + btnStr + '>Button 3</Button>\n</Group>\n\n<Group value={' + radio + '}>\n   <Radio value={1}' + btnStr + '>Radio 1</Radio>\n   <Radio value={2}' + btnStr + '>Radio 2</Radio>\n   <Radio value={3}' + btnStr + '>Radio 3</Radio>\n</Group>\n\n<Group>\n   <Input />\n   <Button' + btnStr + '>Go</Button>\n</Group>\n').trim();
		};

		_this.state = {
			type: 'primary',
			size: 'md',
			radio: 1,
			transparent: false
		};
		return _this;
	}

	_createClass(GroupPage, [{
		key: 'render',
		value: function render() {
			var _state = this.state,
			    type = _state.type,
			    transparent = _state.transparent,
			    size = _state.size;


			return _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(
					'h1',
					null,
					'\u7EC4'
				),
				_react2.default.createElement(
					'p',
					null,
					'\u5982\u679C\u60A8\u5BF9\u6837\u5F0F\u6CA1\u6709\u8FC7\u591A\u8981\u6C42\uFF0C\u8BE5\u7EC4\u4EF6\u53EF\u4EE5\u5E2E\u52A9\u60A8\u5C06\u7EC4\u4EF6\u8FDB\u884C\u81EA\u52A8\u7EC4\u5408\u3002 \uFF08\u652F\u6301',
					_react2.default.createElement(
						'code',
						null,
						'Button'
					),
					'\uFF0C',
					_react2.default.createElement(
						'code',
						null,
						'Radio'
					),
					'\uFF0C',
					_react2.default.createElement(
						'code',
						null,
						'Input'
					),
					'\uFF09'
				),
				_react2.default.createElement(
					'p',
					null,
					'\u5982\u679C\u60A8\u5E0C\u671B\u4F7F\u7528',
					_react2.default.createElement(
						'code',
						null,
						'Form.Field'
					),
					'\u8FDB\u884C\u6570\u636E\u7ED1\u5B9A\uFF0C \u60A8\u53EF\u4EE5\u76F4\u63A5\u5C06',
					_react2.default.createElement(
						'code',
						null,
						'Group'
					),
					'\u4F5C\u4E3A',
					_react2.default.createElement(
						'code',
						null,
						'Form.Field'
					),
					'\u5B50\u7EC4\u4EF6\u3002'
				),
				_react2.default.createElement(
					'pre',
					null,
					'\n<Form instance={this}>\n<Form.Field name="radio">\n  <Group>\n\t <Radio>Radio 1</Radio>\n\t <Radio>Radio 2</Radio>\n  </Group>\n</Form.Field>\n</Form>\n'.trim()
				),
				_react2.default.createElement(
					'p',
					null,
					'* \u5F53\u60A8\u5728',
					_react2.default.createElement(
						'code',
						null,
						'Group'
					),
					'\u4E2D\u4F7F\u7528',
					_react2.default.createElement(
						'code',
						null,
						'Radio'
					),
					'\u65F6\uFF0C',
					_react2.default.createElement(
						'code',
						null,
						'Radio'
					),
					'\u7EC4\u4EF6\u5C06\u81EA\u52A8\u66FF\u6362\u6210',
					_react2.default.createElement(
						'code',
						null,
						'Button'
					),
					'\u7EC4\u4EF6\u3002 \u56E0\u800C\u4F60\u53EF\u4EE5\u76F4\u63A5\u5728',
					_react2.default.createElement(
						'code',
						null,
						'Radio'
					),
					'\u4F7F\u7528',
					_react2.default.createElement(
						'code',
						null,
						'Button'
					),
					'\u7684\u5C5E\u6027\u3002'
				),
				_react2.default.createElement(
					'h2',
					null,
					'\u8BD5\u4E00\u8BD5'
				),
				_react2.default.createElement(
					_components.Form,
					{ instance: this },
					_react2.default.createElement(
						'div',
						{ className: 'measurement' },
						_react2.default.createElement(
							'div',
							{ className: 'preview' },
							_react2.default.createElement(
								_components.Group,
								null,
								[1, 2, 3].map(function (val) {
									return _react2.default.createElement(
										_components.Button,
										{ key: val, type: type, size: size, transparent: transparent },
										'Button ',
										val
									);
								})
							),
							_react2.default.createElement(
								_components.Form.Field,
								{ name: 'radio' },
								_react2.default.createElement(
									_components.Group,
									null,
									[1, 2, 3].map(function (val) {
										return _react2.default.createElement(
											_components.Radio,
											{
												key: val,
												type: type,
												size: size,
												value: val,
												transparent: transparent
											},
											'Radio ',
											val
										);
									})
								)
							),
							_react2.default.createElement(
								_components.Group,
								null,
								_react2.default.createElement(_components.Input, { 'aria-label': 'input', size: size }),
								_react2.default.createElement(
									_components.Button,
									{ type: type, size: size, transparent: transparent },
									'Go'
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'form' },
							_react2.default.createElement(
								_components.Form.Field,
								{ name: 'type', title: 'Type' },
								_enum.TYPE_LIST.map(function (_ref) {
									var name = _ref.name,
									    isDefault = _ref.isDefault;
									return _react2.default.createElement(
										_components.Radio,
										{ key: name, value: name },
										name,
										isDefault && ' (default)'
									);
								})
							),
							_react2.default.createElement(
								_components.Form.Field,
								{ name: 'size', title: 'Size' },
								_enum.SIZE_LIST.map(function (_ref2) {
									var name = _ref2.name,
									    displayName = _ref2.displayName,
									    isDefault = _ref2.isDefault;
									return _react2.default.createElement(
										_components.Radio,
										{ key: name, value: name },
										displayName,
										isDefault && ' (default)'
									);
								})
							),
							_react2.default.createElement(
								_components.Form.Field,
								{ name: 'transparent', title: 'Transparent' },
								_react2.default.createElement(
									_components.Checkbox,
									null,
									'transparent'
								)
							)
						),
						_react2.default.createElement(
							'pre',
							{ className: 'code' },
							this.getSampleCode()
						)
					)
				),
				_react2.default.createElement(
					'h2',
					null,
					'\u62D3\u5C55'
				),
				_react2.default.createElement(
					'p',
					null,
					'\u6709\u65F6\u5019\uFF0C\u60A8\u4F1A\u5E0C\u671B',
					_react2.default.createElement(
						'code',
						null,
						'Group'
					),
					'\u80FD\u591F\u5360\u636E\u4E00\u6574\u884C\u5BBD\u5EA6\u3002\u8FD9\u5F53\u7136\u662F\u6CA1\u6709\u95EE\u9898\u7684\uFF01'
				),
				_react2.default.createElement(
					'p',
					null,
					_react2.default.createElement(
						'code',
						null,
						'Group'
					),
					'\u7EC4\u4EF6\u4F1A\u81EA\u52A8\u5C06\u5B50\u7EC4\u4EF6\u7528',
					_react2.default.createElement(
						'code',
						null,
						'Group.Item'
					),
					'\u5305\u88F9\u8D77\u6765\uFF0C \u56E0\u800C\u60A8\u4E5F\u53EF\u4EE5\u663E\u793A\u7684\u81EA\u5DF1\u4F7F\u7528',
					_react2.default.createElement(
						'code',
						null,
						'Group.Item'
					),
					'\u6765\u5305\u88F9\u5B50\u7EC4\u4EF6\u3002'
				),
				_react2.default.createElement(
					'div',
					{ className: 'measurement' },
					_react2.default.createElement(
						'div',
						{ className: 'preview' },
						_react2.default.createElement(
							_components.Group,
							null,
							_react2.default.createElement(
								_components.Group.Item,
								{ width: '100%' },
								_react2.default.createElement(_components.Input, { 'aria-label': 'input' })
							),
							_react2.default.createElement(
								_components.Button,
								null,
								'Go'
							)
						)
					),
					_react2.default.createElement(
						'pre',
						{ className: 'code' },
						'<Group>\n<Group.Item width="100%">\n  <Input />\n</Group.Item>\n<Button>Go</Button>\n</Group>'
					)
				)
			);
		}
	}]);

	return GroupPage;
}(_react2.default.Component);

exports.default = GroupPage;

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _components = __webpack_require__(3);

var _enum = __webpack_require__(5);

var _objectUtil = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GroupPage = function (_React$Component) {
	_inherits(GroupPage, _React$Component);

	function GroupPage() {
		_classCallCheck(this, GroupPage);

		var _this = _possibleConstructorReturn(this, (GroupPage.__proto__ || Object.getPrototypeOf(GroupPage)).call(this));

		_this.onShowModal = function () {
			_this.setState({ visible: true });
		};

		_this.onHideModal = function () {
			_this.setState({ visible: false });
		};

		_this.state = {
			visible: false,
			typesVisible: {},
			sizesVisible: {},
			prefaceVisible: false,
			confirmVisible: false,
			loadingVisible: false,
			loading: false
		};
		return _this;
	}

	_createClass(GroupPage, [{
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _state = this.state,
			    visible = _state.visible,
			    typesVisible = _state.typesVisible,
			    sizesVisible = _state.sizesVisible,
			    prefaceVisible = _state.prefaceVisible,
			    confirmVisible = _state.confirmVisible,
			    loadingVisible = _state.loadingVisible,
			    loading = _state.loading,
			    lockVisible = _state.lockVisible,
			    lock = _state.lock;


			return _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(
					'h1',
					null,
					'\u6A21\u6001\u5BF9\u8BDD\u6846'
				),
				_react2.default.createElement(
					'p',
					null,
					'\u521B\u5EFA\u4E00\u4E2A\u975E\u963B\u585E\u5BF9\u8BDD\u6846\uFF0C\u652F\u6301\u591A\u5C42\u5F39\u7A97\u4E0E\u5F02\u6B65\u68C0\u6D4B\u529F\u80FD\u3002'
				),
				_react2.default.createElement(
					'div',
					{ className: 'measurement' },
					_react2.default.createElement(
						'div',
						{ className: 'preview' },
						_react2.default.createElement(
							_components.Button,
							{ onClick: this.onShowModal },
							'\u70B9\u51FB\u5F39\u7A97'
						),
						_react2.default.createElement(
							_components.Modal,
							{ visible: visible, onClose: this.onHideModal, size: 'sm' },
							_react2.default.createElement(
								_components.Modal.Title,
								null,
								'Modal'
							),
							'Hello, Bamboo UI!~'
						)
					),
					_react2.default.createElement(
						'pre',
						{ className: 'code' },
						'\n<Modal\ntitle="Modal"\nvisible={this.state.visible}\nonClose={() => { this.setState({ visible: false }); }}\n>\nHello, Bamboo UI!~\n</Modal>\n'.trim()
					)
				),
				_react2.default.createElement(
					'h2',
					null,
					'\u72B6\u6001\u5BF9\u8BDD\u6846'
				),
				_react2.default.createElement(
					'p',
					null,
					'\u6709\u65F6\u5019\uFF0C\u4F60\u5E0C\u671B\u80FD\u591F\u6709\u663E\u793A\u7684\u72B6\u6001\u63D0\u793A\u3002 \u60A8\u53EF\u4EE5\u901A\u8FC7\u8BBE\u7F6E',
					_react2.default.createElement(
						'code',
						null,
						'type'
					),
					'\u5C5E\u6027\u6765\u8BBE\u7F6E\u72B6\u6001\uFF08\u540C',
					_react2.default.createElement(
						'code',
						null,
						'Button'
					),
					'\uFF09\u3002'
				),
				_react2.default.createElement(
					'div',
					{ className: 'preview' },
					_enum.TYPE_LIST.map(function (_ref) {
						var name = _ref.name;
						return _react2.default.createElement(
							'div',
							{ className: 'inline', key: name },
							_react2.default.createElement(
								_components.Button,
								{
									onClick: function onClick() {
										_this2.setState({
											typesVisible: _extends({}, typesVisible, _defineProperty({}, name, true))
										});
									},
									type: name
								},
								'\u70B9\u51FB\u5F39\u7A97'
							),
							' ',
							_react2.default.createElement(
								_components.Modal,
								{
									title: 'Primary Modal',
									type: name,
									visible: typesVisible[name],
									onClose: function onClose() {
										_this2.setState({
											typesVisible: _extends({}, typesVisible, _defineProperty({}, name, false))
										});
									}
								},
								'Hello, Bamboo UI!~'
							)
						);
					})
				),
				_react2.default.createElement(
					'h2',
					null,
					'\u8BBE\u7F6E\u5C3A\u5BF8'
				),
				_react2.default.createElement(
					'p',
					null,
					'\u540C\u65F6\uFF0C\u4F60\u53EF\u4EE5\u901A\u8FC7\u8BBE\u7F6E\u5C3A\u5BF8\u6765\u663E\u793A\u5BF9\u5E94\u5927\u5C0F\u7684\u5BF9\u8BDD\u6846\u3002'
				),
				_react2.default.createElement(
					'div',
					{ className: 'preview' },
					_enum.SIZE_LIST.map(function (_ref2) {
						var name = _ref2.name,
						    displayName = _ref2.displayName;
						return _react2.default.createElement(
							'div',
							{ className: 'inline', key: name },
							_react2.default.createElement(
								_components.Button,
								{
									onClick: function onClick() {
										_this2.setState({
											sizesVisible: _extends({}, sizesVisible, _defineProperty({}, name, true))
										});
									}
								},
								displayName
							),
							' ',
							_react2.default.createElement(
								_components.Modal,
								{
									title: 'Primary Modal',
									size: name,
									visible: sizesVisible[name],
									onClose: function onClose() {
										_this2.setState({
											sizesVisible: _extends({}, sizesVisible, _defineProperty({}, name, false))
										});
									}
								},
								'Hello, Bamboo UI!~'
							)
						);
					})
				),
				_react2.default.createElement(
					'h2',
					null,
					'\u5F15\u8A00\u5BF9\u8BDD\u6846'
				),
				_react2.default.createElement(
					'p',
					null,
					'\u6709\u65F6\u5019\uFF0C\u4F60\u4F1A\u5E0C\u671B\u62D3\u5C55\u5BF9\u8BDD\u6846\u3002 \u4F60\u53EF\u4EE5\u4F7F\u7528',
					_react2.default.createElement(
						'code',
						null,
						'Modal.Preface'
					),
					'\u6765\u6DFB\u52A0\u989D\u5916\u5185\u5BB9\u3002'
				),
				_react2.default.createElement(
					'div',
					{ className: 'preview' },
					_react2.default.createElement(
						_components.Button,
						{
							onClick: function onClick() {
								_this2.setState({ prefaceVisible: true });
							}
						},
						'\u70B9\u51FB\u5F39\u7A97'
					),
					_react2.default.createElement(
						_components.Modal,
						{
							title: 'Preface Modal',
							visible: prefaceVisible,
							onClose: function onClose() {
								_this2.setState({
									prefaceVisible: false
								});
							}
						},
						_react2.default.createElement(
							_components.Modal.Preface,
							null,
							_react2.default.createElement('img', { src: './assets/light.min.jpg', alt: 'Light' })
						),
						_react2.default.createElement(
							_components.Modal.Content,
							null,
							_react2.default.createElement(
								'p',
								null,
								'This is a Modal with Preface:'
							),
							_react2.default.createElement(
								'pre',
								{ className: 'code' },
								'\n<Modal ...>\n<Modal.Preface>\n  <img src="/assets/light.jpg" />\n</Modal.Preface>\n...\n</Modal>\n'.trim()
							)
						)
					)
				),
				_react2.default.createElement(
					'h2',
					null,
					'\u786E\u8BA4\u5BF9\u8BDD\u6846'
				),
				_react2.default.createElement(
					'p',
					null,
					'\u5F53\u4F60\u8BBE\u7F6E',
					_react2.default.createElement(
						'code',
						null,
						'onConfirm'
					),
					'\u4E8B\u4EF6\u5C5E\u6027\u540E\uFF0C\u5BF9\u8BDD\u6846\u5C06\u81EA\u52A8\u8F6C\u6362\u6210\u786E\u8BA4\u5BF9\u8BDD\u6846\u3002 \uFF08\u60A8\u53EF\u4EE5\u901A\u8FC7\u6DFB\u52A0',
					_react2.default.createElement(
						'code',
						null,
						'noMaskClose'
					),
					'\u5C5E\u6027\u6765\u7981\u7528\u70B9\u51FB\u80CC\u666F\u5173\u95ED\u529F\u80FD\uFF09'
				),
				_react2.default.createElement(
					'div',
					{ className: 'measurement' },
					_react2.default.createElement(
						'div',
						{ className: 'preview' },
						_react2.default.createElement(
							_components.Button,
							{
								onClick: function onClick() {
									_this2.setState({ confirmVisible: true });
								}
							},
							'\u70B9\u51FB\u5F39\u7A97'
						),
						_react2.default.createElement(
							_components.Modal,
							{
								title: 'Confirm Modal',
								visible: confirmVisible,
								onClose: function onClose() {
									_this2.setState({
										confirmVisible: false
									});
								},
								onConfirm: function onConfirm() {
									// TODO: do alert
									console.log('confirm');
									_this2.setState({
										confirmVisible: false
									});
								},
								noMaskClose: true
							},
							'Click confirm will popup another modal'
						)
					),
					_react2.default.createElement(
						'pre',
						{ className: 'code' },
						'\n<Modal onConfirm={...} noMaskClose ...>\n...\n</Modal>\n'.trim()
					)
				),
				_react2.default.createElement(
					'p',
					null,
					'\u540C\u6837\uFF0C\u4F60\u4E5F\u53EF\u4EE5\u901A\u8FC7',
					_react2.default.createElement(
						'code',
						null,
						'cancelText'
					),
					'\u548C',
					_react2.default.createElement(
						'code',
						null,
						'confirmText'
					),
					'\u6765\u81EA\u5B9A\u4E49Cancel\u548CConfirm\u6309\u94AE\u7684\u6587\u672C\u5185\u5BB9\u3002'
				),
				_react2.default.createElement(
					'h2',
					null,
					'\u7B49\u5F85\u5BF9\u8BDD\u6846'
				),
				_react2.default.createElement(
					'p',
					null,
					'\u5F53\u4F60\u9700\u8981\u5F02\u6B65\u64CD\u4F5C\u65F6\uFF0C\u4F60\u53EF\u4EE5\u901A\u8FC7\u8BBE\u7F6E',
					_react2.default.createElement(
						'code',
						null,
						'loading'
					),
					'\u5C5E\u6027\uFF0C\u6682\u65F6\u5C06\u5BF9\u8BDD\u6846\u9501\u5B9A\u3002'
				),
				_react2.default.createElement(
					'div',
					{ className: 'measurement' },
					_react2.default.createElement(
						'div',
						{ className: 'preview' },
						_react2.default.createElement(
							_components.Button,
							{
								onClick: function onClick() {
									_this2.setState({ loadingVisible: true });
								}
							},
							'\u70B9\u51FB\u5F39\u7A97'
						),
						_react2.default.createElement(
							_components.Modal,
							{
								title: 'Confirm Modal',
								visible: loadingVisible,
								loading: loading,
								onClose: function onClose() {
									_this2.setState({
										loadingVisible: false
									});
								},
								onConfirm: function onConfirm() {
									_this2.setState({ loading: true });
									setTimeout(function () {
										_this2.setState({ loading: false, loadingVisible: false });
									}, 2000);
								}
							},
							'Click confirm will display loading animation'
						)
					),
					_react2.default.createElement(
						'pre',
						{ className: 'code' },
						'\n<Modal onConfirm={...} loading ...>\n...\n</Modal>\n'.trim()
					)
				),
				_react2.default.createElement(
					'p',
					null,
					'\u60A8\u4E5F\u53EF\u4EE5\u4F7F\u7528',
					_react2.default.createElement(
						'code',
						null,
						'lock'
					),
					'\u5C5E\u6027\u4EC5\u4EC5\u5C06',
					_react2.default.createElement(
						'code',
						null,
						'Modal.Footer'
					),
					'\u4E2D\u7684\u6309\u94AE\u9501\u5B9A\u3002'
				),
				_react2.default.createElement(
					'div',
					{ className: 'preview' },
					_react2.default.createElement(
						_components.Button,
						{
							onClick: function onClick() {
								_this2.setState({ lockVisible: true });
							}
						},
						'\u70B9\u51FB\u5F39\u7A97'
					),
					_react2.default.createElement(
						_components.Modal,
						{
							title: 'Confirm Modal',
							visible: lockVisible,
							lock: lock,
							onClose: function onClose() {
								_this2.setState({
									lockVisible: false
								});
							},
							onConfirm: function onConfirm() {
								_this2.setState({ lock: true });
								setTimeout(function () {
									_this2.setState({ lock: false });
								}, 2000);
							}
						},
						'Click confirm will lock dialog in 2 seconds.'
					)
				),
				_react2.default.createElement(
					'h2',
					null,
					'js\u8C03\u7528'
				),
				_react2.default.createElement(
					'p',
					null,
					'\u5F53\u7136\uFF0C\u6709\u65F6\u5019\u60A8\u4F1A\u5E0C\u671B\u5F39\u51FA\u6846\u50CF\u4F7F\u7528',
					_react2.default.createElement(
						'code',
						null,
						'alert'
					),
					'\u4E00\u822C\uFF0C\u53EC\u4E4B\u5373\u6765\u3002 \u6211\u4EEC\u5BF9',
					_react2.default.createElement(
						'code',
						null,
						'onClose'
					),
					'\u548C',
					_react2.default.createElement(
						'code',
						null,
						'onConfirm'
					),
					'\u8FDB\u884C\u4E86\u5C01\u88C5\uFF0C \u56E0\u800C\u4F60\u53EF\u4EE5\u8FD4\u56DE\u4E00\u4E2Apromise\u5BF9\u8C61\uFF0CModal\u5C06\u81EA\u52A8\u7B49\u5F85promise\u5B8C\u6210\u624D\u5173\u95ED\u3002'
				),
				_react2.default.createElement(
					'div',
					{ className: 'measurement' },
					_react2.default.createElement(
						'div',
						{ className: 'preview' },
						_react2.default.createElement(
							_components.Button,
							{
								onClick: function onClick() {
									_components.Modal.showDialog({
										title: 'Hello',
										content: 'Bamboo UI'
									});
								}
							},
							'\u5F39\u51FA\u5BF9\u8BDD\u6846'
						),
						' ',
						_react2.default.createElement(
							_components.Button,
							{
								onClick: function onClick() {
									_components.Modal.showDialog({
										title: 'Hello',
										content: 'Bamboo UI',
										onConfirm: function onConfirm() {
											return new Promise(function (resolve) {
												_components.Modal.showDialog({
													title: null,
													content: 'You click confirm!',
													size: 'xs',
													onClose: resolve
												});
											});
										}
									});
								}
							},
							'\u5F39\u51FA\u786E\u8BA4\u6846'
						)
					),
					_react2.default.createElement(
						'pre',
						{ className: 'code' },
						'\nModal.showDialog({\ntitle: \'Hello\',\ncontent: \'Bamboo UI\',\nonConfirm: () => (\n  new Promise((resolve) => {\n\t Modal.showDialog({\n\t\ttitle: null,\n\t\tcontent: \'You click confirm!\',\n\t\tsize: \'xs\',\n\t\tonClose: resolve,\n\t });\n  })\n),\n});\n'.trim()
					)
				),
				_react2.default.createElement(
					'h2',
					null,
					'\u81EA\u5B9A\u4E49',
					_react2.default.createElement(
						'code',
						null,
						'Title'
					),
					'\uFF0C',
					_react2.default.createElement(
						'code',
						null,
						'Content'
					),
					'\u548C',
					_react2.default.createElement(
						'code',
						null,
						'Footer'
					)
				),
				_react2.default.createElement(
					'p',
					null,
					'Modal \u63D0\u4F9B\u4E86',
					_react2.default.createElement(
						'code',
						null,
						'title'
					),
					'\uFF0C',
					_react2.default.createElement(
						'code',
						null,
						'content'
					),
					'\uFF08\u7B49\u540C\u4E8Echildren\uFF09 \u548C ',
					_react2.default.createElement(
						'code',
						null,
						'footer'
					),
					'\u5C5E\u6027\u7528\u4EE5\u81EA\u5B9A\u4E49\u4F60\u9700\u8981\u7684\u6807\u9898\u3001\u5185\u5BB9 \u548C \u5E95\u90E8 \u5185\u5BB9\u3002 \u5F53\u7136\u4E86\uFF0C\u60A8\u4E5F\u53EF\u4EE5\u901A\u8FC7\u7EC4\u4EF6\u5F62\u5F0F\u6765\u81EA\u5B9A\u4E49\u8FD9\u4E9B\u5185\u5BB9\u3002'
				),
				_react2.default.createElement(
					'pre',
					{ className: 'code' },
					'\n<Modal>\n<Modal.Title>Your title</Modal.Title>\n<Modal.Content>Your content</Modal.Content>\n<Modal.Footer>Your footer</Modal.Footer>\n</Modal>\n'.trim()
				)
			);
		}
	}]);

	return GroupPage;
}(_react2.default.Component);

exports.default = GroupPage;

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _components = __webpack_require__(3);

var _enum = __webpack_require__(5);

var _propsUtil = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NavPage = function (_React$Component) {
	_inherits(NavPage, _React$Component);

	function NavPage() {
		_classCallCheck(this, NavPage);

		var _this = _possibleConstructorReturn(this, (NavPage.__proto__ || Object.getPrototypeOf(NavPage)).call(this));

		_this.getSampleCode = function () {
			var _this$state$form = _this.state.form,
			    active = _this$state$form.active,
			    form = _objectWithoutProperties(_this$state$form, ['active']);

			return ('\n<Navigation' + (0, _propsUtil.toString)(form, { type: '' }) + '>\n   <Navigation.Group title="Group 1"' + (active === 0 ? ' active' : '') + '>\n      <Navigation.Item>Item 1</Navigation.Item>\n      <Navigation.Item>Item 2</Navigation.Item>\n      <Navigation.Item>Item 3</Navigation.Item>\n   </Navigation.Group>\n   <Navigation.Item' + (active === 1 ? ' active' : '') + '>\n      <a\n         href="https://github.com/zombieJ/bamboo-ui"\n         target="_blank"\n         rel="noopener noreferrer"\n      >\n         Item 1\n      </a>\n   </Navigation.Item>\n   <Navigation.Item' + (active === 2 ? ' active' : '') + ' disabled>\n      Disabled\n   </Navigation.Item>\n</Navigation>\n').trim();
		};

		_this.state = {
			form: {
				type: '',
				active: -1,
				vertical: false,
				inline: false
			}
		};
		return _this;
	}

	_createClass(NavPage, [{
		key: 'render',
		value: function render() {
			var form = this.state.form;


			return _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(
					'h1',
					null,
					'\u5BFC\u822A\u6761'
				),
				_react2.default.createElement(
					'h2',
					null,
					'\u8BD5\u4E00\u8BD5'
				),
				_react2.default.createElement(
					'div',
					{ className: 'measurement' },
					_react2.default.createElement(
						'div',
						{ className: 'preview' },
						_react2.default.createElement(
							_components.Row,
							null,
							_react2.default.createElement(
								_components.Col,
								{ xs: form.vertical ? '1/3' : '1/1' },
								_react2.default.createElement(
									_components.Navigation,
									{ type: form.type, vertical: form.vertical, inline: form.inline },
									_react2.default.createElement(
										_components.Navigation.Group,
										{ title: 'Group 1', active: form.active === 0 },
										_react2.default.createElement(
											_components.Navigation.Item,
											null,
											'Item 1'
										),
										_react2.default.createElement(
											_components.Navigation.Item,
											null,
											'Item 2'
										),
										_react2.default.createElement(
											_components.Navigation.Item,
											null,
											_react2.default.createElement(
												'a',
												{
													href: 'https://github.com/zombieJ/bamboo-ui',
													target: '_blank',
													rel: 'noopener noreferrer'
												},
												'Link'
											)
										)
									),
									_react2.default.createElement(
										_components.Navigation.Item,
										{ active: form.active === 1 },
										_react2.default.createElement(
											'a',
											{
												href: 'https://github.com/zombieJ/bamboo-ui',
												target: '_blank',
												rel: 'noopener noreferrer'
											},
											'Link'
										)
									),
									_react2.default.createElement(
										_components.Navigation.Item,
										{ active: form.active === 2, disabled: true },
										'Disabled'
									)
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'form' },
						_react2.default.createElement(
							_components.Form,
							{ instance: this, path: 'form' },
							_react2.default.createElement(
								_components.Form.Field,
								{ name: 'type', title: 'Type' },
								_react2.default.createElement(
									_components.Radio,
									{ value: '' },
									'(default)'
								),
								_enum.TYPE_LIST.map(function (_ref) {
									var name = _ref.name;
									return _react2.default.createElement(
										_components.Radio,
										{ key: name, value: name },
										name
									);
								})
							),
							_react2.default.createElement(
								_components.Form.Field,
								{ name: 'active', title: 'Active' },
								_react2.default.createElement(
									_components.Radio,
									{ value: -1 },
									'(none)'
								),
								_react2.default.createElement(
									_components.Radio,
									{ value: 0 },
									'No.1'
								),
								_react2.default.createElement(
									_components.Radio,
									{ value: 1 },
									'No.2'
								),
								_react2.default.createElement(
									_components.Radio,
									{ value: 2 },
									'No.3'
								)
							),
							_react2.default.createElement(
								_components.Form.Field,
								{ name: 'vertical', title: 'Vertical' },
								_react2.default.createElement(
									_components.Checkbox,
									null,
									'vertical'
								)
							),
							form.vertical && _react2.default.createElement(
								_components.Form.Field,
								{ name: 'inline', title: 'Inline' },
								_react2.default.createElement(
									_components.Checkbox,
									null,
									'inline'
								)
							)
						)
					),
					_react2.default.createElement(
						'pre',
						{ className: 'code' },
						this.getSampleCode()
					)
				)
			);
		}
	}]);

	return NavPage;
}(_react2.default.Component);

exports.default = NavPage;

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactCssModules = __webpack_require__(12);

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _components = __webpack_require__(3);

var _enum = __webpack_require__(5);

var _propsUtil = __webpack_require__(6);

var _CurtainPage = __webpack_require__(28);

var _CurtainPage2 = _interopRequireDefault(_CurtainPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CurtainPage = function (_React$Component) {
	_inherits(CurtainPage, _React$Component);

	function CurtainPage() {
		_classCallCheck(this, CurtainPage);

		var _this = _possibleConstructorReturn(this, (CurtainPage.__proto__ || Object.getPrototypeOf(CurtainPage)).call(this));

		_this.onCurtainClose = function () {
			_this.setState({ visible: false });
		};

		_this.getSampleCode = function () {
			var hasClose = _this.state.form.hasClose;

			var closeStr = '';
			if (hasClose) {
				closeStr = ' onClose={...}';
			}

			return ('\n<Curtain visible={visible}' + closeStr + '>\n\t...\n</Curtain>\n\t\t').trim().replace(/\t/g, '   ');
		};

		_this.state = {
			form: {
				hasClose: false
			},
			visible: false
		};
		return _this;
	}

	_createClass(CurtainPage, [{
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _state = this.state,
			    visible = _state.visible,
			    hasClose = _state.form.hasClose;


			var props = {};
			if (hasClose) {
				props.onClose = this.onCurtainClose;
			}

			return _react2.default.createElement(
				'div',
				{ styleName: 'curtain' },
				_react2.default.createElement(
					'h1',
					null,
					'\u5E55\u5E03'
				),
				_react2.default.createElement(
					'p',
					null,
					'\u8BE5\u7EC4\u4EF6\u63D0\u4F9B\u5168\u5C4F\u5E55\u5E03\uFF0C\u4F60\u53EF\u4EE5\u901A\u8FC7\u5B83\u6765\u521B\u5EFA\u4E00\u4E2A\u4E34\u65F6\u7684\u5F39\u7A97\u7A7A\u767D\u9875\u9762\u3002'
				),
				_react2.default.createElement(
					'div',
					{ className: 'measurement' },
					_react2.default.createElement(
						'div',
						{ className: 'preview' },
						_react2.default.createElement(
							_components.Button,
							{
								onClick: function onClick() {
									_this2.setState({ visible: true });
								}
							},
							'\u70B9\u51FB\u5C55\u793A\u821E\u53F0'
						),
						_react2.default.createElement(
							_components.Curtain,
							_extends({ visible: visible, styleName: 'curtain-sample' }, props),
							_react2.default.createElement(
								'h1',
								null,
								'\u4F60\u597D\uFF0C\u5E55\u5E03'
							),
							_react2.default.createElement('img', { src: './assets/light.min.jpg', alt: 'Light' }),
							_react2.default.createElement(
								_components.Button,
								{
									onClick: function onClick() {
										_this2.setState({ visible: false });
									}
								},
								'\u70B9\u51FB\u5173\u95ED'
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'form' },
						_react2.default.createElement(
							_components.Form,
							{ instance: this, path: 'form' },
							_react2.default.createElement(
								_components.Form.Field,
								{ name: 'hasClose' },
								_react2.default.createElement(
									_components.Checkbox,
									null,
									'Provide ',
									_react2.default.createElement(
										'code',
										null,
										'onClose'
									),
									' function. (Will show ',
									_react2.default.createElement('span', { className: 'bmbo-times' }),
									' on the top right)'
								)
							)
						)
					),
					_react2.default.createElement(
						'pre',
						{ className: 'code' },
						this.getSampleCode()
					)
				)
			);
		}
	}]);

	return CurtainPage;
}(_react2.default.Component);

exports.default = (0, _reactCssModules2.default)(CurtainPage, _CurtainPage2.default);

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactCssModules = __webpack_require__(12);

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _components = __webpack_require__(3);

var _enum = __webpack_require__(5);

var _propsUtil = __webpack_require__(6);

var _CurtainPage = __webpack_require__(28);

var _CurtainPage2 = _interopRequireDefault(_CurtainPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CurtainPage = function (_React$Component) {
	_inherits(CurtainPage, _React$Component);

	function CurtainPage() {
		_classCallCheck(this, CurtainPage);

		var _this = _possibleConstructorReturn(this, (CurtainPage.__proto__ || Object.getPrototypeOf(CurtainPage)).call(this));

		_this.state = {
			form: {
				value: 50,
				type: 'primary',
				size: 'md',
				active: false,
				showMark: false
			}
		};
		return _this;
	}

	_createClass(CurtainPage, [{
		key: 'render',
		value: function render() {
			var form = this.state.form;


			return _react2.default.createElement(
				'div',
				{ styleName: 'curtain' },
				_react2.default.createElement(
					'h1',
					null,
					'\u8FDB\u5EA6\u6761'
				),
				_react2.default.createElement(
					'p',
					null,
					'\u6CA1\u9519\uFF0C\u662F\u4E2A\u7EC4\u4EF6\u5E93\u5C31\u4F1A\u6709\u8FDB\u5EA6\u6761\u7EC4\u4EF6\u3002'
				),
				_react2.default.createElement(
					'h2',
					null,
					'\u8BD5\u4E00\u8BD5'
				),
				_react2.default.createElement(
					'div',
					{ className: 'measurement' },
					_react2.default.createElement(
						'div',
						{ className: 'preview' },
						_react2.default.createElement(_components.Progress, {
							value: Number(form.value),
							type: form.type,
							size: form.size,
							active: form.active,
							showMark: form.showMark
						})
					),
					_react2.default.createElement(
						'div',
						{ className: 'form' },
						_react2.default.createElement(
							_components.Form,
							{ instance: this, path: 'form' },
							_react2.default.createElement(
								_components.Form.Field,
								{ name: 'type', title: 'Type' },
								_enum.TYPE_LIST.map(function (_ref) {
									var name = _ref.name;
									return _react2.default.createElement(
										_components.Radio,
										{ key: name, value: name },
										name,
										name === 'primary' && ' (default)'
									);
								})
							),
							_react2.default.createElement(
								_components.Form.Field,
								{ name: 'size', title: 'Size' },
								_enum.SIZE_LIST.map(function (_ref2) {
									var name = _ref2.name,
									    displayName = _ref2.displayName,
									    isDefault = _ref2.isDefault;
									return _react2.default.createElement(
										_components.Radio,
										{ key: name, value: name },
										displayName,
										isDefault && ' (default)'
									);
								})
							),
							_react2.default.createElement(
								_components.Form.Field,
								{ name: 'value', title: 'Value' },
								_react2.default.createElement(_components.Input, { type: 'number' })
							),
							_react2.default.createElement(
								_components.Form.Field,
								{ name: 'showMark', title: 'Show Mark' },
								_react2.default.createElement(
									_components.Checkbox,
									null,
									'showMark'
								)
							),
							_react2.default.createElement(
								_components.Form.Field,
								{ name: 'active', title: 'Active' },
								_react2.default.createElement(
									_components.Checkbox,
									null,
									'active'
								)
							)
						)
					),
					_react2.default.createElement(
						'pre',
						{ className: 'code' },
						'lol'
					)
				)
			);
		}
	}]);

	return CurtainPage;
}(_react2.default.Component);

exports.default = (0, _reactCssModules2.default)(CurtainPage, _CurtainPage2.default);

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _components = __webpack_require__(3);

var _enum = __webpack_require__(5);

var _propsUtil = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ButtonPage = function (_React$Component) {
	_inherits(ButtonPage, _React$Component);

	function ButtonPage() {
		_classCallCheck(this, ButtonPage);

		var _this = _possibleConstructorReturn(this, (ButtonPage.__proto__ || Object.getPrototypeOf(ButtonPage)).call(this));

		_this.getSampleCode = function () {
			var form = _this.state.form;


			return ('\n<Tooltip' + (0, _propsUtil.toString)(form, { placement: 'top' }) + '>\n\t<Button>Hover Me!</Button>\n</Tooltip>\n').replace(/\t/g, '   ').trim();
		};

		_this.state = {
			form: {
				title: 'Hello, Bamboo UI!',
				placement: 'top',
				inject: false
			}
		};
		return _this;
	}

	_createClass(ButtonPage, [{
		key: 'render',
		value: function render() {
			var form = this.state.form;


			return _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(
					'h1',
					null,
					'\u63D0\u793A\u6846'
				),
				_react2.default.createElement(
					'p',
					null,
					'\u8BE5\u7EC4\u4EF6\u4F1A\u5305\u88F9\u5B50\u7EC4\u4EF6\u7528\u4EE5\u5904\u7406\u9F20\u6807\u4E8B\u4EF6\uFF0C \u5F53\u7136\u60A8\u4E5F\u53EF\u4EE5\u6DFB\u52A0',
					_react2.default.createElement(
						'code',
						null,
						'inject'
					),
					'\u5C5E\u6027\u6765\u6CE8\u5165\u9F20\u6807\u4E8B\u4EF6\u7ED9\u5B50\u7EC4\u4EF6\uFF0C\u4EE5\u907F\u514D\u989D\u5916\u7684dom\u5143\u7D20\u3002'
				),
				_react2.default.createElement(
					'p',
					null,
					'(\u5F53\u60A8\u4F7F\u7528',
					_react2.default.createElement(
						'code',
						null,
						'inject'
					),
					'\u65F6\uFF0C\u8BF7\u786E\u4FDD\u5B50\u5143\u7D20\u63A5\u6536',
					_react2.default.createElement(
						'code',
						null,
						'onMouseEnter'
					),
					'\u4E0E',
					_react2.default.createElement(
						'code',
						null,
						'onMouseLeave'
					),
					'\u4E8B\u4EF6)'
				),
				_react2.default.createElement(
					'div',
					{ className: 'measurement' },
					_react2.default.createElement(
						'div',
						{ className: 'preview' },
						_react2.default.createElement(
							_components.Tooltip,
							{ title: 'Hello, Bamboo UI!' },
							'\u3010\u8BD5\u8BD5\u60AC\u6D6E\u8FD9\u6BB5\u6587\u5B57\u3011'
						)
					),
					_react2.default.createElement(
						'pre',
						{ className: 'code' },
						'\n<Tooltip title="Hello, Bamboo UI!">\n\u3010\u8BD5\u8BD5\u60AC\u6D6E\u8FD9\u6BB5\u6587\u5B57\u3011\n</Tooltip>\n\t\t\t\t\t\t'.replace(/\t/g, '   ').trim()
					)
				),
				_react2.default.createElement(
					'h2',
					null,
					'\u8BD5\u4E00\u8BD5'
				),
				_react2.default.createElement(
					'div',
					{ className: 'measurement' },
					_react2.default.createElement(
						'div',
						{ className: 'preview' },
						_react2.default.createElement(
							_components.Tooltip,
							{
								title: form.title,
								placement: form.placement,
								inject: form.inject
							},
							_react2.default.createElement(
								_components.Button,
								null,
								'Hover Me!'
							)
						)
					),
					_react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							_components.Form,
							{ instance: this, path: 'form' },
							_react2.default.createElement(
								_components.Form.Field,
								{ name: 'title', title: 'Title' },
								_react2.default.createElement(_components.Input, null)
							),
							_react2.default.createElement(
								_components.Form.Field,
								{ name: 'placement', title: 'placement' },
								_react2.default.createElement(
									_components.Radio,
									{ value: 'top' },
									'Top (default)'
								),
								_react2.default.createElement(
									_components.Radio,
									{ value: 'bottom' },
									'Bottom'
								),
								_react2.default.createElement(
									_components.Radio,
									{ value: 'left' },
									'Left'
								),
								_react2.default.createElement(
									_components.Radio,
									{ value: 'right' },
									'Right'
								)
							),
							_react2.default.createElement(
								_components.Form.Field,
								{ name: 'inject', title: 'Inject' },
								_react2.default.createElement(
									_components.Checkbox,
									null,
									'inject'
								)
							)
						)
					),
					_react2.default.createElement(
						'pre',
						{ className: 'code' },
						this.getSampleCode()
					)
				)
			);
		}
	}]);

	return ButtonPage;
}(_react2.default.Component);

exports.default = ButtonPage;

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _components = __webpack_require__(3);

var _enum = __webpack_require__(5);

var _propsUtil = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DynamicNumberPage = function (_React$Component) {
	_inherits(DynamicNumberPage, _React$Component);

	function DynamicNumberPage() {
		_classCallCheck(this, DynamicNumberPage);

		var _this = _possibleConstructorReturn(this, (DynamicNumberPage.__proto__ || Object.getPrototypeOf(DynamicNumberPage)).call(this));

		_this.getSampleCode = function () {
			var form = _extends({}, _this.state.form);

			form.value = Number(form.value);
			form.duration = Number(form.duration);
			form.decimal = Number(form.decimal);
			form.step = Number(form.step);

			if (form.animateType === 0) {
				delete form.step;
			} else {
				delete form.duration;
			}
			delete form.animateType;

			return ('\n\u5F53\u524D\u503C\uFF1A\n<DynamicNumber' + (0, _propsUtil.toString)(form, { duration: 1000, decimal: 0 }) + ' />\n').replace(/\t/g, '   ').trim();
		};

		_this.state = {
			form: {
				value: 10,
				duration: 1000,
				decimal: 0,
				step: 1,
				animateType: 0
			}
		};
		return _this;
	}

	_createClass(DynamicNumberPage, [{
		key: 'render',
		value: function render() {
			var form = this.state.form;


			return _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(
					'h1',
					null,
					'\u52A8\u6001\u6570\u5B57'
				),
				_react2.default.createElement(
					'p',
					null,
					'\u52A8\u6001\u6570\u5B57\u53EF\u4EE5\u4F7F\u4F60\u901A\u8FC7\u52A8\u753B\u5F62\u5F0F\u5C55\u793A\u6570\u5B57\u5185\u5BB9\u3002'
				),
				_react2.default.createElement(
					'h2',
					null,
					'\u8BD5\u4E00\u8BD5'
				),
				_react2.default.createElement(
					'div',
					{ className: 'measurement' },
					_react2.default.createElement(
						'div',
						{ className: 'preview' },
						'\u5F53\u524D\u503C\uFF1A',
						_react2.default.createElement(_components.DynamicNumber, {
							value: Number(form.value),
							decimal: Number(form.decimal),
							duration: form.animateType === 0 ? Number(form.duration) : null,
							step: form.animateType === 1 ? Number(form.step) : null
						})
					),
					_react2.default.createElement(
						'div',
						{ className: 'form' },
						_react2.default.createElement(
							_components.Form,
							{ instance: this, path: 'form' },
							_react2.default.createElement(
								_components.Form.Field,
								{ name: 'value', title: 'Value' },
								_react2.default.createElement(_components.Input, { type: 'number' })
							),
							_react2.default.createElement(
								_components.Form.Field,
								{ name: 'decimal', title: 'Decimal (>=0)' },
								_react2.default.createElement(_components.Input, { type: 'number' })
							),
							_react2.default.createElement(
								_components.Form.Field,
								{ name: 'animateType', title: 'Animation' },
								_react2.default.createElement(
									_components.Radio,
									{ value: 0 },
									'By Duration'
								),
								_react2.default.createElement(
									_components.Radio,
									{ value: 1 },
									'By Step'
								)
							),
							form.animateType === 0 && _react2.default.createElement(
								_components.Form.Field,
								{ name: 'duration', title: 'Duration' },
								_react2.default.createElement(_components.Input, { type: 'number' })
							),
							form.animateType === 1 && _react2.default.createElement(
								_components.Form.Field,
								{ name: 'step', title: 'Step' },
								_react2.default.createElement(_components.Input, { type: 'number' })
							)
						)
					),
					_react2.default.createElement(
						'pre',
						{ className: 'code' },
						this.getSampleCode()
					)
				)
			);
		}
	}]);

	return DynamicNumberPage;
}(_react2.default.Component);

exports.default = DynamicNumberPage;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _components = __webpack_require__(3);

var _enum = __webpack_require__(5);

var _propsUtil = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DynamicStringPage = function (_React$Component) {
	_inherits(DynamicStringPage, _React$Component);

	function DynamicStringPage() {
		_classCallCheck(this, DynamicStringPage);

		var _this = _possibleConstructorReturn(this, (DynamicStringPage.__proto__ || Object.getPrototypeOf(DynamicStringPage)).call(this));

		_this.getSampleCode = function () {
			var form = _extends({}, _this.state.form);

			form.duration = Number(form.duration);
			form.step = Number(form.step);

			if (form.animateType === 0) {
				delete form.step;
			} else {
				delete form.duration;
			}
			delete form.animateType;

			return ('\n<DynamicString' + (0, _propsUtil.toString)(form, { duration: 1000 }) + ' />\n').replace(/\t/g, '   ').trim();
		};

		_this.state = {
			form: {
				value: 'Hello, Bamboo UI~',
				duration: 1000,
				step: 1,
				animateType: 0,
				cursor: false
			}
		};
		return _this;
	}

	_createClass(DynamicStringPage, [{
		key: 'render',
		value: function render() {
			var form = this.state.form;


			return _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(
					'h1',
					null,
					'\u52A8\u6001\u6587\u5B57'
				),
				_react2.default.createElement(
					'p',
					null,
					'\u52A8\u6001\u6587\u5B57\u53EF\u4EE5\u4F7F\u4F60\u901A\u8FC7\u52A8\u753B\u5F62\u5F0F\u5C55\u793A\u6587\u5B57\u5185\u5BB9\u3002'
				),
				_react2.default.createElement(
					'h2',
					null,
					'\u8BD5\u4E00\u8BD5'
				),
				_react2.default.createElement(
					'div',
					{ className: 'measurement' },
					_react2.default.createElement(
						'div',
						{ className: 'preview' },
						_react2.default.createElement(_components.DynamicString, {
							value: form.value,
							cursor: form.cursor,
							duration: form.animateType === 0 ? Number(form.duration) : null,
							step: form.animateType === 1 ? Number(form.step) : null
						})
					),
					_react2.default.createElement(
						'div',
						{ className: 'form' },
						_react2.default.createElement(
							_components.Form,
							{ instance: this, path: 'form' },
							_react2.default.createElement(
								_components.Form.Field,
								{ name: 'value', title: 'Value' },
								_react2.default.createElement(_components.Input, null)
							),
							_react2.default.createElement(
								_components.Form.Field,
								{ name: 'cursor', title: 'Cursor' },
								_react2.default.createElement(
									_components.Checkbox,
									null,
									'cursor'
								)
							),
							_react2.default.createElement(
								_components.Form.Field,
								{ name: 'animateType', title: 'Animation' },
								_react2.default.createElement(
									_components.Radio,
									{ value: 0 },
									'By Duration'
								),
								_react2.default.createElement(
									_components.Radio,
									{ value: 1 },
									'By Step'
								)
							),
							form.animateType === 0 && _react2.default.createElement(
								_components.Form.Field,
								{ name: 'duration', title: 'Duration' },
								_react2.default.createElement(_components.Input, { type: 'number' })
							),
							form.animateType === 1 && _react2.default.createElement(
								_components.Form.Field,
								{ name: 'step', title: 'Step' },
								_react2.default.createElement(_components.Input, { type: 'number' })
							)
						)
					),
					_react2.default.createElement(
						'pre',
						{ className: 'code' },
						this.getSampleCode()
					)
				)
			);
		}
	}]);

	return DynamicStringPage;
}(_react2.default.Component);

exports.default = DynamicStringPage;

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _components = __webpack_require__(3);

var _enum = __webpack_require__(5);

var _propsUtil = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AutoCompletePage = function (_React$Component) {
	_inherits(AutoCompletePage, _React$Component);

	function AutoCompletePage() {
		_classCallCheck(this, AutoCompletePage);

		var _this = _possibleConstructorReturn(this, (AutoCompletePage.__proto__ || Object.getPrototypeOf(AutoCompletePage)).call(this));

		_this.getSampleCode = function () {
			return '\n<AutoComplete matcher={matcherList} value={...} onChange={...} />\n'.replace(/\t/g, '   ').trim();
		};

		_this.state = {
			form: {},
			value: ''
		};
		return _this;
	}

	_createClass(AutoCompletePage, [{
		key: 'render',
		value: function render() {
			var form = this.state.form;


			var matcherList = [{
				value: 'ABCDE'
			}, {
				value: 'FGHIJ'
			}, {
				value: 'KLMNO'
			}, {
				value: 'PQRST'
			}, {
				value: 'UVWXYZ'
			}, 'ASD', 'BCD', 'EGG', 'GOOD', 'BAD'];

			return _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(
					'h1',
					null,
					'\u81EA\u52A8\u5B8C\u6210'
				),
				_react2.default.createElement(
					'p',
					null,
					'\u8BE5\u7EC4\u4EF6\u5C06\u76D1\u542C\u952E\u76D8\u4E8B\u4EF6\uFF0C\u8BF7\u52A1\u5FC5\u786E\u4FDD\u5B50\u7EC4\u4EF6\u652F\u6301',
					_react2.default.createElement(
						'code',
						null,
						'onKeyDown'
					),
					'\u548C',
					_react2.default.createElement(
						'code',
						null,
						'onKeyUp'
					),
					'\u4E8B\u4EF6\u3002'
				),
				_react2.default.createElement(
					'h2',
					null,
					'\u8BD5\u4E00\u8BD5'
				),
				_react2.default.createElement(
					'div',
					{ className: 'measurement' },
					_react2.default.createElement(
						'div',
						{ className: 'preview' },
						_react2.default.createElement(
							_components.Form,
							{ instance: this },
							_react2.default.createElement(
								_components.Form.Field,
								{ name: 'value' },
								_react2.default.createElement(_components.AutoComplete, { matcher: matcherList })
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'form' },
						_react2.default.createElement(
							'pre',
							null,
							'const matcherList = ',
							JSON.stringify(matcherList, null, 3)
						)
					),
					_react2.default.createElement(
						'pre',
						{ className: 'code' },
						this.getSampleCode()
					)
				)
			);
		}
	}]);

	return AutoCompletePage;
}(_react2.default.Component);

exports.default = AutoCompletePage;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _components = __webpack_require__(3);

var _enum = __webpack_require__(5);

var _propsUtil = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VALUE_LIST = ['Good', 'Bad', 'Just So So'];

function toDisabled(disabled) {
	if (disabled === true) return true;
	return undefined;
}

var SelectPage = function (_React$Component) {
	_inherits(SelectPage, _React$Component);

	function SelectPage() {
		_classCallCheck(this, SelectPage);

		var _this = _possibleConstructorReturn(this, (SelectPage.__proto__ || Object.getPrototypeOf(SelectPage)).call(this));

		_this.getSampleCode = function () {
			var _this$state$form = _this.state.form,
			    optionDisabled = _this$state$form.optionDisabled,
			    groupDisabled = _this$state$form.groupDisabled,
			    groupNoSelectAll = _this$state$form.groupNoSelectAll,
			    customizeTitle = _this$state$form.customizeTitle,
			    form = _objectWithoutProperties(_this$state$form, ['optionDisabled', 'groupDisabled', 'groupNoSelectAll', 'customizeTitle']);

			if (customizeTitle) {
				form.title = 'My Value: ' + form.value;
			}

			return ('\nconst VALUE_LIST = ' + JSON.stringify(VALUE_LIST) + ';\n\n<Select' + (0, _propsUtil.toString)(form, { size: 'md' }) + '>\n\t<Select.Group title="Group 1"' + (0, _propsUtil.toString)({ disabled: groupDisabled, noSelectAll: groupNoSelectAll }) + '>\n\t\t<Select.Option>Group Value 1</Select.Option>\n\t\t<Select.Option>Group Value 2</Select.Option>\n\t\t<Select.Option>Group Value 3</Select.Option>\n\t</Select.Group>\n\t{VALUE_LIST.map(val => (\n\t\t<Select.Option key={val}' + (0, _propsUtil.toString)({ disabled: optionDisabled }) + '>{val}</Select.Option>\n\t))}\n</Button>').trim().replace(/\t/g, '   ');
		};

		_this.state = {
			form: {
				value: VALUE_LIST[0],
				multi: false,
				size: 'md',
				disabled: false,
				noSelectAll: false,
				optionDisabled: false,
				groupDisabled: false,
				groupNoSelectAll: false,
				customizeTitle: false,
				flatten: false
			}
		};
		return _this;
	}

	_createClass(SelectPage, [{
		key: 'render',
		value: function render() {
			var form = this.state.form;


			return _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(
					'h1',
					null,
					'\u9009\u62E9\u6846'
				),
				_react2.default.createElement(
					'div',
					{ className: 'measurement' },
					_react2.default.createElement(
						'div',
						{ className: 'preview' },
						_react2.default.createElement(
							_components.Form,
							{ instance: this, path: 'form' },
							_react2.default.createElement(
								_components.Form.Field,
								{ name: 'value' },
								_react2.default.createElement(
									_components.Select,
									{
										value: form.value,
										multi: form.multi,
										size: form.size,
										disabled: form.disabled,
										noSelectAll: form.noSelectAll,
										title: form.customizeTitle ? 'My Value: ' + form.value : undefined,
										flatten: form.flatten
									},
									_react2.default.createElement(
										_components.Select.Group,
										{ title: 'Group 1', disabled: toDisabled(form.groupDisabled), noSelectAll: form.groupNoSelectAll },
										_react2.default.createElement(
											_components.Select.Option,
											null,
											'Group Value 1'
										),
										_react2.default.createElement(
											_components.Select.Option,
											null,
											'Group Value 2'
										),
										_react2.default.createElement(
											_components.Select.Option,
											null,
											'Group Value 3'
										)
									),
									VALUE_LIST.map(function (val) {
										return _react2.default.createElement(
											_components.Select.Option,
											{ key: val, disabled: toDisabled(form.optionDisabled) },
											val
										);
									})
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'form' },
						_react2.default.createElement(
							_components.Form,
							{ instance: this, path: 'form' },
							_react2.default.createElement(
								_components.Form.Field,
								{ name: 'size', title: 'Size' },
								_enum.SIZE_LIST.map(function (_ref) {
									var name = _ref.name,
									    displayName = _ref.displayName,
									    isDefault = _ref.isDefault;
									return _react2.default.createElement(
										_components.Radio,
										{ key: name, value: name },
										displayName,
										isDefault && ' (default)'
									);
								})
							),
							_react2.default.createElement(
								_components.Form.Field,
								{ name: 'multi', title: 'Multi' },
								_react2.default.createElement(
									_components.Checkbox,
									null,
									'multi'
								)
							),
							form.multi && _react2.default.createElement(
								_components.Form.Field,
								{ name: 'flatten', title: 'Flatten' },
								_react2.default.createElement(
									_components.Checkbox,
									null,
									'Flatten the list. Only work in ',
									_react2.default.createElement(
										'code',
										null,
										'multi'
									),
									' mode'
								)
							),
							form.multi && _react2.default.createElement(
								_components.Form.Field,
								{ name: 'noSelectAll', title: 'No Select All' },
								_react2.default.createElement(
									_components.Checkbox,
									null,
									'noSelectAll'
								)
							),
							form.multi && _react2.default.createElement(
								_components.Form.Field,
								{ name: 'groupNoSelectAll', title: 'Group No Select All' },
								_react2.default.createElement(
									_components.Checkbox,
									null,
									'groupNoSelectAll'
								)
							),
							_react2.default.createElement(
								_components.Form.Field,
								{ name: 'disabled', title: 'Disabled' },
								_react2.default.createElement(
									_components.Checkbox,
									null,
									'disabled'
								)
							),
							_react2.default.createElement(
								_components.Form.Field,
								{ name: 'optionDisabled', title: 'Option Disabled' },
								_react2.default.createElement(
									_components.Checkbox,
									null,
									'Option Disabled'
								)
							),
							_react2.default.createElement(
								_components.Form.Field,
								{ name: 'groupDisabled', title: 'Group Disabled' },
								_react2.default.createElement(
									_components.Checkbox,
									null,
									'Group Disabled'
								)
							),
							_react2.default.createElement(
								_components.Form.Field,
								{ name: 'customizeTitle', title: 'Customize Title' },
								_react2.default.createElement(
									_components.Checkbox,
									null,
									'Customize Title'
								)
							)
						)
					),
					_react2.default.createElement(
						'pre',
						{ className: 'code' },
						this.getSampleCode()
					)
				)
			);
		}
	}]);

	return SelectPage;
}(_react2.default.Component);

exports.default = SelectPage;

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _components = __webpack_require__(3);

var _enum = __webpack_require__(5);

var _propsUtil = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var data = [];
for (var i = 0; i < 100; i += 1) {
	data.push({
		id: i,
		name: 'name_' + i
	});
}

var TablePage = function (_React$Component) {
	_inherits(TablePage, _React$Component);

	function TablePage() {
		_classCallCheck(this, TablePage);

		var _this = _possibleConstructorReturn(this, (TablePage.__proto__ || Object.getPrototypeOf(TablePage)).call(this));

		_this.onPageChange = function (page) {
			console.log('Page Change:', page);
		};

		_this.onRowClick = function (item) {
			console.log('Row Click:', item);
		};

		_this.state = {
			form: {}
		};
		return _this;
	}

	_createClass(TablePage, [{
		key: 'render',
		value: function render() {
			return _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(
					'h1',
					null,
					'\u8868\u683C'
				),
				_react2.default.createElement(
					_components.Table,
					{
						data: data,
						onPageChange: this.onPageChange,
						onRowClick: this.onRowClick,
						bordered: true,
						hover: true
					},
					_react2.default.createElement(_components.Table.Column, { width: '100', name: 'id' }),
					_react2.default.createElement(_components.Table.Column, { width: '200', name: 'name' })
				),
				_react2.default.createElement(
					'h2',
					null,
					'\u4F7F\u7528\u6837\u5F0F'
				),
				_react2.default.createElement(
					'p',
					null,
					'\u4F60\u53EF\u4EE5\u901A\u8FC7\u6DFB\u52A0',
					_react2.default.createElement(
						'code',
						null,
						'bmbo-table'
					),
					'class\u6765\u5C06\u8868\u683C\u53D8\u4E3ABamboo UI\u98CE\u683C\u3002 \u540C\u65F6\u6DFB\u52A0',
					_react2.default.createElement(
						'code',
						null,
						'bmbo-bordered'
					),
					'class\u6765\u6DFB\u52A0\u8FB9\u6846\u7EBF\u3002'
				),
				_react2.default.createElement(
					'table',
					{ className: 'bmbo-table bmbo-border' },
					_react2.default.createElement(
						'thead',
						null,
						_react2.default.createElement(
							'tr',
							null,
							_react2.default.createElement(
								'th',
								null,
								'Head 1'
							),
							_react2.default.createElement(
								'th',
								null,
								'Head 2'
							)
						)
					),
					_react2.default.createElement(
						'tbody',
						null,
						_react2.default.createElement(
							'tr',
							null,
							_react2.default.createElement(
								'td',
								null,
								'TD 1'
							),
							_react2.default.createElement(
								'td',
								{ className: 'bmbo-primary' },
								'.primary'
							)
						),
						_react2.default.createElement(
							'tr',
							null,
							_react2.default.createElement(
								'td',
								null,
								'TD 1'
							),
							_react2.default.createElement(
								'td',
								{ className: 'bmbo-info' },
								'.info'
							)
						),
						_react2.default.createElement(
							'tr',
							null,
							_react2.default.createElement(
								'td',
								null,
								'TD 1'
							),
							_react2.default.createElement(
								'td',
								{ className: 'bmbo-success' },
								'.success'
							)
						),
						_react2.default.createElement(
							'tr',
							null,
							_react2.default.createElement(
								'td',
								null,
								'TD 1'
							),
							_react2.default.createElement(
								'td',
								{ className: 'bmbo-danger' },
								'.danger'
							)
						),
						_react2.default.createElement(
							'tr',
							null,
							_react2.default.createElement(
								'td',
								null,
								'TD 1'
							),
							_react2.default.createElement(
								'td',
								{ className: 'bmbo-warning' },
								'.warning'
							)
						),
						_react2.default.createElement(
							'tr',
							null,
							_react2.default.createElement(
								'td',
								null,
								'TD 1'
							),
							_react2.default.createElement(
								'td',
								{ className: 'bmbo-forbid' },
								'.forbid'
							)
						)
					)
				),
				_react2.default.createElement(
					'h2',
					null,
					'\u81EA\u9002\u5E94'
				),
				_react2.default.createElement(
					'p',
					null,
					'\u540C',
					_react2.default.createElement(
						'code',
						null,
						'Bootstrap'
					),
					'\u4E00\u6837\uFF0C \u4F60\u53EF\u4EE5\u901A\u8FC7\u5728',
					_react2.default.createElement(
						'code',
						null,
						'table'
					),
					'\u5916\u5305\u88F9\u4E00\u4E2A',
					_react2.default.createElement(
						'code',
						null,
						'className="bmbo-table-responsive"'
					),
					'\u7684div\u6765\u8FDB\u884C\u81EA\u9002\u5E94\u652F\u6301\u3002'
				),
				_react2.default.createElement(
					'strong',
					null,
					'\u5E26\u5185\u8FB9\u6846\uFF1A'
				),
				_react2.default.createElement(
					'div',
					{ className: 'bmbo-table-responsive' },
					_react2.default.createElement(
						'table',
						{ className: 'bmbo-table bmbo-border' },
						_react2.default.createElement(
							'tbody',
							null,
							_react2.default.createElement(
								'tr',
								null,
								Array(10).fill(0).map(function (_, index) {
									return _react2.default.createElement(
										'td',
										{ key: index },
										'Column_',
										index + 1
									);
								})
							),
							_react2.default.createElement(
								'tr',
								null,
								Array(10).fill(0).map(function (_, index) {
									return _react2.default.createElement(
										'td',
										{ key: index },
										'Column_',
										index + 1
									);
								})
							),
							_react2.default.createElement(
								'tr',
								null,
								Array(10).fill(0).map(function (_, index) {
									return _react2.default.createElement(
										'td',
										{ key: index },
										'Column_',
										index + 1
									);
								})
							)
						)
					)
				),
				_react2.default.createElement(
					'strong',
					null,
					'\u65E0\u5185\u8FB9\u6846\uFF1A'
				),
				_react2.default.createElement(
					'div',
					{ className: 'bmbo-table-responsive' },
					_react2.default.createElement(
						'table',
						{ className: 'bmbo-table' },
						_react2.default.createElement(
							'tbody',
							null,
							_react2.default.createElement(
								'tr',
								null,
								Array(10).fill(0).map(function (_, index) {
									return _react2.default.createElement(
										'td',
										{ key: index },
										'Column_',
										index + 1
									);
								})
							),
							_react2.default.createElement(
								'tr',
								null,
								Array(10).fill(0).map(function (_, index) {
									return _react2.default.createElement(
										'td',
										{ key: index },
										'Column_',
										index + 1
									);
								})
							),
							_react2.default.createElement(
								'tr',
								null,
								Array(10).fill(0).map(function (_, index) {
									return _react2.default.createElement(
										'td',
										{ key: index },
										'Column_',
										index + 1
									);
								})
							)
						)
					)
				),
				_react2.default.createElement(
					'h2',
					null,
					'\u60AC\u6D6E'
				),
				_react2.default.createElement(
					'p',
					null,
					'\u901A\u8FC7\u6DFB\u52A0',
					_react2.default.createElement(
						'code',
						null,
						'bmbo-hover'
					),
					'\u6765\u4F7F\u8868\u683C\u83B7\u5F97\u9F20\u6807\u60AC\u6D6E\u9AD8\u4EAE\u6548\u679C\u3002 \u5F53\u7136\uFF0C\u60A8\u4E5F\u53EF\u4EE5\u5C06\u5176\u6DFB\u52A0\u5230',
					_react2.default.createElement(
						'code',
						null,
						'thead'
					),
					'\u3001',
					_react2.default.createElement(
						'code',
						null,
						'tbody'
					),
					'\u6216\u8005',
					_react2.default.createElement(
						'code',
						null,
						'tr'
					),
					'\u4E0A\u6765\u53EA\u8BA9\u90E8\u5206\u884C\u652F\u6301\u60AC\u6D6E\u9AD8\u4EAE\u6548\u679C\u3002'
				),
				_react2.default.createElement(
					'table',
					{ className: 'bmbo-table bmbo-hover' },
					_react2.default.createElement(
						'tbody',
						null,
						Array(5).fill(0).map(function (_, rowIndex) {
							return _react2.default.createElement(
								'tr',
								{ key: rowIndex },
								Array(3).fill(0).map(function (__, index) {
									return _react2.default.createElement(
										'td',
										{ key: index },
										'Column_',
										index + 1
									);
								})
							);
						})
					)
				)
			);
		}
	}]);

	return TablePage;
}(_react2.default.Component);

exports.default = TablePage;

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _components = __webpack_require__(3);

var _enum = __webpack_require__(5);

var _propsUtil = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LabelPage = function (_React$Component) {
	_inherits(LabelPage, _React$Component);

	function LabelPage() {
		_classCallCheck(this, LabelPage);

		var _this = _possibleConstructorReturn(this, (LabelPage.__proto__ || Object.getPrototypeOf(LabelPage)).call(this));

		_this.getSampleCode = function () {
			var _this$state$form = _this.state.form,
			    text = _this$state$form.text,
			    form = _objectWithoutProperties(_this$state$form, ['text']);

			return '<Label' + (0, _propsUtil.toString)(form, { type: 'primary', size: 'md' }) + '>\n   ' + text + '\n</Label>';
		};

		_this.state = {
			form: {
				text: '你的测试标签',
				type: 'primary',
				size: 'md'
			}
		};
		return _this;
	}

	_createClass(LabelPage, [{
		key: 'render',
		value: function render() {
			var form = this.state.form;


			return _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(
					'h1',
					null,
					'\u6807\u7B7E'
				),
				_react2.default.createElement(
					'div',
					{ className: 'measurement' },
					_react2.default.createElement(
						'div',
						{ className: 'preview' },
						'\u8FD9\u662F',
						' ',
						_react2.default.createElement(
							_components.Label,
							{
								type: form.type,
								disabled: form.disabled,
								size: form.size,
								transparent: form.transparent,
								checked: form.checked
							},
							form.text
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'form' },
						_react2.default.createElement(
							_components.Form,
							{ instance: this, path: 'form' },
							_react2.default.createElement(
								_components.Form.Field,
								{ name: 'text', title: 'Text' },
								_react2.default.createElement(_components.Input, null)
							),
							_react2.default.createElement(
								_components.Form.Field,
								{ name: 'type', title: 'Type' },
								_enum.TYPE_LIST.map(function (_ref) {
									var name = _ref.name,
									    isDefault = _ref.isDefault;
									return _react2.default.createElement(
										_components.Radio,
										{ key: name, value: name },
										name,
										isDefault && ' (default)'
									);
								})
							),
							_react2.default.createElement(
								_components.Form.Field,
								{ name: 'size', title: 'Size' },
								_enum.SIZE_LIST.map(function (_ref2) {
									var name = _ref2.name,
									    displayName = _ref2.displayName,
									    isDefault = _ref2.isDefault;
									return _react2.default.createElement(
										_components.Radio,
										{ key: name, value: name },
										displayName,
										isDefault && ' (default)'
									);
								})
							)
						)
					),
					_react2.default.createElement(
						'pre',
						{ className: 'code' },
						this.getSampleCode()
					)
				)
			);
		}
	}]);

	return LabelPage;
}(_react2.default.Component);

exports.default = LabelPage;

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactCssModules = __webpack_require__(12);

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _components = __webpack_require__(3);

var _enum = __webpack_require__(5);

var _propsUtil = __webpack_require__(6);

var _CurtainPage = __webpack_require__(28);

var _CurtainPage2 = _interopRequireDefault(_CurtainPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CurtainPage = function (_React$Component) {
	_inherits(CurtainPage, _React$Component);

	function CurtainPage() {
		_classCallCheck(this, CurtainPage);

		var _this = _possibleConstructorReturn(this, (CurtainPage.__proto__ || Object.getPrototypeOf(CurtainPage)).call(this));

		_this.getSampleCode = function () {
			var hasClose = _this.state.form.hasClose;

			var closeStr = '';
			if (hasClose) {
				closeStr = ' onClose={...}';
			}

			return ('\n<Curtain visible={visible}' + closeStr + '>\n\t...\n</Curtain>\n\t\t').trim().replace(/\t/g, '   ');
		};

		var now = new Date();

		_this.state = {
			form: {
				value: now.toISOString().replace('T', ' ').slice(0, 10)
			},
			visible: false
		};
		return _this;
	}

	_createClass(CurtainPage, [{
		key: 'render',
		value: function render() {
			var form = this.state.form;


			return _react2.default.createElement(
				'div',
				{ styleName: 'curtain' },
				_react2.default.createElement(
					'h1',
					null,
					'\u65E5\u671F\u9009\u62E9\u5668'
				),
				_react2.default.createElement('span', { className: 'bmbo-caret bmbo-caret-right' }),
				_react2.default.createElement(
					'div',
					{ className: 'measurement' },
					_react2.default.createElement(
						'div',
						{ className: 'preview' },
						_react2.default.createElement(
							_components.Form,
							{ instance: this, path: 'form' },
							_react2.default.createElement(
								_components.Form.Field,
								{ name: 'value', title: 'Date' },
								_react2.default.createElement(_components.Picker, null)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'form' },
						_react2.default.createElement(_components.Form, { instance: this, path: 'form' })
					),
					_react2.default.createElement(
						'pre',
						{ className: 'code' },
						this.getSampleCode()
					)
				)
			);
		}
	}]);

	return CurtainPage;
}(_react2.default.Component);

exports.default = (0, _reactCssModules2.default)(CurtainPage, _CurtainPage2.default);

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _components = __webpack_require__(3);

var _enum = __webpack_require__(5);

var _propsUtil = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TRIGGER_LIST = [{ name: 'click', isDefault: true }];

var PinBoxPage = function (_React$Component) {
	_inherits(PinBoxPage, _React$Component);

	function PinBoxPage() {
		_classCallCheck(this, PinBoxPage);

		var _this = _possibleConstructorReturn(this, (PinBoxPage.__proto__ || Object.getPrototypeOf(PinBoxPage)).call(this));

		_this.getSampleCode = function () {
			var form = _this.state.form;

			return ('\nconst $pin = (\n\t<div>\n\t\t<p>Hello World!~</p>\n\t\t<p>Hello World!~</p>\n\t\t<p>Hello World!~</p>\n\t</div>\n);\n\n<PinBox' + (0, _propsUtil.toString)(form, { trigger: 'click' }) + '>\n\t<Button>\n\t\t\u70B9\u51FB\u6B64\u6309\u94AE\u5C1D\u8BD5\u7C98\u9644\u6846\n\t</Button>\n</Button>\n').trim().replace(/\t/g, '   ');
		};

		_this.state = {
			form: {
				trigger: 'click',
				backdrop: false,
				stretch: false,
				disabled: false
			}
		};
		return _this;
	}

	_createClass(PinBoxPage, [{
		key: 'render',
		value: function render() {
			var form = this.state.form;


			var $pin = _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(
					'p',
					null,
					'Hello World!~'
				),
				_react2.default.createElement(
					'p',
					null,
					'Hello World!~'
				),
				_react2.default.createElement(
					'p',
					null,
					'Hello World!~'
				)
			);

			return _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(
					'h1',
					null,
					'\u7C98\u9644\u6846'
				),
				_react2.default.createElement(
					'p',
					null,
					'\u7C98\u9644\u6846\u53EF\u4F7F\u4F60\u7684\u7EC4\u4EF6\u62E5\u6709\u5F39\u51FA\u7C98\u9644\u5F39\u6846\u7684\u80FD\u529B\uFF0C \u4F8B\u5982',
					_react2.default.createElement(
						'code',
						null,
						'<Select>'
					),
					'\u3001',
					_react2.default.createElement(
						'code',
						null,
						'<DatePciker>'
					),
					'\u7B49\u7EC4\u4EF6\u3002 \u4F7F\u7528\u8BE5\u7EC4\u4EF6\u8BF7\u786E\u4FDD\u5B50\u7EC4\u4EF6\u63A5\u53D7\u5BF9\u5E94\u7684\u9F20\u6807\u4E8B\u4EF6\u3002 \u6B64\u5916\uFF0C\u6211\u4EEC\u8FD8\u63D0\u4F9B\u4E86',
					_react2.default.createElement(
						'code',
						null,
						'onVisibilityChange(visibility)'
					),
					'\u548C',
					_react2.default.createElement(
						'code',
						null,
						'onVisibilityChanged(visibility)'
					),
					'\u4E8B\u4EF6\u7528\u4E8E\u4F60\u6765\u5904\u7406\u5F39\u51FA\u6846\u989D\u663E\u793A/\u9690\u85CF\u4E8B\u4EF6\u3002'
				),
				_react2.default.createElement(
					'div',
					{ className: 'measurement' },
					_react2.default.createElement(
						'div',
						{ className: 'preview' },
						_react2.default.createElement(
							_components.PinBox,
							{
								trigger: form.trigger,
								backdrop: form.backdrop,
								stretch: form.stretch,
								disabled: form.disabled,
								pin: $pin,
								onVisibilityChange: function onVisibilityChange(visibility) {
									console.log('Do trigger:', visibility);
								},
								onVisibilityChanged: function onVisibilityChanged(visibility) {
									console.log('Do triggered:', visibility);
								}
							},
							_react2.default.createElement(
								_components.Button,
								null,
								'\u70B9\u51FB\u6B64\u6309\u94AE\u5C1D\u8BD5\u7C98\u9644\u6846'
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'form' },
						_react2.default.createElement(
							_components.Form,
							{ instance: this, path: 'form' },
							_react2.default.createElement(
								_components.Form.Field,
								{ name: 'trigger', title: 'Trigger' },
								TRIGGER_LIST.map(function (_ref) {
									var name = _ref.name,
									    isDefault = _ref.isDefault;
									return _react2.default.createElement(
										_components.Radio,
										{ key: name, value: name },
										name,
										isDefault && ' (default)'
									);
								})
							),
							_react2.default.createElement(
								_components.Form.Field,
								{ name: 'disabled', title: 'Disabled' },
								_react2.default.createElement(
									_components.Checkbox,
									null,
									'disabled'
								)
							),
							_react2.default.createElement(
								_components.Form.Field,
								{ name: 'backdrop', title: 'Backdrop' },
								_react2.default.createElement(
									_components.Checkbox,
									null,
									'Hide pin box when click on window'
								)
							),
							_react2.default.createElement(
								_components.Form.Field,
								{ name: 'stretch', title: 'Stretch' },
								_react2.default.createElement(
									_components.Checkbox,
									null,
									'Stretch the pin box to fit sub component\'s width'
								)
							)
						)
					),
					_react2.default.createElement(
						'pre',
						{ className: 'code' },
						this.getSampleCode()
					)
				)
			);
		}
	}]);

	return PinBoxPage;
}(_react2.default.Component);

exports.default = PinBoxPage;

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _components = __webpack_require__(3);

var _enum = __webpack_require__(5);

var _propsUtil = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FLAT_LIST = [{
	value: '1',

	list: [{
		value: '1 - 1',
		list: [{ value: '1 - 1 - 1' }]
	}, {
		value: '1 - 2',
		list: [{ value: '1 - 2 - 1' }]
	}, {
		value: '1 - 3',
		list: [{ value: '1 - 3 - 1' }]
	}]
}, {
	value: '2',
	list: [{
		value: '2 - 1',
		list: [{ value: '2 - 1 - 1' }]
	}]
}];

var FLAT_LIST2 = [{
	value: '1',

	list: [{
		value: '1 - 1',
		title: 'a - 1',
		list: [{ value: 'a - 1 - 1' }]
	}, {
		value: '1 - 2',
		title: 'a - 2',
		list: [{ value: 'a - 2 - 1' }]
	}]
}, {
	value: '2',
	list: [{
		value: '2 - 1',
		list: [{ value: 'b - 1 - 1' }]
	}]
}];

var FlatListPage = function (_React$Component) {
	_inherits(FlatListPage, _React$Component);

	function FlatListPage() {
		_classCallCheck(this, FlatListPage);

		var _this = _possibleConstructorReturn(this, (FlatListPage.__proto__ || Object.getPrototypeOf(FlatListPage)).call(this));

		_this.getSampleCode = function () {
			return '';

			var form = _this.state.form;

			return ('\nconst $pin = (\n\t<div>\n\t\t<p>Hello World!~</p>\n\t\t<p>Hello World!~</p>\n\t\t<p>Hello World!~</p>\n\t</div>\n);\n\n<PinBox' + (0, _propsUtil.toString)(form, { trigger: 'click' }) + '>\n\t<Button>\n\t\t\u70B9\u51FB\u6B64\u6309\u94AE\u5C1D\u8BD5\u7C98\u9644\u6846\n\t</Button>\n</Button>\n').trim().replace(/\t/g, '   ');
		};

		_this.state = {
			form: {
				value: [],
				trigger: 'click',
				backdrop: false,
				stretch: false
			},

			list: FLAT_LIST
		};
		return _this;
	}

	_createClass(FlatListPage, [{
		key: 'render',
		value: function render() {
			var _state = this.state,
			    form = _state.form,
			    list = _state.list;


			return _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(
					'h1',
					null,
					'\u5E73\u7EA7\u5217\u8868'
				),
				_react2.default.createElement(
					'p',
					null,
					'\u63D0\u4F9B\u4E86\u5E73\u7EA7\u4E0B\u62C9\u529F\u80FD\u7684\u5217\u8868\u3002 \u60A8\u53EF\u4EE5\u901A\u8FC7css',
					_react2.default.createElement(
						'code',
						null,
						'.bmbo-flat-list > .bmbo-flat-list-column'
					),
					'\u6765\u8BBE\u7F6E\u5217\u7684\u6700\u5927\u9AD8\u5EA6\u3002'
				),
				_react2.default.createElement(
					'div',
					{ className: 'measurement' },
					_react2.default.createElement(
						'div',
						{ className: 'preview' },
						_react2.default.createElement(
							_components.Form,
							{ instance: this, path: 'form' },
							_react2.default.createElement(
								_components.Form.Field,
								{ name: 'value' },
								_react2.default.createElement(_components.FlatList, {
									list: list,
									columns: 3
								})
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'form' },
						_react2.default.createElement(
							_components.Form,
							{ instance: this, path: 'form' },
							'Value: ',
							JSON.stringify(form.value)
						)
					),
					_react2.default.createElement(
						'pre',
						{ className: 'code' },
						this.getSampleCode()
					)
				)
			);
		}
	}]);

	return FlatListPage;
}(_react2.default.Component);

exports.default = FlatListPage;

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _components = __webpack_require__(3);

var _objectUtil = __webpack_require__(19);

var _enum = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GroupPage = function (_React$Component) {
	_inherits(GroupPage, _React$Component);

	function GroupPage() {
		_classCallCheck(this, GroupPage);

		var _this = _possibleConstructorReturn(this, (GroupPage.__proto__ || Object.getPrototypeOf(GroupPage)).call(this));

		_this.state = {
			form: {
				hasIcon: false,
				type: '',
				size: 'md',
				value: ''
			}
		};
		return _this;
	}

	_createClass(GroupPage, [{
		key: 'render',
		value: function render() {
			var form = this.state.form;


			return _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(
					'h1',
					null,
					'\u8F93\u5165\u6846'
				),
				_react2.default.createElement(
					'p',
					null,
					'\u4F60\u53EF\u4EE5\u901A\u8FC7',
					_react2.default.createElement(
						'code',
						null,
						'<Input />'
					),
					'\u6765\u4F7F\u7528\u5C01\u88C5\u597D\u6837\u5F0F\u7684\u8F93\u5165\u6846\u3002'
				),
				_react2.default.createElement(
					'div',
					{ className: 'measurement' },
					_react2.default.createElement(
						'div',
						{ className: 'preview' },
						_react2.default.createElement(
							_components.Form,
							{ instance: this, path: 'form' },
							_react2.default.createElement(
								_components.Form.Field,
								{ name: 'value' },
								_react2.default.createElement(_components.Input, {
									icon: form.hasIcon ? 'search' : null,
									size: form.size,
									type: form.type
								})
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'form' },
						_react2.default.createElement(
							_components.Form,
							{ instance: this, path: 'form' },
							_react2.default.createElement(
								_components.Form.Field,
								{ name: 'size', title: 'Size' },
								_enum.SIZE_LIST.map(function (_ref) {
									var name = _ref.name,
									    displayName = _ref.displayName,
									    isDefault = _ref.isDefault;
									return _react2.default.createElement(
										_components.Radio,
										{ key: name, value: name },
										displayName,
										isDefault && ' (default)'
									);
								})
							),
							_react2.default.createElement(
								_components.Form.Field,
								{ name: 'type', title: 'Type' },
								_react2.default.createElement(
									_components.Radio,
									{ value: '' },
									'(default)'
								),
								_enum.TYPE_LIST.map(function (_ref2) {
									var name = _ref2.name;
									return _react2.default.createElement(
										_components.Radio,
										{ key: name, value: name },
										name
									);
								})
							),
							_react2.default.createElement(
								_components.Form.Field,
								{ name: 'hasIcon' },
								_react2.default.createElement(
									_components.Checkbox,
									null,
									'\u6DFB\u52A0\u56FE\u6807'
								)
							)
						)
					),
					_react2.default.createElement('pre', { className: 'code' })
				)
			);
		}
	}]);

	return GroupPage;
}(_react2.default.Component);

exports.default = GroupPage;

/***/ }),
/* 118 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 119 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 120 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// bundle.js